import React from 'react';
import { keyBy } from 'lodash';

export const ExitSurveyIconsCol = [
  {
    icon: 'bbk-esi-3d',
    name: '3d',
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 480.947 543.493"
        height="543.493"
        width="480.947"
      >
        <path
          d="M260.981 290.33v253.163L480.94 416.501v-253.16zM0 416.5L219.956 543.49V288.68L0 161.69zM240.472.005L21.234 126.573l220.662 127.391 219.235-126.561L240.472.005"
          fill="#231f20"
        />
      </svg>
    ),
    tags: ['box', '3d', 'dimensions'],
  },
  {
    icon: 'bbk-esi-add',
    name: 'Add',
    tags: ['plus', 'add', 'addition', 'math'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 442.76 442.773"
        height="442.773"
        width="442.76"
      >
        <path
          d="M442.765 165.984H276.781V.001H165.98v165.983H0v110.805h165.98v165.984h110.801V276.79h165.984V165.984"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-addressBook',
    name: 'Address Book',
    tags: ['address', 'notebook', 'planner'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 569.867 562.547"
        height="562.547"
        width="569.867"
      >
        <path
          d="M448.248 415.267h-289.29c-.245-12.388.643-34.724.643-44.178 4.804-13.92 20.703-15.918 33.984-21.521 14.58-6.145 30.756-13.288 45.307-19.252 4.155-1.13 8.307-2.267 12.456-3.403 4.96-3.408 9.815-14.746 12.465-20.384l5.892-1.428c-1.333-7.45-5.941-8.033-7.862-13.293-.755-7.93-1.508-15.861-2.268-23.785.036.37-5.422-.999-6.134-1.448-7.696-4.818-7.848-24.396-8.59-32.538-.336-3.72 4.837-6.772 3.4-13.59-8.432-39.955 3.645-58.648 22.738-64.846 13.252-5.373 37.995-15.332 61.074-1.133l5.729 5.305 9.267 1.6c4.652 2.682 7.62 11.584 7.62 11.584 2.441 9.835 2.684 10.652 2.457 20.751-.092 3.887-2.327 21.879-1.719 27.393.499 4.555 1.632 4.915 3.432 8.662 3.126 6.533 2.076 15.53.883 22.114-.66 3.602-2.044 8.726-4.155 11.662-2.321 3.237-6.969 3.266-9.028 7.049-2.962 5.437-1.29 13.076-3.16 18.956-2.118 6.664-7.521 7.133-7.928 15.852 2.648.377 5.29.757 7.928 1.133 2.654 5.638 7.507 16.976 12.466 20.384 4.149 1.136 8.306 2.272 12.458 3.403 14.548 5.964 30.722 13.107 45.31 19.252 13.277 5.603 29.178 7.601 33.977 21.521 0 9.454.89 31.79.648 44.178zM114.686.007v562.54h377.887V.007zM0 33.389V529.16c0 18.439 14.95 33.387 33.386 33.387h41.239V.007H33.386C14.95.007 0 14.949 0 33.389M569.861 128.879h-51.064V.007h51.064v128.872M569.861 291.63h-51.064V162.758h51.064v128.874M569.861 454.378h-51.064V325.507h51.064v128.871"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-alert-alt',
    name: 'Alert',
    tags: ['alert', 'danger', 'warning'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 584.04 503.947"
        height="503.947"
        width="584.04"
      >
        <path
          d="M263.243 172.535v68.704l15.262 126.393h27.398l14.896-126.393v-68.704zm1.288 270.117h54.982v-53.14h-54.982zM292.02 66.59l234.094 403.97H57.93zm0-66.59L0 503.947h584.044L292.021 0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-alert',
    name: 'Alert',
    tags: ['alert', 'danger', 'warning'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 584.053 503.947"
        height="503.947"
        width="584.053"
      >
        <path
          d="M306.207 358.43h-30.758L258.317 216.54v-77.127h64.611v77.127zm15.277 84.222h-61.72v-59.657h61.72zM292.027.002L0 503.946h584.048z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-alt',
    name: 'Alt',
    tags: ['keyboard', 'alt', 'modify', 'modifier', 'stroke'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 491.413 300.507"
        height="300.507"
        width="491.413"
      >
        <path
          d="M225.35 76.923V8.435h266.067v68.488H225.351M217.123 300.507L51.869 68.483H0V-.001h87.17L252.42 232.017h238.994V300.507H217.123"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-arrow-down',
    name: 'Arrow down',
    tags: ['direction', 'arrow', 'down'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 488.6 537"
        height="537"
        width="488.6"
      >
        <path
          d="M159.38-.003v241.006H0L244.299 537l244.298-295.997H329.213V-.003H159.38"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-arrow-left',
    name: 'Arrow left',
    tags: ['direction', 'arrow', 'left'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 537 488.6"
        height="488.6"
        width="537"
      >
        <path
          d="M537.001 159.384H295.997V.003L0 244.3 295.997 488.6V329.216h241.004V159.384"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-arrow-left-1',
    name: 'Arrow left 1',
    tags: ['direction', 'arrow', 'left'],
    svg: (
      <svg viewBox="0 0 26 26" width="100" height="100">
        <path
          fill="#231f20"
          d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zM11.157 7.422l-4.735 4.756a1.473 1.473 0 0 0 0 2.065l4.756 4.734c.27.271.667.417 1.022.417.354 0 .73-.125 1.021-.417a1.473 1.473 0 0 0 0-2.065l-2.273-2.252h7.592c.813 0 1.46-.647 1.46-1.46s-.647-1.46-1.46-1.46h-7.571l2.252-2.253a1.473 1.473 0 0 0 0-2.065 1.473 1.473 0 0 0-2.064 0z"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-arrow-right',
    name: 'Arrow right',
    tags: ['direction', 'arrow', 'right'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 537 488.6"
        height="488.6"
        width="537"
      >
        <path
          d="M0 329.22h241.005V488.6l295.996-244.299L241.005.003v159.384H0V329.22"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-arrow-up',
    name: 'Arrow up',
    tags: ['direction', 'arrow', 'up'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 488.6 537"
        height="537"
        width="488.6"
      >
        <path
          d="M329.219 537V295.996h159.38L244.299-.003 0 295.996h159.384V537h169.835"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-attachment',
    name: 'Attachment',
    tags: ['attachment', 'file', 'paper clip'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 567.08 516.64"
        height="516.64"
        width="567.08"
      >
        <path
          d="M113.284 516.64c-28.752.007-57.755-11.327-79.846-33.417C11.335 461.123-.006 432.108 0 403.36c-.039-27.061 10.164-54.34 30.713-74.853l4.717-4.719L318.841 40.361c26.97-27.006 62.776-40.405 98.47-40.356 37.938-.016 76.292 14.944 105.572 44.212 29.248 29.266 44.204 67.598 44.196 105.536.037 35.706-13.355 71.503-40.356 98.486L288.788 486.176l-17.705 17.703-35.415-35.41L491.32 212.823c17.123-17.161 25.639-39.61 25.679-63.07-.006-24.862-9.766-50.347-29.538-70.125-19.778-19.784-45.277-29.536-70.15-29.552-23.451.046-45.898 8.558-63.046 25.688L70.832 359.197l-4.715 4.716c-10.682 10.708-15.992 24.643-16.038 39.447.018 15.68 6.152 31.836 18.772 44.459 12.605 12.596 28.748 18.724 44.433 18.74 14.802-.044 28.735-5.351 39.45-16.034l200.549-200.54 16.794-16.793c4.024-4.053 6.03-9.208 6.066-15.107 0-6.221-2.423-12.761-7.63-17.968-5.218-5.221-11.758-7.634-17.973-7.652-5.9.051-11.044 2.056-15.104 6.086l-184.84 184.842-35.414-35.413 184.827-184.825c13.879-13.92 32.386-20.806 50.531-20.76 19.29-.016 38.68 7.605 53.399 22.318 14.674 14.7 22.292 34.072 22.292 53.372.04 18.131-6.839 36.639-20.744 50.519l-16.802 16.793L188.14 485.944c-20.486 20.503-47.691 30.7-74.696 30.696h-.159"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-badge-add',
    name: 'Badge add',
    tags: ['badge', 'add', 'plus'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 209.347 209.347"
        height="209.347"
        width="209.347"
      >
        <path
          d="M123.486 123.498v56.398H85.842v-56.398H29.447V85.844h56.395V29.449h37.644v56.395h56.409v37.654zM104.668.004C46.864.004 0 46.865 0 104.677c0 57.81 46.864 104.67 104.668 104.67 57.81 0 104.675-46.86 104.675-104.67C209.343 46.865 162.479.004 104.668.004"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-badge-count',
    name: 'Badge count',
    tags: ['badge', 'count', 'one'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 209.347 209.347"
        height="209.347"
        width="209.347"
      >
        <path
          d="M121.36 174.832H93.428v-95.66H60.807V60.616c8.586-.39 14.6-.96 18.033-1.724 5.473-1.21 9.926-3.63 13.36-7.27 2.355-2.489 4.136-5.8 5.344-9.947.7-2.486 1.048-4.336 1.048-5.547h22.767zM104.667.004C46.865.004 0 46.865 0 104.674c0 57.804 46.865 104.673 104.668 104.673 57.81 0 104.673-46.869 104.673-104.673 0-57.809-46.862-104.67-104.673-104.67"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-badge-remove',
    name: 'Badge remove',
    tags: ['badge', 'remove', 'minus'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 209.347 209.347"
        height="209.347"
        width="209.347"
      >
        <path
          d="M29.447 123.498V85.844h150.448v37.654zM104.669.004C46.864.004 0 46.865 0 104.677c0 57.81 46.864 104.67 104.669 104.67 57.81 0 104.672-46.86 104.672-104.67C209.341 46.865 162.48.004 104.67.004"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-badge-restricted',
    name: 'Badge restricted',
    tags: ['badge', 'restricted', 'warning', 'danger'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 209.347 209.347"
        height="209.347"
        width="209.347"
      >
        <path
          d="M104.869 175.272c-39.875 0-72.204-32.327-72.204-72.21 0-39.875 32.33-72.2 72.204-72.2 39.878 0 72.208 32.325 72.208 72.2 0 39.883-32.33 72.21-72.208 72.21zM104.67.005C46.867.005 0 46.865 0 104.678c0 57.81 46.867 104.669 104.67 104.669 57.811 0 104.673-46.86 104.673-104.669C209.343 46.865 162.48.005 104.67.005zM54.597 103.061c0 27.727 22.551 50.278 50.272 50.278 9.896 0 19.104-2.91 26.89-7.871L62.467 76.173c-4.955 7.787-7.87 16.995-7.87 26.888zm50.272-50.268c-9.894 0-19.105 2.914-26.894 7.871l69.298 69.288c4.955-7.787 7.868-16.992 7.868-26.89 0-27.717-22.553-50.269-50.272-50.269"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-bar-chart-1',
    name: 'Bar chart',
    tags: ['bar', 'chart', 'graph'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 471.373 506.48"
        height="506.48"
        width="471.373"
      >
        <path
          d="M0 506.476h110.808V166.932H0zm180.285.004h110.803V.007H180.285zm180.282-172.623V506.48h110.801V333.857H360.567"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-bar-chart-2',
    name: 'Bar chart',
    tags: ['bar', 'chart', 'graph'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 586.28 483.76"
        height="483.76"
        width="586.28"
      >
        <path
          d="M316.981 483.757v-325.27h110.8v325.27h-110.8M475.468 483.757V-.003h110.808v483.76H475.468M158.487 483.76V316.977H269.29V483.76H158.487M0 483.757V447.11h110.802v36.648H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-battery-full',
    name: 'Battery full',
    tags: ['battery', 'full', 'meter'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 579.8 330.52"
        height="330.52"
        width="579.8"
      >
        <path
          d="M523.195 255.273c31.262 0 56.609-25.349 56.609-56.606v-65.47c0-31.261-25.347-56.608-56.61-56.608v178.684M404.301 73.652H72.411v183.224h331.89zm33.384 216.608H39.027V40.267h398.658zM0 .005V330.52h476.716V.005H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-battery-low',
    name: 'Battery low',
    tags: ['battery', 'low', 'empty', 'meter'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 579.8 330.52"
        height="330.52"
        width="579.8"
      >
        <path
          d="M523.193 255.273c31.264 0 56.611-25.349 56.611-56.606v-65.47c0-31.261-25.347-56.608-56.61-56.608v178.684M120.095 73.652H72.411v183.224h47.684zm317.59 216.608H39.025V40.267h398.66zM0 .005V330.52h476.716V.005H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-bell-off',
    name: 'Bell off',
    tags: ['bell', 'notifications', 'off', 'quiet'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 569.027 569.013"
        height="569.013"
        width="569.027"
      >
        <path
          d="M284.517 474.147c-60.669.024-115.662-5.583-153.866-14.163-15.374-3.396-28.052-7.415-36.63-11.13a82.708 82.708 0 0 1 6.004-2.371c16.81-6.299 43.255-12.282 75.104-16.362 21.25-2.745 45.01-4.712 70.318-5.726 3.917 17.98 19.912 31.454 39.07 31.454s35.152-13.476 39.064-31.468c8.875.359 17.547.835 25.992 1.427l-217.07-217.08c-5.354 14.503-8.274 28.69-8.274 41.51 0 53.14 25.252 95.066-29.597 145.049-11.033 3.392-20.873 7.216-29.513 11.736-7.353 3.946-14.012 8.337-19.92 14.726-5.788 6.187-11.194 15.748-11.168 27.115-.026 11.384 5.38 20.944 11.168 27.13 10.396 10.957 22.81 16.84 37.911 22.605 22.6 8.283 51.722 14.484 86.027 18.925 34.259 4.412 73.536 6.888 115.38 6.888 57.295-.016 109.623-4.612 151.114-12.556l-43.975-43.968c-31.408 3.957-68.048 6.264-107.139 6.259zm249.378-16.49c.685-2.785 1.102-5.708 1.094-8.793.035-11.367-5.38-20.928-11.161-27.115-10.401-10.966-22.801-16.842-37.91-22.609-.835-.308-1.74-.59-2.59-.89-60.581-52.415-32.16-94.423-32.16-148.011 0-53.112-52.933-134.064-124.287-157.115.255-1.883.428-3.784.428-5.736 0-23.639-19.156-42.799-42.792-42.799-23.637 0-42.801 19.16-42.801 42.799 0 2.637.272 5.212.73 7.717-16.287 5.995-31.52 14.956-45.291 25.806zM29.02-.005L0 29.013l539.999 540 29.022-29.02-540-539.998"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-bell',
    name: 'Bell',
    tags: ['bell', 'notifications', 'on', 'loud', 'sound'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500.96 479.827"
        height="479.827"
        width="500.96"
      >
        <path
          d="M434.968 406.672c-16.808 6.295-43.252 12.272-75.093 16.36-31.896 4.128-69.378 6.53-109.388 6.526-60.667.027-115.662-5.582-153.862-14.16-15.376-3.403-28.054-7.417-36.632-11.129a82.259 82.259 0 0 1 6.004-2.376c16.81-6.292 43.255-12.278 75.102-16.362 21.25-2.744 45.012-4.703 70.318-5.726 3.92 17.984 19.912 31.455 39.07 31.455 19.161 0 35.156-13.476 39.068-31.468 44.952 1.817 84.992 6.687 114.788 13.375 15.365 3.398 28.052 7.416 36.629 11.128a86.955 86.955 0 0 1-6.004 2.377zm54.828-29.517c-10.397-10.962-22.801-16.84-37.91-22.603-.835-.302-1.735-.588-2.587-.888-60.58-52.42-32.16-94.424-32.16-148.015 0-53.112-52.931-134.062-124.286-157.113.251-1.884.427-3.787.427-5.736 0-23.636-19.156-42.799-42.793-42.799-23.636 0-42.799 19.163-42.799 42.799 0 2.637.275 5.213.732 7.719-68.263 25.117-118.222 101.9-118.222 155.13 0 53.146 25.26 95.067-29.595 145.051-11.03 3.39-20.873 7.215-29.51 11.737-7.358 3.94-14.014 8.337-19.923 14.718C5.384 383.348-.021 392.907 0 404.28c-.021 11.379 5.384 20.938 11.17 27.124 10.397 10.962 22.809 16.84 37.91 22.603 22.604 8.284 51.723 14.49 86.025 18.93 34.262 4.403 73.538 6.889 115.382 6.889 63.79-.024 121.464-5.702 164.825-15.369 21.755-4.914 39.856-10.625 54.557-18.337 7.362-3.939 14.018-8.326 19.927-14.716 5.79-6.186 11.201-15.745 11.168-27.124.033-11.374-5.379-20.933-11.168-27.126"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-block',
    name: 'Block',
    tags: ['off', 'block', 'warning', 'danger', 'stop'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 580.907 580.907"
        height="580.907"
        width="580.907"
      >
        <path
          d="M88.23 290.456c0-39.812 11.614-76.943 31.56-108.272l278.935 278.935c-31.33 19.946-68.461 31.561-108.274 31.561-111.51 0-202.22-90.72-202.22-202.224zm404.443 0c0 39.815-11.614 76.944-31.561 108.279l-278.939-278.94c31.332-19.948 68.46-31.56 108.278-31.56 111.505 0 202.222 90.714 202.222 202.221zM290.451.006C130.04.005 0 130.045 0 290.455c0 160.412 130.04 290.45 290.45 290.45 160.413 0 290.451-130.038 290.451-290.45 0-160.41-130.038-290.45-290.45-290.45"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-bluetooth',
    name: 'Bluetooth',
    tags: ['bluetooth', 'phone', 'connection'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 297.253 564.053"
        height="564.053"
        width="297.253"
      >
        <path
          d="M229.38 393.803l-54.237 54.232.045-108.428zm0-223.72l-54.192 54.197-.045-108.43zm67.879-.226L127.4.005v223.918l-93.423-93.428L0 164.476l117.245 117.55L0 399.587l33.978 33.977 93.423-93.436v223.926L297.26 394.2 185.088 282.027l112.17-112.17"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-book-3',
    name: 'Book',
    tags: ['book', 'read', 'magazine'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 594.693 465.827"
        height="465.827"
        width="594.693"
      >
        <path
          d="M346.86 275.893l17.843 23.426 2.29 3.206c.022-.017.058-.038.099-.065 2.017-1.363 25.483-17.243 71.852-17.27 25.307 0 44.095 4.743 56.403 9.3 6.149 2.274 10.669 4.5 13.529 6.08a56.608 56.608 0 0 1 3.035 1.778c.28.181.466.312.554.37a.05.05 0 0 0 .023.014l.037.03 5.398-7.665 14.118-19.422c-1.969-1.48-33.965-23.895-93.097-23.876-59.141-.03-90.028 22.464-92.084 24.094zm20.133-45.564c1.104-.737 24.568-17.312 71.955-17.341 25.303.013 44.097 4.76 56.399 9.308 6.157 2.264 10.678 4.51 13.533 6.081a57.295 57.295 0 0 1 3.027 1.775c.253.159.426.281.526.347.047.036.079.062.087.062l5.312-7.528 14.208-19.545v-.013c-1.968-1.475-33.96-23.89-93.092-23.868-59.143-.042-90.036 22.472-92.088 24.096l20.235 26.552-2.439-3.191zm-2.337-75.461l2.34 3.267.001.004c1.095-.738 24.57-17.315 71.951-17.343 25.303 0 44.097 4.75 56.403 9.299 6.146 2.273 10.666 4.513 13.525 6.078a60.75 60.75 0 0 1 3.032 1.792c.232.135.397.252.503.32l19.629-27.001c-1.973-1.47-33.96-23.89-93.092-23.879-59.143-.032-90.035 22.474-92.092 24.108l20.236 26.548zm147.864 3.504l5.53-7.845-5.64 7.758-.002.006c.064.048.104.073.112.081zM69.37 275.893l18.465 24.239-.663-.86 2.333 3.253.103-.065c2.012-1.363 25.48-17.243 71.848-17.27 25.307 0 44.097 4.743 56.404 9.3 6.148 2.274 10.668 4.5 13.53 6.08a55.704 55.704 0 0 1 3.031 1.778c.283.181.468.312.56.37.007.009.015.011.022.014l.033.03 5.401-7.665 14.119-19.422c-1.981-1.48-33.968-23.895-93.1-23.876-59.14-.03-90.029 22.464-92.085 24.094zm20.137-45.564c1.097-.737 24.568-17.312 71.945-17.341 25.307.013 44.104 4.76 56.41 9.308 6.145 2.264 10.666 4.51 13.522 6.081a53.105 53.105 0 0 1 3.035 1.775c.293.19.484.32.568.38a.23.23 0 0 0 .046.03l5.235-7.43 14.285-19.644v-.013c-1.977-1.475-33.969-23.89-93.101-23.868-59.132-.042-90.027 22.472-92.08 24.096l20.237 26.552-2.45-3.204zm-20.134-98.816l17.81 23.363 2.322 3.263c1.105-.738 24.57-17.315 71.948-17.343 25.308 0 44.098 4.75 56.407 9.299 6.153 2.273 10.675 4.513 13.525 6.078a63.148 63.148 0 0 1 3.039 1.792c.281.174.465.302.557.363.007.01.015.013.022.019l.033.025 5.347-7.592 14.173-19.496c-1.973-1.47-33.97-23.89-93.103-23.879-59.13-.032-90.033 22.474-92.08 24.108zm481.918 253.99c-25.76-22.723-65.308-46.094-117.218-46.094-51.046-.016-89.733 22.676-115.022 45.124V110.704c4.409-6.75 14.182-20.284 28.893-33.224 20.215-17.744 48.43-34.059 86.13-34.075 38.897 0 68.471 17.484 89.337 35.958 10.33 9.192 18.236 18.502 23.429 25.381a146 146 0 0 1 4.45 6.187zm-275.644.025c-25.759-22.73-65.292-46.119-117.22-46.119h-.062c-50.997 0-89.695 22.665-114.967 45.092v-273.8c4.412-6.757 14.201-20.301 28.89-33.221 20.225-17.744 48.441-34.059 86.139-34.075 38.898 0 68.474 17.484 89.325 35.958a177.84 177.84 0 0 1 23.441 25.381c1.828 2.416 3.3 4.51 4.454 6.205zM591.825 93.832c-.777-1.292-13.67-23.796-39.572-46.89C526.52 23.961 486.632-.004 434.073-.004c-52.56-.016-92.056 24.04-117.274 47.119a216.606 216.606 0 0 0-19.758 20.607 224.862 224.862 0 0 0-20.434-20.782C250.873 23.963 210.985-.003 158.427-.003c-52.558-.016-92.064 24.04-117.275 47.119C15.763 70.306 3.414 92.873 2.653 94.215L0 104.61v339.406L40.664 454.4l.07.042c.57-1.086 11.49-19.906 31.553-37.552 20.226-17.729 48.442-34.045 86.14-34.073 38.898 0 68.474 17.493 89.325 35.956 10.344 9.204 18.248 18.503 23.441 25.385a139.589 139.589 0 0 1 5.746 8.144c.522.796.89 1.386 1.161 1.823 3.617 6.95 10.87 11.703 19.243 11.703 8.529 0 15.888-4.933 19.434-12.083 2.128-3.628 12.81-20.71 31.167-36.855 20.215-17.729 48.43-34.045 86.13-34.073 38.897 0 68.471 17.493 89.337 35.956 10.33 9.204 18.236 18.503 23.429 25.385a138.072 138.072 0 0 1 5.755 8.144c.606.935 1.046 1.654 1.313 2.081.132.218.216.357.257.435l.058-.03 40.476-10.77V104.611l-2.874-10.779"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-book-2',
    name: 'Book',
    tags: ['book', 'read', 'magazine'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 594.707 465.733"
        height="465.733"
        width="594.707"
      >
        <path
          d="M551.305 385.505c-25.766-22.72-65.321-46.093-117.226-46.093-51.056-.024-89.743 22.674-115.035 45.13v-273.82c4.407-6.743 14.185-20.289 28.897-33.238 20.226-17.745 48.436-34.052 86.138-34.077 38.902 0 68.48 17.496 89.336 35.965 10.336 9.187 18.234 18.5 23.434 25.373a148.253 148.253 0 0 1 4.456 6.202zm-392.87-46.093h-.083c-50.994 0-89.677 22.661-114.95 45.092V110.71c4.413-6.757 14.205-20.304 28.892-33.225 20.225-17.745 48.433-34.052 86.14-34.077 38.889 0 68.473 17.496 89.329 35.965 10.328 9.187 18.245 18.5 23.437 25.373 1.828 2.42 3.305 4.51 4.45 6.207v274.577c-25.76-22.726-65.3-46.117-117.215-46.117zM591.832 93.824c-.777-1.281-13.676-23.777-39.567-46.872C526.527 23.967 486.632-.003 434.08.005 381.513-.02 342.016 24.036 316.8 47.111a217.163 217.163 0 0 0-19.753 20.612 223.83 223.83 0 0 0-20.433-20.771C250.879 23.967 210.98-.003 158.435.005 105.865-.02 66.37 24.036 41.153 47.111 15.764 70.312 3.419 92.873 2.655 94.215L0 104.609v339.413l40.654 10.374.088.052c.564-1.09 11.495-19.903 31.552-37.556 20.225-17.73 48.433-34.05 86.14-34.076 38.889.008 68.473 17.494 89.329 35.967 10.328 9.192 18.245 18.507 23.437 25.374a147.09 147.09 0 0 1 5.752 8.147 72.77 72.77 0 0 1 1.57 2.501l.009.007.008-.002c3.744 6.517 10.756 10.923 18.818 10.923 8.207 0 15.342-4.561 19.028-11.285h.003s.03-.052.033-.065l.011-.018c.823-1.505 11.705-20.04 31.51-37.473 20.225-17.73 48.435-34.05 86.137-34.076 38.902.008 68.48 17.494 89.336 35.967 10.336 9.192 18.234 18.507 23.434 25.374a148.21 148.21 0 0 1 5.75 8.147 67.098 67.098 0 0 1 1.313 2.081c.121.207.217.35.256.42l.005.007.039-.015 40.493-10.775V104.61l-2.873-10.785"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-book-1',
    name: 'Book',
    tags: ['book', 'read', 'magazine'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 474.32 579.587"
        height="579.587"
        width="474.32"
      >
        <path
          d="M437.895 478.072l-30.206 1.404V104.79L72.372 78.705h-.765c-11.634.048-21.912-3.129-28.036-7.066-3.07-1.923-5.058-3.971-6.035-5.454-.985-1.532-1.093-2.282-1.117-3.002.024-.719.132-1.466 1.117-2.999 1.423-2.235 5.303-5.675 11.365-8.228 6.02-2.58 13.982-4.303 22.706-4.295h.168l366.12-10.214zM332.619 244.7L91.36 225.373l3.271-40.904 241.26 19.322zm-61.968 97.784l-139.237-10.823 3.178-40.912 139.237 10.83zM71.32 11.244c-17.75.096-34.054 4.461-47.192 12.69-6.588 4.174-12.434 9.4-16.85 15.989C2.858 46.464-.021 54.592 0 63.183v438.27c-.02 8.596 2.858 16.727 7.279 23.264 6.674 9.866 16.346 16.727 27.318 21.454 10.801 4.594 23.083 7.108 36.163 7.218l336.93 26.198v-63.65l66.633-3.102V.005L71.32 11.244"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-bookmark',
    name: 'Bookmark',
    tags: ['bookmark', 'tag', 'flag', 'save'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 241.76 477.44"
        height="477.44"
        width="241.76"
      >
        <path
          d="M241.763 477.44l-120.88-120.881L0 477.44V-.004h241.763V477.44"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-box',
    name: 'Box',
    tags: ['box', 'crate', 'container'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 480.947 543.48"
        height="543.48"
        width="480.947"
      >
        <path
          d="M0 416.496l219.945 126.979V288.668L0 161.693zm260.985-126.18V543.48L480.94 416.496V163.335zm200.147-162.919L240.471-.005 155.699 48.94l220.665 127.39zM114.664 72.628l-93.431 53.936 220.664 127.393 93.435-53.937L114.664 72.628"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-brush',
    name: 'Brush',
    tags: ['brush', 'paint'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 551.507 562.173"
        height="562.173"
        width="551.507"
      >
        <path
          d="M276.393 348.67l28.267-44.62 40.564 25.7-28.267 44.625zM551.5 59.29l-45.975-29.122L457.908-.007l-218.999 350.02c-30.517-3.944-62.21 8.462-79.742 52.062C119.907 517.072 0 513.524 0 513.524s171.412 109.261 294.301.299c25.62-22.715 35.855-56.41 29.482-87.631L551.5 59.289"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-bug',
    name: 'Bug',
    tags: ['bug', 'problem', 'insect'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 528.693 534.787"
        height="534.787"
        width="528.693"
      >
        <path
          d="M360.639 382.339c-20.476 0-37.075-11.408-37.075-25.484 0-14.075 16.599-25.49 37.075-25.49 20.474 0 37.072 11.415 37.072 25.49 0 14.076-16.598 25.484-37.072 25.484zm-35.279 84.688c-9.547 0-17.285-11.728-17.285-26.192 0-14.467 7.738-26.199 17.285-26.199s17.284 11.732 17.284 26.199c0 14.464-7.737 26.192-17.284 26.192zm-4.51-220.683c14.48-14.476 34.282-18.139 44.234-8.187 9.959 9.95 6.288 29.763-8.187 44.235-14.481 14.48-34.284 18.145-44.24 8.195-9.953-9.956-6.284-29.763 8.194-44.243zm13.886-62.393h-50.36v350.836c75.23-10.276 133.945-89.114 133.945-184.571 0-72.728-34.088-135.79-83.585-166.265zM221.851 290.587c-9.956 9.95-29.76 6.285-44.236-8.195-14.476-14.472-18.147-34.285-8.192-44.235 9.953-9.952 29.757-6.289 44.234 8.187 14.476 14.48 18.148 34.287 8.194 44.243zm-12.7 176.44c-9.55 0-17.288-11.728-17.288-26.192 0-14.467 7.738-26.199 17.288-26.199 9.544 0 17.286 11.732 17.286 26.199 0 14.464-7.742 26.192-17.286 26.192zM136.8 356.855c0-14.075 16.596-25.49 37.072-25.49 20.473 0 37.07 11.415 37.07 25.49 0 14.076-16.597 25.484-37.07 25.484-20.476 0-37.072-11.408-37.072-25.484zm-19.753-6.639c0 95.457 58.708 174.295 133.938 184.57V183.952h-50.36c-49.489 30.476-83.578 93.537-83.578 166.265zm24.338-330.919c36.42.266 52.911 13.774 62.584 28.834 7.952 12.656 10.208 27.353 10.715 36.096-20.3 13.922-34.865 35.586-39.415 60.764H360.1c-4.55-25.183-19.117-46.847-39.419-60.77.502-8.745 2.762-23.444 10.72-36.09 9.662-15.06 26.152-28.566 62.59-28.834 5.324 0 9.644-4.317 9.644-9.641 0-5.33-4.32-9.648-9.644-9.648-41.55-.27-66.6 17.561-78.979 37.933-7.93 12.838-11.308 26.123-12.733 36.472a93.812 93.812 0 0 0-34.584-6.641 93.879 93.879 0 0 0-34.614 6.648c-1.426-10.348-4.802-23.633-12.732-36.479C207.967 17.568 182.924-.26 141.385.008a9.641 9.641 0 0 0-9.65 9.645 9.64 9.64 0 0 0 9.65 9.644zM506.48 328.388l-56.727.003c.664 7.55 1.011 15.209 1.011 22.966 0 7.243-.312 14.4-.888 21.463h56.604c12.27 0 22.216-9.948 22.216-22.219 0-12.269-9.945-22.21-22.216-22.213zm-68.928 104.49c-5.176 15.36-11.75 29.85-19.568 43.263l41.036 41.031c8.673 8.681 22.74 8.681 31.412-.003 8.676-8.674 8.676-22.734 0-31.413zM93.586 277.07c4.755-15.71 10.994-30.559 18.48-44.366l-42.381-42.381c-8.68-8.672-22.748-8.672-31.42 0-8.679 8.68-8.679 22.748 0 31.416zm-10.867 74.286c0-7.757.35-15.416 1.012-22.966l-61.515-.003C9.944 328.391 0 338.332 0 350.601c0 12.271 9.944 22.219 22.216 22.219H83.61a262.985 262.985 0 0 1-.891-21.463zM490.428 221.74c8.68-8.668 8.68-22.736 0-31.416-8.67-8.672-22.739-8.672-31.416 0l-39.268 39.27c7.653 13.61 14.035 28.307 19.001 43.838zM38.263 485.756c-8.677 8.679-8.677 22.739 0 31.413 8.672 8.684 22.74 8.684 31.412.003l44.065-44.056c-7.65-13.613-14.035-28.308-19-43.836l-56.477 56.476"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-bulleted-list',
    name: 'Bulleted List',
    tags: ['bullet', 'editor', 'list'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 542.187 461.8"
        height="461.8"
        width="542.187"
      >
        <path
          d="M184.508 112.461V1.656h357.677v110.805H184.508M184.508 287.127V176.329h357.679v110.798H184.508M184.508 461.8V351h357.681v110.8H184.508M116.022 58.001c0 32.044-25.974 58.011-58.012 58.011C25.973 116.012 0 90.045 0 58.002 0 25.961 25.973-.005 58.01-.005c32.038 0 58.012 25.967 58.012 58.005M116.022 224.827c0 32.037-25.974 58.01-58.012 58.01-32.037 0-58.01-25.973-58.01-58.01 0-32.036 25.973-58.011 58.01-58.011 32.038 0 58.012 25.975 58.012 58.01M116.022 403.357c0 32.038-25.974 58.011-58.012 58.011-32.037 0-58.01-25.973-58.01-58.01 0-32.04 25.973-58.01 58.01-58.01 32.038 0 58.012 25.97 58.012 58.01"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-burn',
    name: 'Burn',
    tags: ['radioactive', 'warning', 'danger'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 557.12 557.12"
        height="557.12"
        width="557.12"
      >
        <path
          d="M444.84 444.836c-12.17 12.163-25.684 22.937-40.243 32.203L281.28 280.53 158.537 480.77a236.519 236.519 0 0 1-46.253-35.935c-42.176-42.2-68.313-100.144-68.827-164.407H281.13L167.164 71.413c33.144-17.864 71.043-28.01 111.392-28.014 42.377.004 82.021 11.23 116.317 30.804L281.388 280.429h232.277c-.512 64.263-26.648 122.207-68.825 164.407zM278.556-.003C124.713.007.02 124.711 0 278.557.02 432.411 124.713 557.101 278.556 557.12c153.855-.019 278.55-124.71 278.568-278.563C557.105 124.711 432.411.007 278.556-.003"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-calendar-1',
    name: 'Calendar',
    tags: ['calendar', 'date', 'month', 'day', 'agenda'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.227 576.56"
        height="576.56"
        width="582.227"
      >
        <path
          d="M529.048 523.382H53.172V192.151h475.876zm-53.35-477.015v26.257c10.323 9.125 16.86 22.43 16.86 37.285 0 27.523-22.311 49.83-49.827 49.83-27.519 0-49.823-22.307-49.823-49.83 0-14.854 6.54-28.16 16.855-37.285V46.367h-232.8v26.257c10.317 9.125 16.856 22.43 16.856 37.285 0 27.523-22.308 49.83-49.828 49.83-27.517 0-49.82-22.307-49.82-49.83 0-14.854 6.537-28.16 16.851-37.285V46.367H0V576.56h582.225V46.367zm-32.965 92.577c13.695 0 24.802-11.103 24.802-24.803V24.807c0-13.695-11.107-24.803-24.802-24.803-13.701 0-24.8 11.108-24.8 24.803v89.334c0 13.7 11.099 24.803 24.8 24.803zm-298.74 0c13.696 0 24.804-11.103 24.804-24.803V24.807c0-13.695-11.108-24.803-24.804-24.803-13.7 0-24.801 11.108-24.801 24.803v89.334c0 13.7 11.1 24.803 24.801 24.803zm174.58 257.704L377.8 294.452v102.196zm59.226 87.548h45.654v-51.053h26.836v-36.495h-26.836v-148.25h-52.366l-87.219 144v40.745h93.93zm-210.115 0h47.781V246.923h-38.941c0 2.072-.601 5.236-1.796 9.492-2.065 7.094-5.119 12.764-9.139 17.016-5.877 6.217-13.498 10.366-22.854 12.437-5.876 1.312-16.158 2.292-30.85 2.948v31.744h55.799v163.636"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-calendar-2',
    name: 'Calendar',
    tags: ['calendar', 'date', 'month', 'day', 'agenda'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.227 576.56"
        height="576.56"
        width="582.227"
      >
        <path
          d="M442.735 138.944c13.696 0 24.8-11.101 24.8-24.799v-89.34c0-13.689-11.104-24.8-24.8-24.8-13.7 0-24.806 11.111-24.806 24.8v89.34c0 13.698 11.106 24.799 24.806 24.799zm-298.739 0c13.697 0 24.803-11.101 24.803-24.799v-89.34c0-13.689-11.106-24.8-24.803-24.8-13.7 0-24.803 11.111-24.803 24.8v89.34c0 13.698 11.104 24.799 24.803 24.799zm94.324 198.335h-59.841v59.812h59.841zm84.225 80.049h-59.797v59.82h59.797zm-84.225 0h-59.841v59.82h59.841zm0-160.093h-59.841v59.802h59.841zM529.05 523.38H53.176V192.15H529.05zM475.7 46.37v26.254c10.318 9.13 16.856 22.433 16.856 37.292 0 27.51-22.309 49.823-49.825 49.823-27.523 0-49.823-22.312-49.823-49.823 0-14.864 6.538-28.165 16.856-37.292V46.369H176.963v26.255c10.318 9.13 16.856 22.433 16.856 37.292 0 27.51-22.31 49.823-49.826 49.823-27.519 0-49.823-22.312-49.823-49.823 0-14.864 6.54-28.165 16.857-37.292V46.369H0V576.56h582.224V46.37zM154.02 337.278H94.21v59.812h59.809zm0 80.049H94.21v59.82h59.809zm337.07-80.05h-59.805v59.813h59.805zm-84.232-80.043H347.02v59.802h59.838zm-84.312 80.044h-59.797v59.812h59.797zm168.544-80.044h-59.805v59.802h59.805zm-84.232 80.044H347.02v59.812h59.838zm-84.312-80.044h-59.797v59.802h59.797zm84.312 160.093H347.02v59.82h59.838v-59.82"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-camcorder',
    name: 'Camcorder',
    tags: ['record', 'video', 'tape'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 581.227 284.16"
        height="284.16"
        width="581.227"
      >
        <path
          d="M0 3.952v216.005h48.76l53.16-34.321V38.276L48.76 3.952zm510.59 47.477V35.836C510.59 16.044 494.55 0 474.758 0H171.135c-19.794 0-35.836 16.044-35.836 35.836v212.492c0 19.79 16.042 35.832 35.836 35.832h303.622c19.792 0 35.834-16.043 35.834-35.832V100.145l70.64 45.615V5.81l-70.64 45.62"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-caps-lock',
    name: 'Caps lock',
    tags: ['caps', 'keys', 'modifer'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 488.6 539.733"
        height="539.733"
        width="488.6"
      >
        <path
          d="M244.297 49.01L76.653 229.22h67.131v105.596h201.019V229.22h67.14L244.297 49.01zm0-49.017l244.299 262.614h-110.41v105.592H110.402V262.607H0L244.297-.007M344.803 450.17H143.787v56.178h201.016V450.17zm33.384-33.385v122.948H110.4V416.785h267.786"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-chart',
    name: 'Chart',
    tags: ['line graph', 'arrow graph', 'graph'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 568.893 568.907"
        height="568.907"
        width="568.893"
      >
        <path
          d="M41.032 527.876v-.52h-1.391V.003H0v568.904h568.9v-41.031zm138.43-159.69c12.81 0 24.405-5.19 32.806-13.58l133.37 49.695c2.349 23.436 22.129 41.735 46.177 41.735 25.638 0 46.42-20.788 46.42-46.423 0-6.27-1.259-12.244-3.512-17.698l78.185-88.83 30.183 23.284 14.574-111.589-104.241 42.412 26.928 20.779-76.465 86.866c-3.858-1.037-7.887-1.64-12.072-1.64-12.323 0-23.492 4.834-31.802 12.67l-134.572-50.142c-2.966-22.777-22.392-40.376-45.98-40.376-25.633 0-46.414 20.78-46.414 46.416 0 1.282.084 2.543.191 3.795l-60.21 37.052v48.192l81.316-50.037c7.245 4.676 15.853 7.42 25.117 7.42zm0-166.594c9.775 0 18.84-3.036 26.315-8.199l74.883 44.823c-.1 1.243-.187 2.485-.187 3.757 0 25.635 20.784 46.416 46.42 46.416 25.635 0 46.416-20.781 46.416-46.416 0-5.802-1.114-11.325-3.052-16.448l86.842-93.182 51.006 44.097L538.94 12.235l-158.034 54.24 45.127 39.012-85.772 92.042a46.348 46.348 0 0 0-13.367-1.974c-9.281 0-17.908 2.753-25.162 7.446l-75.968-45.473c.04-.787.117-1.557.117-2.353 0-25.635-20.78-46.415-46.419-46.415-25.633 0-46.414 20.78-46.414 46.415 0 4.438.661 8.714 1.821 12.776l-61.84 56.833v55.735l89.43-82.183c5.273 2.079 10.993 3.256 17.003 3.256"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-chat-active',
    name: 'Chat active',
    tags: ['chat', 'message', 'talk', 'text'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.173 500.947"
        height="500.947"
        width="582.173"
      >
        <path
          d="M405.685 263.09c-19.805 0-35.857-16.055-35.857-35.854 0-19.801 16.052-35.857 35.857-35.857 19.802 0 35.854 16.056 35.854 35.857 0 19.799-16.052 35.853-35.854 35.853zm-119.517 0c-19.804 0-35.855-16.055-35.855-35.854 0-19.801 16.051-35.857 35.855-35.857s35.856 16.056 35.856 35.857c0 19.799-16.052 35.853-35.856 35.853zm-119.517 0c-19.803 0-35.854-16.055-35.854-35.854 0-19.801 16.051-35.857 35.854-35.857 19.802 0 35.857 16.056 35.857 35.857 0 19.799-16.055 35.853-35.857 35.853zM295.563.07C134.817-3.102 2.503 95.954.035 221.304c-.859 43.58 14.1 84.6 40.722 119.707h-.009c45.784 58.819-4.185 159.935-4.185 159.935l147.533-63.538c31.785 10.044 66.324 15.893 102.52 16.608 160.744 3.167 293.059-95.882 295.525-221.238C584.615 107.424 456.307 3.239 295.563.069"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-chat',
    name: 'Chat',
    tags: ['chat', 'message', 'talk', 'text'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.173 500.96"
        height="500.96"
        width="582.173"
      >
        <path
          d="M295.563.076C134.817-3.087 2.503 95.963.035 221.316c-.858 43.58 14.1 84.59 40.722 119.703h-.005c45.783 58.822-4.187 159.941-4.187 159.941l147.532-63.54c31.784 10.044 66.324 15.895 102.518 16.608 160.746 3.168 293.06-95.887 295.529-221.239C584.614 107.433 456.307 3.245 295.563.076"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-check',
    name: 'Check',
    tags: ['check', 'complete', 'finish', 'done'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 581.2 501.52"
        height="501.52"
        width="581.2"
      >
        <path
          d="M566.23.005C389.43 108.401 261.142 245.165 203.5 313.8L62.335 203.2 0 253.455 243.921 501.52c41.98-107.53 174.931-317.685 337.274-467.004L566.23.006"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-checkbox-dotted-active',
    name: 'Checkbox',
    tags: ['check', 'complete', 'finish', 'done', 'checkbox'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 569.667 532.067"
        height="532.067"
        width="569.667"
      >
        <path
          d="M289.932 532.067h68.317v-33.388h-68.317zm-89.18 0h68.303v-33.388h-68.303zm-.003-435.486h68.31V63.2h-68.31zm-91.067 0h68.313V63.2h-68.313zm326.755 166.427v68.305h33.383v-68.305zm-52.564 234.581v33.397c46.956-.014 84.986-38.055 84.992-85.006h-33.378c-.059 28.51-23.112 51.56-51.614 51.61zm52.57-75.194h33.377v-68.31h-33.377zM109.68 532.067h68.315v-33.388H109.68zM358.243 91.7V63.2H289.94v33.381h62.632c1.88-1.624 3.765-3.252 5.67-4.881zm111.574 112.293a1668.434 1668.434 0 0 0-29.61 38.136h29.61zM33.394 173.816H0v68.313h33.394zm-.01 180.27H.005v68.309h33.38zM0 148.205h33.394c.045-28.509 23.113-51.58 51.61-51.625V63.203C38.05 63.207.008 101.248 0 148.207zm33.385 114.802H0v68.305h33.385zm.001 182.972H.006C.014 492.93 38.052 530.967 85 530.986v-33.393c-28.493-.045-51.565-23.116-51.614-51.613"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-checkbox-dotted',
    name: 'Checkbox',
    tags: ['check', 'complete', 'finish', 'done', 'checkbox'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 469.827 468.88"
        height="468.88"
        width="469.827"
      >
        <path
          d="M.003 85.008C.01 38.055 38.055.011 85.003.003V33.39C56.5 33.437 33.439 56.5 33.386 85.008h.009H.003M.003 178.937V110.63h33.382v68.308H.003M0 268.123v-68.311h33.386v68.31H0M.005 359.197v-68.306h33.38v68.306H.005M436.439 178.937V110.63h33.386v68.308H436.44M436.439 268.123v-68.311h33.384v68.31h-33.384M436.443 359.197v-68.306h33.377v68.306h-33.377M289.933 468.88v-33.393h68.31v33.393h-68.31M200.75 468.88v-33.393h68.309v33.393h-68.31M109.683 468.88v-33.393h68.312v33.393h-68.312M289.933 33.383V0h68.315v33.383h-68.315M200.75 33.383V0h68.306v33.383h-68.307M109.677 33.383V0h68.314v33.383h-68.314M0 382.79h33.39c.048 28.493 23.117 51.56 51.614 51.607v33.386C38.052 467.777.01 429.737 0 382.79M383.875 434.4c28.497-.045 51.557-23.106 51.613-51.606h33.38c-.01 46.943-38.04 84.983-84.993 84.994V434.4M435.485 85.008c-.053-28.495-23.118-51.57-51.61-51.617V.003c46.952.008 84.982 38.052 84.993 85.005h-33.383"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-checkbox',
    name: 'Checkbox',
    tags: ['check', 'complete', 'finish', 'done', 'checkbox'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 445.227 461.773"
        height="461.773"
        width="445.227"
      >
        <path
          d="M378.456 33.39H66.768c-18.408 0-33.385 14.974-33.385 33.383v328.234c0 18.404 14.977 33.384 33.385 33.384h311.688c18.407 0 33.387-14.98 33.387-33.384V66.773c0-18.409-14.98-33.384-33.387-33.384zm0-33.385c36.876 0 66.77 29.894 66.77 66.768v328.234c0 36.87-29.894 66.766-66.77 66.766H66.768C29.895 461.773 0 431.877 0 395.007V66.773C0 29.9 29.895.005 66.768.005h311.688"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-checkbox-active',
    name: 'Checkbox active',
    tags: ['check', 'complete', 'finish', 'done', 'checkbox'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 567.107 526.987"
        height="526.987"
        width="567.107"
      >
        <path
          d="M411.841 277.35v182.862c0 18.41-14.977 33.387-33.385 33.387H66.773c-18.409 0-33.387-14.976-33.387-33.387V131.984c0-18.407 14.978-33.385 33.387-33.385h280.879a1617.735 1617.735 0 0 1 39.075-32.823c-2.714-.333-5.463-.561-8.271-.561H66.773C29.893 65.215 0 95.107 0 131.984v328.228c0 36.879 29.893 66.775 66.773 66.775h311.683c36.877 0 66.773-29.896 66.773-66.775V232.133a1667.231 1667.231 0 0 0-33.388 45.216"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-client',
    name: 'Client',
    tags: ['client', 'man', 'woman', 'person'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 580.8 538.093"
        height="538.093"
        width="580.8"
      >
        <path
          d="M579.421 449.43c-9.636-27.94-41.548-31.949-68.205-43.194-29.272-12.343-61.73-26.67-90.935-38.653-8.333-2.268-16.673-4.543-25.005-6.82-9.95-6.848-19.692-29.6-25.012-40.915-5.303-.756-10.603-1.517-15.917-2.27.821-17.506 11.656-18.446 15.917-31.822 3.75-11.799.39-27.132 6.336-38.05 4.128-7.583 13.461-7.64 18.12-14.14 4.233-5.9 7.017-16.186 8.335-23.413 2.406-13.205 4.505-31.281-1.767-44.378-3.605-7.527-5.881-8.247-6.885-17.387-1.219-11.07 3.265-47.18 3.449-54.99.457-20.258-.033-21.9-4.935-41.631 0 0-5.954-17.88-15.286-23.263l-18.603-3.203-11.495-10.653c-46.326-28.504-95.988-8.508-122.588 2.27-38.326 12.437-62.564 49.969-45.641 130.149 2.888 13.694-7.499 19.816-6.824 27.286 1.488 16.346 1.801 55.628 17.243 65.308 1.434.895 12.388 3.639 12.316 2.891 1.518 15.91 3.032 31.835 4.545 47.744 3.856 10.576 13.107 11.737 15.792 26.675l-11.835 2.877c-5.318 11.315-15.064 34.067-25.013 40.915a26965.24 26965.24 0 0 1-25.003 6.82c-29.209 11.984-61.666 26.31-90.939 38.653-26.655 11.245-58.565 15.253-68.203 43.195 0 18.974-1.789 63.797-1.298 88.662h254.851l18.712-127.788-15.553-32.828L294 360.26l30.246 16.861-16.674 33.8 29.483 127.172h243.665c.487-24.865-1.3-69.688-1.3-88.662"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-cloud-upload',
    name: 'Cloud upload',
    tags: ['cloud', 'upload', 'save'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 584.547 397.547"
        height="397.547"
        width="584.547"
      >
        <path
          d="M504.163 172.803a138.133 138.133 0 0 0 4.474-34.939c0-76.143-61.726-137.867-137.87-137.867C313.516-.003 264.42 34.9 243.58 84.58c-17.901-21.035-44.552-34.395-74.337-34.395-53.899 0-97.595 43.69-97.595 97.591 0 9.268 1.32 18.223 3.736 26.713C31.37 190.63 0 232.885 0 282.524c0 63.481 51.44 115.023 114.992 115.023h150.065v-96.922H203.1l94.976-115.078 94.973 115.078h-61.963v96.922h138.44c63.586 0 115.024-51.542 115.024-115.023 0-51.485-33.76-95.036-80.386-109.721"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-cloud',
    name: 'Cloud',
    tags: ['cloud', 'server', 'internet'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 584.547 397.547"
        height="397.547"
        width="584.547"
      >
        <path
          d="M504.159 172.801a137.973 137.973 0 0 0 4.48-34.933C508.639 61.72 446.91-.005 370.767-.005c-57.252 0-106.346 34.901-127.187 84.584-17.897-21.038-44.55-34.399-74.337-34.399-53.898 0-97.594 43.693-97.594 97.592 0 9.27 1.32 18.223 3.734 26.719C31.372 190.629 0 232.888 0 282.519c0 63.486 51.44 115.028 114.993 115.028h354.531c63.584 0 115.024-51.542 115.024-115.028 0-51.486-33.763-95.03-80.39-109.718"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-code',
    name: 'Code',
    tags: ['code', 'angle brackets', 'brackets', 'html'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576.68 366"
        height="366"
        width="576.68"
      >
        <path
          d="M0 182.996L183.007 0l62.376 62.385-120.61 120.611 120.61 120.614L183.007 366 0 182.996M331.29 303.61l120.622-120.614-96.039-96.035L331.3 62.385 393.683-.004l24.581 24.584 158.417 158.416L393.683 366l-62.394-62.39"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-color-bucket',
    name: 'Color bucket',
    tags: ['color', 'paint'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 536.213 553.467"
        height="553.467"
        width="536.213"
      >
        <path
          d="M359.185 256.053c-13.494-11.108-27.429-23.69-41.208-37.514-27.569-27.554-50.338-55.524-65.886-79.53-7.772-11.988-13.73-22.985-17.571-32.146-3.884-9.128-5.457-16.535-5.379-20.166-.002-.589.03-1.07.074-1.437.369-.045.852-.079 1.436-.079 3.648-.073 11.048 1.488 20.181 5.386 27.768 11.518 70.49 42.116 111.683 83.45 27.57 27.564 50.35 55.536 65.888 79.551.545.836 1.057 1.656 1.588 2.485zm24.56 115.151c-.35.087-1.072.21-2.208.201-3.637.079-11.048-1.492-20.172-5.376-27.766-11.528-70.482-42.118-111.688-83.476-27.558-27.552-50.338-55.518-65.882-79.529-7.772-11.977-13.726-22.977-17.566-32.145-3.894-9.13-5.46-16.542-5.388-20.18 0-1.092.115-1.808.194-2.163l37.878-37.876c.826 2.29 1.706 4.608 2.69 6.97 14.666 34.602 47.068 78.649 90.642 122.363 29.06 29.046 58.51 53.14 84.994 70.311 13.256 8.58 25.76 15.452 37.377 20.339a156.1 156.1 0 0 0 6.984 2.693zM119.498 109.911c-7.345-12.999-10.732-24.152-10.696-33.142.172-9.748 3.155-18.01 13.18-28.276 11.91-11.685 20.818-14.985 30.195-15.105 6.507-.01 14.034 1.908 22.987 6.37 9.213 4.48 19.493 11.714 30.783 21.025-.183.17-.374.313-.548.49-.03.024-.066.046-.094.074l-70.888 70.886c-5.931-7.836-10.99-15.314-14.919-22.322zm159.955 417.081L409.015 397.42h.008l.009-.013 54.659-54.656c-16.826 53.033-41.176 133.316-41.176 153.868 0 31.398 25.446 56.848 56.845 56.848 31.403 0 56.85-25.45 56.85-56.848 0-25.55-37.64-143.44-51.662-186.478.13-1.438.219-2.864.207-4.252-.083-10.766-3.155-21.441-7.998-33.1-14.67-34.601-47.072-78.661-90.64-122.374-29.045-29.039-58.506-53.134-84.981-70.294-13.253-8.589-25.763-15.449-37.385-20.34-4.862-2.013-9.55-3.702-14.146-5.017-7.942-7.379-15.688-14.28-23.253-20.464-12.259-10-24.137-18.34-36.296-24.42C177.928 3.836 165.303.008 152.177 0c-19.342-.137-38.026 8.863-53.802 24.885-15.059 14.803-23.117 33.24-22.96 51.884.044 17.103 5.984 33.479 14.978 49.519 5.586 9.896 12.42 19.767 20.213 29.76L9.557 257.092C2.335 264.289-.064 273.98.002 282.449c.07 10.756 3.15 21.43 7.984 33.099 14.665 34.604 47.072 78.659 90.628 122.356 29.061 29.05 58.52 53.14 84.993 70.31 13.26 8.59 25.76 15.447 37.382 20.338 11.67 4.833 22.343 7.912 33.096 7.982.119.005.242.005.367.005 8.403 0 17.893-2.44 24.993-9.543"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-color-picker',
    name: 'Color picker',
    tags: ['eyedropper', 'picker'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.4 582.44"
        height="582.44"
        width="582.4"
      >
        <path
          d="M152.296 488.361c-6.096 6.093-14.061 9.128-22.043 9.128a31.323 31.323 0 0 1-13.643-3.124v.01l-30.99 30.981a20.122 20.122 0 0 1-14.287 5.92 20.129 20.129 0 0 1-14.286-5.92c-7.892-7.895-7.892-20.687-.003-28.58l30.978-30.984c.003 0 .005-.003.01-.005-5.634-11.633-3.654-26.024 6.004-35.682l223.692-223.69 58.26 58.257zM565.529 52.156l-35.294-35.297c-22.49-22.491-58.955-22.487-81.444.004L366.836 98.82l-39.603-39.599-78.352 78.352 32.668 32.664L57.86 393.928c-14.65 14.647-22.864 33.867-23.975 53.65l-13.02 13.018c-27.823 27.841-27.818 73.117.002 100.939 13.475 13.478 31.397 20.905 50.466 20.905 19.063 0 36.978-7.424 50.463-20.893l13.01-13.02c20.28-1.095 39.191-9.518 53.665-23.987l223.693-223.688 32.657 32.66 78.354-78.352-39.598-39.599 81.952-81.954c22.498-22.494 22.498-58.959 0-81.451"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-command',
    name: 'Command',
    tags: ['key', 'modifer', 'apple', 'mac'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 578.413 578.427"
        height="578.427"
        width="578.413"
      >
        <path
          d="M505.259 140.325c-2.716 6.14-6.287 11.384-10.779 15.868-4.51 4.502-9.75 8.067-15.883 10.775-6 2.645-12.242 3.95-18.982 3.959h-.026l-51.06-.018.016-49.624c0-7.457 1.344-14.141 3.99-20.241 2.726-6.328 6.346-11.843 10.905-16.69 4.436-4.706 9.735-8.367 16.112-11.066 6.065-2.567 12.393-3.89 19.18-4.001h.888c6.701.008 12.905 1.385 18.895 4.152 6.09 2.845 11.322 6.624 15.84 11.409 4.549 4.859 8.161 10.37 10.894 16.696 2.651 6.147 3.974 12.672 3.983 19.775-.01 6.745-1.324 13.02-3.973 19.006zM459.523 408.08c6.749 0 13.002 1.317 19.018 3.961 6.119 2.722 11.36 6.295 15.864 10.788 4.46 4.478 8.03 9.78 10.755 16.067 2.659 6.188 3.975 12.547 3.975 19.304h.005c-.008 7.113-1.343 13.625-3.996 19.772-2.732 6.32-6.355 11.84-10.907 16.681-4.514 4.795-9.749 8.566-15.846 11.4-5.99 2.778-12.188 4.135-18.892 4.143-7.118-.008-13.727-1.335-20.071-4.014-6.379-2.691-11.667-6.354-16.095-11.073-4.544-4.82-8.157-10.398-10.878-16.874-2.675-6.32-3.998-12.892-4.007-19.965l.017-50.209zm-120.228-68.745l-98.779-.03.024-99.258 98.784.034zM172.332 170.848l-52.011-.01c-7.11-.009-13.633-1.33-19.773-3.989-6.312-2.73-11.71-6.322-16.366-10.84-4.634-4.494-8.255-9.709-10.945-15.798-2.652-5.998-3.956-12.255-3.956-19v-.015c.005-7.461 1.348-14.137 3.99-20.253 2.72-6.318 6.344-11.842 10.9-16.688 4.444-4.706 9.747-8.36 16.112-11.064 6.328-2.672 12.936-4 20.045-4h.026c7.456.017 14.138 1.356 20.25 4 6.235 2.696 11.701 6.401 16.53 11.237 4.825 4.828 8.534 10.292 11.242 16.541 2.625 6.11 3.977 12.791 3.977 20.26zm-.072 287.25c-.008 7.11-1.344 13.727-4.017 20.074-2.715 6.39-6.419 11.913-11.223 16.719-4.828 4.828-10.3 8.533-16.54 11.233-6.115 2.639-12.795 3.968-20.25 3.981-7.111-.013-13.732-1.342-20.06-4.016-6.378-2.696-11.668-6.352-16.112-11.073-4.535-4.825-8.14-10.403-10.87-16.872-2.576-6.084-3.89-12.415-4.001-19.19v-.887c0-6.748 1.308-13.098 3.984-19.295 2.7-6.239 6.327-11.516 10.926-15.98 4.669-4.512 10.074-8.105 16.385-10.836 5.882-2.54 12.12-3.87 18.897-3.976l52.896.015zm406.147-338.066c-.154-15.95-3.278-31.172-9.344-45.45-6.172-14.534-14.575-27.42-25.154-38.507-10.625-11.142-23.244-19.947-37.68-26.322C491.735 3.34 476.16.12 459.764.101c-.056 0-.11-.002-.159 0h-.022c-16.442-.01-32.095 3.22-46.756 9.615-14.59 6.365-27.376 15.144-38.159 26.273-10.745 11.076-19.33 23.94-25.67 38.472-6.431 14.678-9.64 30.367-9.64 46.808l-.014 49.626-98.777-.024.017-51.208-.017-.034c-.192-15.857-3.402-30.998-9.604-45.2-6.335-14.53-14.902-27.408-25.65-38.494-10.785-11.127-23.548-19.908-38.129-26.29-14.612-6.385-30.2-9.601-46.553-9.632a5.738 5.738 0 0 0-.293-.008V0c-16.448 0-32.11 3.216-46.782 9.617C58.966 15.98 46.188 24.768 35.4 35.9 24.655 46.964 16.081 59.837 9.727 74.375 3.34 88.98.123 104.587.09 120.956c-.002.09-.002.139 0 .173v.051h.005c0 .008 0 .02-.005.036-.007 16.436 3.205 32.039 9.63 46.56 6.344 14.404 14.95 26.99 25.746 37.617 10.778 10.624 23.541 19.064 38.09 25.247 14.665 6.26 30.312 9.373 46.747 9.373l52.005.018-.026 99.257-51.763-.016c-.182-.005-.35 0-.49 0-16.34.016-31.908 3.143-46.507 9.353-14.556 6.182-27.318 14.607-38.106 25.232-10.803 10.614-19.412 23.214-25.77 37.607C3.233 425.947.02 441.508 0 457.894c-.002.143 0 .193 0 .205-.01 16.436 3.193 32.101 9.613 46.777 6.334 14.536 14.934 27.292 25.722 38.072 10.772 10.793 23.526 19.385 38.065 25.746 14.674 6.42 30.356 9.638 46.803 9.638h4.132l.039-.075c14.934-.487 29.206-3.671 42.642-9.538 14.548-6.354 27.296-14.937 38.084-25.725 10.788-10.78 19.395-23.526 25.747-38.066 6.417-14.68 9.636-30.352 9.636-46.813l.016-50.104 98.779.034-.018 50.104v.051c-.01 16.43 3.203 32.09 9.618 46.761 6.338 14.538 14.936 27.304 25.716 38.08 10.78 10.792 23.524 19.392 38.074 25.746 14.627 6.393 30.255 9.609 46.651 9.632h.085l.07.002 10.802.006-.225-.455c12.587-1.083 24.633-4.141 36.02-9.165 14.392-6.36 26.999-14.955 37.621-25.75 10.634-10.792 19.056-23.545 25.252-38.096 6.251-14.662 9.375-30.313 9.375-46.745v-1.097l-.005-.011c-.138-15.73-3.259-30.781-9.359-44.957-6.187-14.407-14.71-27.094-25.493-37.874-10.784-10.789-23.459-19.312-37.859-25.52-14.507-6.254-29.936-9.389-46.065-9.389l-51.058-.017.024-99.258 57.74.024v-.184c13.714-.738 26.891-3.793 39.391-9.182 14.403-6.187 27.088-14.708 37.877-25.494 10.779-10.78 19.312-23.452 25.516-37.858 6.247-14.507 9.383-29.934 9.383-46.064v-1.284l-.005-.019"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-company',
    name: 'Company',
    tags: ['company', 'buildings', 'campus'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 581.867 531.28"
        height="531.28"
        width="581.867"
      >
        <path
          d="M558.687 402.244h-57.802v-57.803h57.802zm-67.852-87.887h-57.803v-57.801h57.803zm0 177.23h-57.803v-57.798h57.803zm65.412-272.428V150.11h-31.478V82.739h-22.588V20.073h-18.985V82.74h-22.587v67.372h-31.472v69.048h-25.624V531.28H581.87V219.159zM35.963 397.996h57.796v57.805H35.963zm0-98.743h57.796v57.802H35.963zm0-102.762h57.796v57.804H35.963zM0 531.28h129.719V167.968H0zm187.225-132.386h57.802v57.802h-57.802zm0-173.118h57.802v57.796h-57.802zm0-173.124h57.802v57.8h-57.802zm99.546 0h57.805v57.8h-57.805zm-49.772 144.363v-57.803h57.804v57.803zm107.577 86.557h-57.805v-57.796h57.805zm-107.577 86.565v-57.802h57.804v57.802zm107.577 86.56h-57.805v-57.803h57.805zm-184.42 74.583h216.372V-.004H160.156V531.28"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-connection',
    name: 'Connection',
    tags: ['connection', 'electricity', 'lightning'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 560.92 316.84"
        height="316.84"
        width="560.92"
      >
        <path
          d="M0 316.84L231.203 48.028l124.266 97.025L560.923.007 355.469 267.336l-124.266-98.023L0 316.84"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-contrast',
    name: 'Contrast',
    tags: ['contrast', 'image', 'editor', 'modifier'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 557.12 557.12"
        height="557.12"
        width="557.12"
      >
        <path
          d="M444.841 444.845c-42.629 42.583-101.276 68.859-166.278 68.867V43.408c65.002.003 123.649 26.284 166.278 68.873 42.59 42.62 68.86 101.268 68.882 166.278-.022 65.004-26.292 123.661-68.882 166.286zM278.557 0C124.708.017.016 124.709 0 278.559.016 432.416 124.708 557.105 278.557 557.12c153.85-.015 278.536-124.704 278.558-278.561C557.093 124.709 432.407.017 278.557-.001"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-conversation',
    name: 'Conversation',
    tags: ['chat', 'talk'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 584.24 465.333"
        height="465.333"
        width="584.24"
      >
        <path
          d="M412.741 78.279l-.789-78.283-157.039 134.255 159.711 130.728-.752-74.771c157.656 18.735 91.268 114.397 3.104 205.521 307.185-207.705 120.937-297.997-4.235-317.45zM170.372 275.123c-157.655-18.73-91.271-114.398-3.104-205.514-307.19 207.703-120.937 297.995 4.233 317.446l.79 78.278L329.33 331.08 169.617 200.357l.755 74.766"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-coverflow',
    name: 'Coverflow',
    tags: ['coverflow', 'mac', 'apple', 'file'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 589.493 426.76"
        height="426.76"
        width="589.493"
      >
        <path
          d="M73.096 378.436V48.317h41.037v330.119H73.096M0 426.76V-.003h41.037V426.76H0M475.363 378.436V48.315h41.033v330.121h-41.033M548.453 426.76V-.003h41.04V426.76h-41.04M441.696 360.952H146.553V65.808h295.143v295.144"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-credit-card-1',
    name: 'Credit card',
    tags: ['money', 'credit'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576.853 370"
        height="370"
        width="576.853"
      >
        <path
          d="M549.237 188.003H28.747V78.648h520.49zM180.933 257.19v-22.802h107.575v22.802zm-98.31-.005v-22.8h82.546v22.8zm221.642 36.17H82.627v-22.792h221.638zM550.107 0H26.75C11.974 0 0 11.973 0 26.748v316.515C0 358.024 11.974 370 26.75 370h523.357c14.774 0 26.749-11.976 26.749-26.737V26.748C576.856 11.973 564.881 0 550.106 0"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-credit-card-2',
    name: 'Credit card',
    tags: ['money', 'credit'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 586.173 350.667"
        height="350.667"
        width="586.173"
      >
        <path
          d="M309.175 256.03H83.978v22.377h225.197zm-16.014-34.28H183.855v22.375H293.16zm-125.336 0H83.978v22.375h83.847zM545.903 72.692H40.266V40.271h505.637zm0 237.703H40.266V180.017h505.637zM558.996 0H27.175C12.163 0 0 11.357 0 25.36v299.965c0 14 12.163 25.342 27.175 25.342h531.821c15.01 0 27.176-11.341 27.176-25.342V25.36c0-14.003-12.165-25.36-27.176-25.36"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-curve',
    name: 'Curve',
    tags: ['curve', 'geometry'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 594.84 594.613"
        height="594.613"
        width="594.84"
      >
        <path
          d="M592.004 393.132c6.305-18.576 2.11-39.928-12.699-54.735-14.806-14.809-36.156-19.002-54.732-12.698l-80.824-80.823 24.362-24.363-92.151-92.148-24.365 24.362-76.396-76.395c9.581-19.808 6.204-44.31-10.234-60.75-20.777-20.773-54.453-20.777-75.226 0-20.776 20.774-20.776 54.455 0 75.227 14.781 14.784 36.084 18.991 54.638 12.732l73.364 73.363c-30.118-13.152-62.38-19.843-94.657-19.835-50.504-.016-101.164 15.863-143.582 47.738-20.308-11.58-46.588-8.766-63.924 8.566-20.77 20.774-20.77 54.455 0 75.228 20.774 20.775 54.454 20.775 75.23 0 14.933-14.934 19.071-36.522 12.532-55.208 35.461-26.141 77.53-39.09 119.744-39.112a199.697 199.697 0 0 1 73.055 13.906l-12.331 12.33 92.147 92.151 19.676-19.67a198.674 198.674 0 0 1 27.862 101.42c-.016 33.558-8.188 67-24.597 97.134-18.867-6.943-40.867-2.896-56.012 12.252-20.773 20.777-20.773 54.459 0 75.227 20.77 20.774 54.452 20.78 75.232 0 16.913-16.912 20.05-42.382 9.419-62.474 22.186-37.58 33.189-79.942 33.173-122.14.01-32.177-6.681-64.326-19.793-94.338l52.885 52.886c-9.523 19.798-6.135 44.246 10.28 60.659 20.77 20.768 54.452 20.773 75.228 0 5.757-5.755 9.855-12.515 12.423-19.701l.533-.535-.26-.256"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-cut',
    name: 'Cut',
    tags: ['scissors', 'paper', 'cut', 'shears'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.067 467.453"
        height="467.453"
        width="582.067"
      >
        <path
          d="M153.944 145.34L41.758 84.147c16.899-30.982 55.71-42.396 86.687-25.5 30.983 16.904 42.396 55.713 25.499 86.693zm62.283 13.853c-11.588-7.588-15.452-13.369-18.514-21.806-2.992-8.564-3.938-21.04-5.417-37.967-2.29-23.841-7.363-48.087-22.33-67.648-14.97-19.739-40.321-32.04-74.69-31.77-33.682-.06-58.316 8.705-74.2 24.686C5.196 40.668-.046 61.893.002 81.973-.08 92.823 2.41 103.788 8.96 112.94c6.515 9.154 15.796 15.854 27.667 22.145l.189.1 166.85 84.017 9.865 4.946c5.062 2.541 7.121 8.706 4.576 13.764-.351.696-.811 1.29-1.287 1.862-.055.068-.088.144-.141.21-.014.014-.023.036-.038.049L376.19 329.44l111.931 51.95c20.688 10.262 37.399 14.65 50.936 14.715 9.192.013 17.207-1.957 23.615-5.753 6.434-3.746 10.828-9.167 13.309-14.221l6.076-12.162-312.352-174.865zm-89.09 251.18c-31.105 16.663-69.836 4.955-86.494-26.151l112.636-60.343c16.672 31.1 4.966 69.833-26.142 86.494zm-90.265-78.129l-.245.119c-11.871 6.292-21.152 12.992-27.667 22.145-6.55 9.156-9.04 20.119-8.958 30.972-.048 20.077 5.194 41.299 21.074 57.281 15.884 15.982 40.518 24.74 74.2 24.69l1.101.002c33.82.003 58.783-12.248 73.59-31.776 14.966-19.561 20.038-43.805 22.329-67.614 1.479-16.957 2.415-29.435 5.417-37.998 3.068-8.458 6.947-14.248 18.594-21.861l35.448-19.839-60.495-33.898zm545.192-227.181l-6.084-12.16c-2.481-5.055-6.875-10.483-13.31-14.228-6.407-3.784-14.422-5.762-23.614-5.747-13.537.067-30.248 4.456-50.939 14.717L309.6 171.867l76.344 42.784 196.12-109.588"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-dashboard',
    name: 'Dashboard',
    tags: ['home', 'information'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 525.267 525.267"
        height="525.267"
        width="525.267"
      >
        <path
          d="M379.74 172.47l-23.61-23.615 46.346-46.339 23.601 23.604zm-73.384-53.325l27.701-59.402 30.259 14.12-27.701 59.388zm-39.11 334.91c-29.031 0-52.56-23.53-52.56-52.555 0-22.672 14.374-41.927 34.483-49.307V202.288h33.384v148.93c21.558 6.554 37.248 26.578 37.248 50.282 0 29.025-23.53 52.556-52.556 52.556zM166.655 73.913l30.259-14.107 27.69 59.394-30.25 14.104zm-16.47 98.557l-46.338-46.349 23.6-23.604 46.35 46.339zm99.882-122.588h33.385v65.536h-33.385zM262.635-.003C117.584-.003 0 117.585 0 262.632c0 145.052 117.584 262.635 262.635 262.635 145.048 0 262.632-117.583 262.632-262.635 0-145.047-117.584-262.635-262.632-262.635"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-delete',
    name: 'Delete',
    tags: ['clear', 'remove'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 393.32 393.32"
        height="393.32"
        width="393.32"
      >
        <path
          d="M392.373 79.285L314.031.94 196.66 118.305 79.289.94.943 79.285l117.367 117.37L.943 314.02l78.346 78.357L196.66 275.001l117.37 117.376 78.343-78.357-117.368-117.365 117.368-117.37"
          fill="#231f20"
        />
        <path
          d="M392.373 79.285L314.031.94 196.66 118.305 79.289.94.943 79.285l117.367 117.37L.943 314.02l78.346 78.357L196.66 275.001l117.37 117.376 78.343-78.357-117.368-117.365z"
          fill="none"
          stroke="#fff"
          strokeWidth="1.3333"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-disc',
    name: 'Disc',
    tags: ['cd', 'music'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 581.333 581.333"
        height="581.333"
        width="581.333"
      >
        <path
          d="M290.667 153.577c-75.595 0-137.095 61.502-137.095 137.095 0 75.59 61.5 137.09 137.095 137.09 75.592 0 137.089-61.5 137.089-137.09 0-75.593-61.497-137.095-137.09-137.095zm0-153.57c160.532 0 290.662 130.136 290.662 290.665 0 160.526-130.13 290.661-290.662 290.661C130.137 581.333 0 451.198 0 290.672 0 130.142 130.136.007 290.667.007"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-display',
    name: 'Display',
    tags: ['computer', 'monitor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 580.147 503.413"
        height="503.413"
        width="580.147"
      >
        <path
          d="M540.083 352.479H40.064V40.06h500.019zM563.632-.005H16.509C7.39-.005 0 7.389 0 16.507v359.517c0 9.12 7.39 16.517 16.509 16.517h547.123c9.121 0 16.512-7.397 16.512-16.517V16.507c0-9.118-7.39-16.512-16.512-16.512zM362.171 437.353c-1.191-5.333-2.027-10.576-2.643-15.529h-138.91c-1.245 9.96-3.46 21.21-7.343 31.6-3.882 10.461-9.396 19.961-16.883 26.653-7.52 6.675-16.861 10.86-29.923 10.906v12.43h247.196v-12.43c-13.065-.046-22.406-4.231-29.929-10.913-11.245-9.995-17.988-26.509-21.565-42.717"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-document',
    name: 'Document',
    tags: ['page', 'editor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 397.427 555.6"
        height="555.6"
        width="397.427"
      >
        <path
          d="M33.384 522.219V33.383h188.817c49.603 0 25.7 117.574 25.7 117.574s114.667-27.869 116.139 24.712v346.55zm354.268-400.452L275.656 9.776l-9.775-9.777H0V555.6h397.428V131.548l-9.776-9.781"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-documents',
    name: 'Documents',
    tags: ['pages', 'editor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 583.227 582.893"
        height="582.893"
        width="583.227"
      >
        <path
          d="M573.444 108.35L465.089-.006H296.284l33.39 33.384h95.309c.085 0 .16.014.246.014-.008.381-.032.729-.032 1.116 14.899 0 22.255 12.06 25.492 27.933 5.811 30.612-3.082 74.435-3.082 74.435s.182-.042.454-.11c-.152.803-.241 1.244-.241 1.244s89.505-21.768 101.057 14.31c.103.392.215.78.3 1.182.111.403.186.816.276 1.228a28.03 28.03 0 0 1 .383 3.872v305.076h-117.33l.002 33.383h150.716V118.132zM364.043 549.506H33.38V60.675h188.82c49.604 0 25.703 117.572 25.703 117.572s114.667-27.867 116.139 24.708zM275.66 37.067l-9.78-9.779H0v555.605h397.427V158.835l-9.776-9.78L275.66 37.067"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-download',
    name: 'Download',
    tags: ['file', 'save'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 318.773 586.253"
        height="586.253"
        width="318.773"
      >
        <path
          d="M264.105 490.85H54.664V375.045h209.441zm31.82-155.867H22.843a8.239 8.239 0 0 0-8.24 8.242v179.44a8.241 8.241 0 0 0 8.24 8.245h273.082a8.243 8.243 0 0 0 8.244-8.245v-179.44a8.24 8.24 0 0 0-8.244-8.242zm-98.218 226.306c-1.936-5.184-3.04-10.79-3.664-15.76h-69.326c-.62 4.972-1.724 10.584-3.662 15.77-4.052 10.524-10.55 18.68-23.362 18.747v6.207h123.383v-6.207c-12.819-.066-19.316-8.228-23.37-18.757zM318.77 131.644H214.787V.005H103.984v131.639H0l159.39 193.112 159.38-193.112"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-edit',
    name: 'Edit',
    tags: ['change', 'alter'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 578.587 579.213"
        height="579.213"
        width="578.587"
      >
        <path
          d="M134.239 478.31l-61.825 28.135 27.866-62.097 31.184-31.181 4.49 29.733 29.463 4.219zm52.346-78.737l-21.242-21.245 254.564-254.57-21.715-21.711L63.644 436.596l.247.245L0 579.213l141.745-64.51.243.242.643-.644.008-.004 333.898-333.909-35.382-35.383zM500.232.003l-66.63 66.633 78.347 78.347 66.635-66.642L500.232.003"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-eject',
    name: 'Eject',
    tags: ['remove'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 444.987 394.6"
        height="394.6"
        width="444.987"
      >
        <path
          d="M0 394.6V283.804h444.984V394.6H0M221.405-.001l221.014 221.01H.398z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-employee',
    name: 'Employee',
    tags: ['person', 'man', 'woman'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 580.8 538.093"
        height="538.093"
        width="580.8"
      >
        <path
          d="M457.503 512.936H354.12V467.46h103.383zm121.92-63.499c-9.639-27.936-41.552-31.95-68.204-43.19-29.274-12.342-61.734-26.678-90.938-38.654-8.334-2.27-16.673-4.545-25.005-6.82-9.952-6.846-19.693-29.602-25.015-40.917-5.301-.757-10.601-1.516-15.918-2.268.824-17.505 11.66-18.445 15.918-31.824 3.75-11.793.392-27.132 6.339-38.05 4.127-7.585 13.459-7.637 18.12-14.14 4.232-5.898 7.016-16.186 8.333-23.41 2.406-13.213 4.504-31.281-1.765-44.383-3.608-7.524-5.884-8.245-6.887-17.384-1.22-11.069 3.266-47.184 3.451-54.99.456-20.259-.033-21.898-4.939-41.628 0 0-5.949-17.88-15.282-23.264l-18.603-3.203-11.497-10.653c-46.323-28.506-95.99-8.516-122.587 2.27-38.328 12.435-62.563 49.962-45.643 130.143 2.888 13.697-7.498 19.821-6.821 27.292 1.488 16.34 1.801 55.63 17.24 65.303 1.437.9 12.39 3.644 12.317 2.894 1.52 15.91 3.032 31.836 4.546 47.746 3.854 10.573 13.105 11.737 15.793 26.676l-11.833 2.873c-5.322 11.315-15.064 34.07-25.014 40.917a63840.93 63840.93 0 0 1-25.008 6.82c-29.203 11.976-61.664 26.312-90.935 38.653-26.656 11.24-58.566 15.255-68.203 43.191 0 18.979-1.788 63.798-1.298 88.656H580.72c.49-24.858-1.296-69.677-1.296-88.656"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-enter',
    name: 'Enter',
    tags: ['entrance'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 288.827 391.307"
        height="391.307"
        width="288.827"
      >
        <path
          d="M135.007-.004v68.485h85.334v190.066H119.36v-64.264L0 292.793l119.359 98.514V327.03h169.466V-.004H135.007"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-equalizer',
    name: 'Equalizer',
    tags: ['music'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 627 573.24"
        height="573.24"
        width="627"
      >
        <path
          d="M183.481 174.692c0 17.11-13.873 30.983-30.985 30.983H30.986C13.875 205.675 0 191.803 0 174.692c0-17.116 13.874-30.988 30.987-30.988h121.509c17.112 0 30.985 13.872 30.985 30.988M405.968 391.077c0 17.115-13.873 30.986-30.984 30.986H253.472c-17.115 0-30.987-13.871-30.987-30.986 0-17.11 13.872-30.985 30.987-30.985h121.512c17.11 0 30.984 13.875 30.984 30.985M627 218.439c0 17.112-13.873 30.981-30.985 30.981H474.503c-17.114 0-30.983-13.87-30.983-30.981 0-17.116 13.87-30.988 30.983-30.988h121.512c17.112 0 30.985 13.872 30.985 30.988M270.779 573.24h88.238V460.095H270.78zm-221.696 0h88.232V245.019H49.083zm443.397 0h88.227V288.763H492.48zM270.779 324.68h88.238V-.001H270.78zM492.48.001v153.343h88.227V.001zM49.083 109.6h88.232V.001H49.083V109.6"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-ethernet',
    name: 'Ethernet',
    tags: ['cat', 'cat-5', 'internet'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 579.733 350.84"
        height="350.84"
        width="579.733"
      >
        <path
          d="M384.677 207.89c16.518 0 29.915-13.394 29.915-29.909 0-16.521-13.397-29.916-29.915-29.916-16.521 0-29.912 13.395-29.912 29.916 0 16.515 13.391 29.91 29.912 29.91zm-96.146-59.825c-16.522 0-29.912 13.395-29.912 29.916 0 16.515 13.39 29.91 29.912 29.91 16.52 0 29.912-13.395 29.912-29.91 0-16.521-13.392-29.916-29.912-29.916zm-126.064 29.916c0 16.515 13.394 29.91 29.913 29.91 16.521 0 29.915-13.395 29.915-29.91 0-16.521-13.394-29.916-29.915-29.916-16.519 0-29.913 13.395-29.913 29.916zM428.89 24.58L404.305.003l-47.208 47.214 24.575 24.584 103.63 103.614-128.205 128.204 47.208 47.221 175.423-175.425zM94.418 175.415l128.21-128.2L175.416.01 0 175.415l175.416 175.42 47.217-47.209-.005-.007-128.21-128.204"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-exit-fullscreen',
    name: 'Exit fullscreen',
    tags: ['leave', 'dismiss'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 580.72 578.92"
        height="578.92"
        width="580.72"
      >
        <path
          d="M467.05 349.023V233.13c0-47.999-38.905-86.896-86.894-86.896H199.213c-47.989 0-86.894 38.897-86.894 86.896v115.892c0 47.988 38.905 86.886 86.894 86.886h180.943c47.99 0 86.895-38.898 86.895-86.886zM141.309 141.3V-.005L91.871 49.433 45.33 2.896 2.182 46.044l46.535 46.541L0 141.3zM49.433 487.04L2.898 533.576l43.162 43.161 46.531-46.536 48.716 48.719V437.604H.002zm531.282-49.425H439.4V578.92l49.442-49.436 46.529 46.534 43.163-43.16-46.531-46.533zM531.273 91.864l46.531-46.535-43.16-43.16-46.525 46.538L439.407-.005v141.312h141.306l-49.44-49.443"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-eye',
    name: 'Eye',
    tags: ['view', 'see'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 574.187 311.053"
        height="311.053"
        width="574.187"
      >
        <path
          d="M287.083 263.93c-60.782 0-110.062-49.234-110.062-110.094 0-60.783 49.28-110.047 110.062-110.047 60.816 0 110.094 49.264 110.094 110.047 0 60.86-49.278 110.093-110.094 110.093zm0-263.937C144.045-.007 0 155.524 0 155.524s144.045 155.53 287.083 155.53c143.058 0 287.105-155.53 287.105-155.53S430.141-.006 287.083-.006zm0 99.923c-29.74 0-53.934 24.19-53.934 53.92 0 29.755 24.194 53.964 53.934 53.964 29.758 0 53.965-24.21 53.965-53.964 0-29.73-24.207-53.92-53.965-53.92"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-factory',
    name: 'Factory',
    tags: ['manufacture', 'build'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 579.48 582.307"
        height="582.307"
        width="579.48"
      >
        <path
          d="M167.063 62.945l-3.834 2.935.032.043zm-66.481-29.557c18.124-.048 33.823 7.795 45.273 16.25a104.967 104.967 0 0 1 13.208 11.571 74.374 74.374 0 0 1 3.326 3.654c.359.41.604.721.739.896.055.06.077.092.101.121l26.495-20.307v-.013c-.644-.812-8.976-11.643-24.045-22.781C150.677 11.719 128.429.032 100.582 0 72.709-.112 40.92 12.313 9.528 43.919l23.618 23.606c27.134-26.95 49.344-34.03 67.436-34.137zm113.415 37.893l-3.802 2.972 3.84-2.932c-.012-.005-.035-.037-.038-.04zm-2.421 43.146c15.007 11.061 37.245 22.732 65.096 22.772h.376c27.79 0 59.417-12.462 90.676-43.912l-23.595-23.61c-27.157 26.94-49.372 34.019-67.457 34.132-18.116.047-33.819-7.794-45.277-16.249a106.067 106.067 0 0 1-13.192-11.556 80.642 80.642 0 0 1-3.331-3.665c-.36-.407-.603-.714-.745-.892-.05-.067-.076-.095-.092-.126L187.54 91.644c.639.812 8.976 11.65 24.036 22.783zm249.16-81.039c18.125-.048 33.825 7.79 45.275 16.25 5.685 4.195 10.209 8.449 13.201 11.566a75.71 75.71 0 0 1 3.33 3.659c.353.41.6.721.746.896.041.049.072.089.097.117l-.01.004.044.032 3.433-2.696 23.035-17.653h-.011c-.64-.81-8.983-11.648-24.041-22.792C510.827 11.712 488.59.043 460.736 0c-27.875-.117-59.657 12.313-91.053 43.916l23.621 23.61c27.121-26.949 49.343-34.031 67.432-34.138zm30.516 50.677v241.362L366.22 258.672v81.057l-176.012-81.057v87.597L0 258.672v323.635h579.476V84.065h-88.224"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-favorite',
    name: 'Favorite',
    tags: ['save', 'flag'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.013 501.747"
        height="501.747"
        width="582.013"
      >
        <path
          d="M496.268 14.292C421.636-20.88 332.587 11.12 297.425 85.779c-2.441 5.18-4.561 11.689-6.417 19.237-1.855-7.548-3.979-14.057-6.42-19.237C249.424 11.12 160.398-20.88 85.742 14.292 11.13 49.453-20.883 138.455 14.28 213.109c35.158 74.652 276.67 288.638 276.67 288.638l.055-.686.058.686S532.576 287.76 567.732 213.109c35.164-74.654 3.196-163.656-71.464-198.817"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-firewire',
    name: 'Firewire',
    tags: ['internet', 'wiring'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 478.653 511.133"
        height="511.133"
        width="478.653"
      >
        <path
          d="M398.479-.004l-100.78 100.461 80.174 79.422 100.784-99.464zM91.806 3.915L0 95.428l30.605 30.51 91.814-92.033zm61.211 60.504l-91.809 91.508 30.598 30.513 91.817-91.525zm19.944 446.714H302.8v-43.148H172.96zm0-86.292H302.8v-43.15H172.96zm64.918-129.424c-30.422 0-55.087-24.588-55.087-54.908 0-30.317 24.665-54.91 55.087-54.91 30.417 0 55.09 24.593 55.09 54.91 0 30.32-24.673 54.908-55.09 54.908zm0-152.952c-54.33 0-98.37 43.892-98.37 98.044 0 54.154 44.04 98.048 98.37 98.048 54.332 0 98.36-43.894 98.36-98.048 0-54.152-44.028-98.044-98.36-98.044"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-flag-alt',
    name: 'Flag alt',
    tags: ['banner', 'save', 'favorite'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 581.48 586.653"
        height="586.653"
        width="581.48"
      >
        <path
          d="M457.855 46.08s-83.258 113.95-206.438-9.227v.226C163.571-53.06 87.276 49.48 87.276 49.48l123.627 296.931s51.352-145.863 206.436 9.224v-.228c87.844 90.13 164.144-12.407 164.144-12.407zM0 82.587l208.485 504.066 58.624-24.245L58.615 58.328 0 82.587"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-flag',
    name: 'Flag',
    tags: ['banner', 'save', 'favorite'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 531.4 572.08"
        height="572.08"
        width="531.4"
      >
        <path
          d="M0 572.08V26.585h63.43V572.08H0M287.903 321.996c-119.223-109.445-190.059-7.324-190.059-7.324V27.289S255.117-57.925 326.09 72.804l.007-.19C431.8 244.65 531.401 154.968 531.401 154.968S407.123 431.445 287.903 321.996"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-flash',
    name: 'Flash',
    tags: ['tags', 'important'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 378.92 597"
        height="597"
        width="378.92"
      >
        <path
          d="M378.923-.007L0 339.43h126.66L0 597l378.923-339.441H252.26L378.923-.007"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-folder-open',
    name: 'Folder open',
    tags: ['file system'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576.84 480.867"
        height="480.867"
        width="576.84"
      >
        <path
          d="M45.325 214.21V95.646h486.111v118.566zm509.668 138.326c1.391-41.528 21.844-115.281 21.844-115.281 0-11.244-8.046-20.586-18.69-22.623V68.942h-.008c-.036-11.946-9.723-21.614-21.674-21.614h-274.2c-8.57-.208-15.176-15.79-15.176-21.743l.003-2.541c0-12.723-10.315-23.04-23.04-23.04H78.082c-12.723 0-23.038 10.317-23.038 23.04l.006 2.541c0 5.998-6.697 21.762-15.357 21.762h.206c-11.792.212-21.286 9.821-21.286 21.661l.004 145.635C8.011 216.708 0 226.039 0 237.255c0 0 19.546 74.569 20.938 116.094 1.39 41.532-6.843 104.482-6.843 104.482 0 12.718 2.631 23.036 15.35 23.036H547.39c12.726 0 15.354-10.318 15.354-23.036 0 0-9.14-63.768-7.75-105.295"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-folder',
    name: 'Folder',
    tags: ['file system'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576.84 480.867"
        height="480.867"
        width="576.84"
      >
        <path
          d="M558.141 69.003c0-11.974-9.702-21.675-21.677-21.675H262.267c-8.572-.213-15.179-15.79-15.179-21.747l.004-2.537c0-12.728-10.316-23.04-23.04-23.04H78.084c-12.726 0-23.042 10.312-23.042 23.04l.006 2.537c0 6-6.695 21.763-15.355 21.763h.206c-11.792.21-21.287 9.819-21.287 21.659v14.964h539.53zm0 56.416v-.422H18.612v.438C8.004 127.5 0 136.83 0 148.04c0 0 7.578 115.284 8.968 156.815 1.393 41.53 5.125 152.97 5.125 152.97 0 12.725 2.63 23.04 15.352 23.04H547.39c12.723 0 15.351-10.315 15.351-23.04 0 0 3.739-111.44 5.127-152.97 1.392-41.53 8.968-156.815 8.968-156.815 0-11.242-8.046-20.588-18.694-22.622"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-font',
    name: 'Font',
    tags: ['typography'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 525.28 554.627"
        height="554.627"
        width="525.28"
      >
        <path
          d="M235.172 345.041h140.727l-22.952-218.237zM315.695-.004h130.944l78.641 554.63H399.603l-11.664-114.01H183.62l-62.461 114.01H0L315.695-.003"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-fullscreen-alt',
    name: 'Fullscreen alt',
    tags: ['view', 'expand', 'monitor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 580.813 581.907"
        height="581.907"
        width="580.813"
      >
        <path
          d="M367.832-.005l75.836 75.842L323.218 196.3l62.39 62.38 120.448-120.455 74.757 74.764V-.005zM195.207 323.212L74.755 443.671 0 368.912v212.995h212.985l-75.844-75.85L257.597 385.59l-62.39-62.377"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-fullscreen',
    name: 'Fullscreen',
    tags: ['view', 'expand', 'monitor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 580.72 578.933"
        height="578.933"
        width="580.72"
      >
        <path
          d="M467.053 349.032V233.139c0-47.991-38.905-86.894-86.893-86.894H199.216c-47.988 0-86.895 38.903-86.895 86.894v115.893c0 47.99 38.907 86.89 86.895 86.89H380.16c47.988 0 86.893-38.9 86.893-86.89zM95.968 138.407l43.163-43.155-46.537-46.53L141.31.006H0V141.31l49.44-49.434zm42.436 344.546L95.244 439.8l-46.53 46.536L.003 437.62v141.313h141.305l-49.438-49.44zm392.875 4.108l-46.535-46.532-43.16 43.157 46.533 46.533-48.712 48.714h141.316V437.624zm-88.967-391.08l43.156 43.151 46.53-46.532 48.718 48.719V.007H439.411l49.433 49.436-46.532 46.538"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-game',
    name: 'Game',
    tags: ['controller', 'play', 'computer'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 586.907 410.907"
        height="410.907"
        width="586.907"
      >
        <path
          d="M172.795 109.567c-26.275.053-47.532 21.309-47.578 47.582.046 26.272 21.303 47.534 47.578 47.582 26.269-.048 47.53-21.31 47.578-47.582-.048-26.273-21.309-47.529-47.578-47.582zm329.288 57.278c-9.25 9.25-24.244 9.25-33.492 0-9.25-9.252-9.246-24.244.002-33.493 9.248-9.25 24.242-9.25 33.49 0 9.25 9.245 9.25 24.241 0 33.493zM457 211.921c-9.248 9.25-24.243 9.25-33.492 0-9.248-9.245-9.243-24.242.003-33.488 9.249-9.248 24.245-9.253 33.489-.005 9.25 9.25 9.25 24.248 0 33.493zm-76.983-43.486c-9.249-9.255-9.249-24.247 0-33.492 9.25-9.251 24.246-9.251 33.494 0 9.246 9.245 9.244 24.237-.003 33.486-9.248 9.246-24.241 9.25-33.49.006zM425.1 89.86c9.25-9.248 24.244-9.248 33.494 0 9.244 9.247 9.243 24.243-.002 33.488-9.251 9.25-24.242 9.25-33.492.004-9.25-9.25-9.25-24.243 0-33.492zM172.795 238.112c-44.725-.008-80.957-36.244-80.962-80.963.005-44.722 36.237-80.956 80.962-80.96 44.721.004 80.953 36.238 80.958 80.96-.005 44.719-36.237 80.955-80.958 80.963zm388.312-75.261C540.319 77.6 511.515-11.145 408.725 3.439 369.071 9.07 339.068 32.328 294.82 32.435c-36.982.09-65.95-23.262-99.932-28.996C92.195-13.896 67.854 35.289 38.02 126.983 21.156 178.82-32.704 357.58 28.515 400.38c62.027 43.365 129.74-75.94 176.422-94.11 40.314-15.693 127.052-14.338 166.796-2.345C425.652 320.2 478.76 423.247 539.516 409.68c83.193-18.573 34.173-195.243 21.59-246.83"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-gift',
    name: 'Gift',
    tags: ['give', 'present'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.56 579.373"
        height="579.373"
        width="582.56"
      >
        <path
          d="M307.97 579.373h223.018V331.295H307.971zM343.3 87.39c9.918-14.204 21.586-26.149 33.65-34.166 12.128-8.05 24.286-12.178 36.49-12.188h.128c10.228 0 19.922 3.924 26.61 9.82 6.744 6.001 10.226 13.182 10.243 20.885-.059 9.136-4.853 22.452-26.153 38.032-20.284 14.72-55.276 29.836-109.266 40.396 5.176-21.445 15.1-44.11 28.298-62.779zm-187.922 29.024c-11.081-6.958-17.817-13.997-21.746-20.238-3.907-6.288-5.255-11.791-5.287-17.166-.059-8.997 4.44-18.596 12.343-26.062 7.773-7.403 18.338-11.912 27.85-11.912h.24c12.203.01 24.362 4.138 36.487 12.188 18.124 11.977 35.216 32.994 47.15 56.833 6.097 12.043 10.86 24.78 14.07 37.199-54.95-5.686-90.563-17.839-111.107-30.842zm398.818 41.707H423.379c9.284-4.768 17.565-9.795 24.905-15.068 28.319-20.212 43.221-45.839 43.17-71.312.017-20.861-9.909-39.277-24.234-51.75C452.853 7.438 433.857.032 413.439.003c-21.758-.012-41.946 7.519-59.24 19.063C328.19 36.5 307.723 62.773 293.144 91.6c-.7 1.4-1.375 2.81-2.048 4.218-5.337-11.111-11.543-21.864-18.559-31.963-12.332-17.587-27.161-33.195-44.521-44.79C210.717 7.52 190.529-.003 168.777.005c-21.634.076-41.432 9.159-56.269 23.11-14.768 13.954-25.143 33.602-25.2 55.895-.04 13.036 3.77 26.65 11.588 39.018 9.828 15.558 25.398 29.036 46.957 40.093H28.364C12.702 158.12 0 170.817 0 186.485V291.66h274.583V158.12h33.388v133.539h274.588V186.485c0-15.668-12.703-28.365-28.364-28.365zM51.565 579.373h223.018V331.295H51.565v248.078"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-globe',
    name: 'Globe',
    tags: ['earth', 'planet'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.227 582.227"
        height="582.227"
        width="582.227"
      >
        <path
          d="M527.504 349.41c-5-4.347-10.9-10.17-14.455-15.798-3.798-5.999-1.457-12.172-1.181-19.043.232-5.78-2.59-14.004-.133-19.206 1.126-2.376 3.712-3.163 4.774-5.11 2.262-4.121 1.759-6.906 4.535-10.449 2.977-3.807 6.98-4.743 10.295-7.725 3.473-3.131 3.377-5.599 5.577-9.608 1.608-2.931 5.39-7.82 8.97-10.375a258.654 258.654 0 0 1 2.955 39.017c0 22.942-3.052 45.176-8.705 66.362-4.82-1.244-8.784-4.718-12.632-8.066zm-3.33-133.478c.478-1.023 1.597-1.36 2.06-2.205.971-1.776.755-2.979 1.954-4.503 1.283-1.644 3.01-2.05 4.441-3.333a5.27 5.27 0 0 0 1.164-1.487A255.53 255.53 0 0 1 544 241.5c-.076.09-.119.227-.212.305-.626.494-4.706 1.1-5.543 1.128-2.956.116-5.15-1.845-7.272-3.692-2.157-1.874-4.699-4.382-6.232-6.809-1.639-2.592-.627-5.253-.51-8.216.098-2.492-1.113-6.04-.057-8.284zm-47.115-102.208c-10.031.301-17.014.321-25.074 5.884-3.245 2.241-5.449 5.216-9.569 6.375-3.696 1.037-7.684.126-11.35 1.37-13.227 4.488-11.13 32.816-28.56 28.54-8.187-2.009-13.955-11.684-18.077-18.001-3.628-5.557-10.238-10.156-5.773-17.11-2.036.523-4.21-.074-6.213.31 2.793-6.136 12.154-5.596 13.712-8.73 3.88-7.854-10.68-8.674-14.803-9.762 4.968-5.297 7.485 1.78 12.39.579 4.715-1.159-2.489-7.368-5.315-8.064-1.015-.252-17.616 4.585-8.008-4.012l-35.58-22.686c-1.998 8.412 15.786 13.192 21.594 16.159-.901 3.472-6.304 8.532-10.442 7.048-3.896-1.395-2.314-7.853-8.198-7.207-4.202 9.771 8.883 6.915 10.098 12.9 1.382 6.82-4.946 3.932-7.379 3.812-.58-.028-5.115-4.725-5.361-1.17-.294 4.22 7.236 2.576 7.766 6.837-8.769.353-13.248-2.812-20.386-7.553-8.331-5.53-12.607-5.031-22.814-5.031 3.054-1.253 7.258-2.184 9.868-4.203 1.427-1.104 7.022-6.542 7.39-7.758 1.582-5.235-.084-4.842-5.098-8.274-4.454-3.046-9.857-8.518-15.257-9.598-19.561-3.906-6.035 17.662-20.883 20.637.254.01.53.025.748.025h-.849c.036-.004.067-.017.101-.025-3.434-.124-9.872-.96-12.086.853-1.563 1.278-1.694 6.403-3.44 8.256-3.108 3.314-7.742 3.976-11.451 6.367-3.621 2.332-11.603 8.321-13.73 12.384-7.835 14.972 17.658 19.62 27.322 23.993 4.367 1.979 17.127 4.687 19.505 7.991 3.187 4.437-2.748 8.597 3.908 11.717 2.126.992 6.511 1.195 8.342-.864 2.976-3.35-1.21-4.109-1.922-7.981-1.38-7.457.894-4.495 4.643-7.264 7.644-5.644 5.923-5.987 3.173-14.98-1.278-4.188-6.093-15.868-1.858-18.956 5.526-4.035 17.309 2.183 21.546 2.703 4.931.605 7.728 7.436 10.416 10.229 1.786 1.855 4.978 5.792 8.095 5.365 4.95-.676 2.879-5.002 5.748-6.997 7.7-5.344 9.728 1.912 12.797 9.168 2.887 6.815 5.618 9.344 10.756 13.715 2.387 2.036 12.846 9.3 11.859 13.773-.67 3.016-12.616 7.59-15.81 8.603-11.68 3.696-33.583-6.056-35.937 12.464 4.53-1.69 17.416-12.218 21.283-7.227 1.763 2.265-1.397 5.563-.653 7.81 2.204 6.742 7.402 4.394 12.853 3.303-.37.232-.752.435-1.153.614 7.448-3.83 6.674-3.028 10.09-9.239 1.116-2.027 2.778-6.937 4.35-8.388 5.416-4.981 6.249-1.552 9.601 2.292.879 1.012 9.172 12.952 6.22 12.359-9.645-1.936-18.907-1.678-26.907 3.597-4.609 3.044-8.969 7.152-14.474 9.175-1.319.482-11.09 1.408-9.935-.26 1.685-2.427 7.49-4.038 9.779-6.658-6.346-2.613-11.639 3.156-16.627 6.531-5.29 2.504-6.521 7.17-11.027 11.26-1.968 1.783-5.686 2.084-7.617 4.433-1.875 2.278-2.108 5.858-3.883 8.022-1.245 1.513-4.437.597-5.737 2.88-1.693 2.982 1.55 5.748.839 7.897-1.302 3.903-8.724 7.212-11.579 10.021.381-.366.761-.744 1.133-1.125-2.861 3-6.48 5.208-8.713 8.681 1.025 4.903 4.257 16.595 3.356 19.286-2.973 8.853-8.752-4.814-11.096-8.343-8.052-12.135-24.144-4.013-35.137-3.008-14.059 1.285-27.83 19.533-19.159 34.345 4.164 7.104 11.165 9.851 19.2 8.207 7.148-1.463 9.296-11.465 16.027-11.647 12.373-.329.273 12.124-.796 16.694-.99 4.233 1.542 4.626 5.9 5.673 3.218.77 7.776-1.376 10.564.461 1.758 1.162 1.673 7.512 4.092 5.508-4.76 3.944-3.65 13.296 1.23 16.679 5.41 3.75 11.78.276 17.443 1.717 10.69 2.728 5.587-.813 14.976-6.482 6.337-3.82 7.377.72 11.708.736 2.948.01 4.821-4.239 9.75-2.999 4.017 1.01 5.606 4.112 10.403 4.825 1.966.29 3.998-.738 5.872-.533 8.872.985 15.664 6.656 22.656 11.78 5.762 4.219 9.579 3.365 16.307 5.29 4.919 1.4 13.99 8.515 13.525 14.762-.082 1.116-4.38 6.737-5.114 9.267 1.258.873 10.009-1.084 12.569-1.271-.841.981-6.801 5.168-6.801 2.945 0 1.138 4.217 3.479 5.244 4.208 3.108-10.093 8.213-3.6 14.356-1.1 5.224 2.127 11.654 2.242 17.225 3.568 4.73 1.128 15.161 4.32 18.665 8.186 4.219 4.652 1.302 12.209-1.82 16.84-4.082 6.068-10.24 8.4-12.786 15.537-2.012 5.659-.502 11.375-1.652 17.648-1.555 8.49-2.802 5.513-8.268 10.696-4.602 4.36-.078 3.603-6.342 6.383-6.293 2.798-11.832 1.965-16.189 8.866.175-.433.317-.869.439-1.322-1.838 2.571-2.759 7.841-3.628 9.568-2.198 4.41-5.226 7.193-8.699 10.866-1.332 1.407-13.57 18.125-14.277 16.782-.91-1.746-10.559 1.756-11.019-.736.384 2.093-.092 1.392 2.305 2.6-2.22 13.738-8.03 15.788-21.524 15.928 1.16 6.603-4.889 5.285-7.701 8.837-1.643 2.075-2.428 7.902-3.567 10.588-.712 1.685-5.98 8.441-5.98 9.784-.005 1.232 1.771 3.039 3.436 4.77-9.51 1.882-19.212 3.195-29.064 3.995 1.844-2.324 2.288-4.365-3.585-4.645 1.572-4.27 5.261-6.707 6.827-10.844.742-1.952.128-2.724.756-4.656 2.149-6.678 1.217-4.16.004-9.347-2.836-12.15 1.01-15.476 4.324-26.602 3.4-11.439 3.084-26.263 5.262-38.58 1.034-5.896 2.73-18.158.682-23.732-2.307-6.275-12.454-11.216-17.102-15.438-6.578-5.992-10.076-12.472-14.96-19.88-2.481-3.762-5.308-7.453-7.241-11.548-4.137-8.746.003-3.538.699-8.702.666-4.99-.595-9.447 1.388-14.684 2.189-5.79 7.658-9.396 9.454-15.235 1.618-5.196.387-11.727-4.952-13.461-2.974-.97-6.256 1.265-9.245.776-4.17-.676-8.887-3.787-12.157-6.276-4.567-3.478-6.279-9.134-11.143-12.43-4.07-2.752-6.965-1.104-11.32-2.39-4.541-1.339-7.345-6.942-11.01-8.698-5.498-2.628-8.595 1.147-14.4.384-4.935-.646-12.462-6.118-17.074-8.182-9.377-4.198-15.09-8.83-18.837-18.347-3.212-8.163-7.894-11.97-13.407-18.768-5.584-6.888-7.335-12.755-15.944-14.592-1.01-.219 2.107 7.233 2.428 7.827 3.077 5.698 7.696 10.902 11.412 16.205 5.468 7.812 3.139 9.279-2.423 1.723-6.36-8.64-13.74-17.235-19.257-26.386-2.085-3.461-1.684-5.697-5.124-8.982-3.325-3.172-7.673-4.716-11.02-7.734-12.042-10.83-14.232-25.288-12.858-40.726.446-5.031 2.264-9.056 1.462-13.892-.661-4.018-3.034-7.339-5.995-10.299-.956-1.517-3.351-5.264-3.491-5.503-2.733-4.54-4.859-9.006-9.203-12.734-2.49-2.143-8.938-7.16-15.008-11.363 27.272-34.01 62.957-60.968 103.894-77.704.327 2.056 1.21 4.112 2.535 6.077 3.367 4.994 6.573 4.598 13.143 5.983-.703 7.621-9.618 7.683-15.651 6.855-7.201-.984-14.779-3.379-21.019 2.933 3.447 2.073 12.904 10.141 11.65 1.71 6.897-.346 13.566-.553 20.317.273 2.705.333 11.765 3.373 14.223 1.986 1.029-.582 2.129-5.666 3.218-7.232-1.924.012-3.988-.96-5.904-.774 4.471-5.723 8.924-1.236 14.612 1.397-6.262 3.807-2.549 12.925 3.575 5.516 5.028-6.093-1.232-10.513-7.617-14.063 6.438-8.053 10.41-8.782 16.469.311 1-5.608 5.523-3.363 10.253-2.95v-1.4c-2.082.047-4.305-1.15-6.365-.933 4.817-7.686 1.741-9.444 8.63-11.952 5.485-1.997 21.133-.138 23.06-5.294-10.951 2.13-24.18 2.638-34.06 7.617-4.26 2.148-9.334 8.924-13.589 4.517-4.36-4.517 3.119-11.784 6.946-14h-.916a257.807 257.807 0 0 1 53.681-5.661c11.897 0 23.587.877 35.063 2.447-3.972 2.085-1.035 3.494-3.927 5.625-5.524 4.061-15.33 7.452-21.903 10.02 8.355-.023 28.582 7.835 32.474-3.887-2.698-.412-5.388-.829-8.083-1.244 5.035-3.338 10.65-6.04 16.548-8.021 53.207 10.543 100.533 37.53 136.535 75.401-.256-.005-.512-.013-.76-.005zM291.112.003C130.333.003 0 130.336 0 291.113c0 160.778 130.333 291.114 291.112 291.114 160.776 0 291.115-130.336 291.115-291.114 0-160.777-130.339-291.11-291.115-291.11zm108.91 364.113c-.694-.11-2.249.092-2.865-.359-.378 1.311.195 1.806 2.864.359zm-2.865-.359c.006 0 .006-.004.006-.006-.016-.008-.067-.008-.078-.026.016.018.056.018.072.032zM285.35 241.673c.031-.049.075-.092.107-.14a19.258 19.258 0 0 1-.261-1.433c.054.523.11 1.047.154 1.573"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-hammer',
    name: 'Hammer',
    tags: ['tool'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 572.613 540.08"
        height="540.08"
        width="572.613"
      >
        <path
          d="M504.039 134.113c-10.836-10.83-15.722-25.325-14.766-39.489l-18.176-18.172S360.257-50.805 230.751 23.059l6.128 7.676 48.294-7.499-39.798 18.144 7.454 9.336c53.747-8.088 150.623 30.604 118.684 70.635l-94.404 94.397-.202-.204a50.574 50.574 0 0 1-22.431 12.424L0 460.421l79.67 79.659 231.942-253.921c2.108-8.876 6.565-17.31 13.492-24.23.857-.861 1.77-1.634 2.68-2.424l101.224-101.221.003.003c13.005.032 26.91 4.096 36.837 14.018 10.368 10.366 15.28 24.084 14.847 37.664l29.949 29.948 61.963-61.956-29.082-29.082c-14.164.954-28.658-3.934-39.486-14.766"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-hand-active-alt',
    name: 'Hand active alt',
    tags: ['grab'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 380.373 393.507"
        height="393.507"
        width="380.373"
      >
        <path
          d="M211.108.007c-2.648 0-5.463.121-8.359.362-15.465 1.283-27.117 5.696-35.63 11.908C157.283 4.921 145.053.592 131.784.592c-.7 0-1.411.013-2.115.04-15.737.572-30.29 7.221-41.005 18.736-10.717 11.524-16.302 26.53-15.724 42.265l.004.139.006.147 1.169 25.67a58.764 58.764 0 0 0-15.187-1.994c-5.074 0-10.14.66-15.058 1.956-15.202 4.02-27.938 13.716-35.85 27.308-7.915 13.594-10.064 29.457-6.047 44.664l1.046 3.974 1.98 3.594 54.304 98.747c17.013 30.686 35.853 50.062 49.18 61.19l.254 33.348.251 33.13H322.671l.437-32.942.576-43.252 48.197-152.019.282-.888.23-.897 1.248-4.83c3.599-13.893 6.443-24.867 6.711-35.643.644-25.638-14.179-38.815-23.076-44.39-6.53-4.089-13.487-7.98-21.148-10.386-2.477-19.562-16.853-39.511-52.192-45.792-5.297-.944-10.067-1.404-14.573-1.404-4.299 0-8.408.437-12.288 1.288C248.939 9.788 234.305.007 211.108.007zm0 33.384c11.32 0 19.743 3.573 20.75 15.681l1.345 28.359c2.572 10.328 5.596 13.584 8.374 13.584 4.739 0 8.792-9.459 8.792-9.459l2.272-12.723c1.891-10.684 7.772-14.386 16.722-14.386 2.649 0 5.565.325 8.732.892 13.87 2.464 27.224 8.572 24.773 22.436l-1.763 9.886v-.01s-9.06 33.053-4.557 33.053c1.081 0 2.933-1.885 5.872-6.57-.003-.026-.003-.026.027-.042l6.956-7.765c3.221-5.138 7.044-7.126 11.304-7.126 5.636 0 12.038 3.474 18.841 7.73 11.93 7.477 7.55 20.865.508 48.269l-49.69 156.724-.638 48.2H142.124l-.383-50.159s-28.377-15.477-53.183-60.216l-54.301-98.748c-3.6-13.622 4.532-27.574 18.144-31.169a25.533 25.533 0 0 1 6.531-.847c11.295 0 21.622 7.548 24.633 18.988l15.532 34.954c4.018 3.15 6.687 4.902 8.408 4.902 5.988 0 .532-21.237.532-79.134l-1.735-38.288c-.518-14.091 10.49-25.903 24.55-26.414.31-.01.624-.014.932-.014 13.67 0 24.987 10.825 25.488 24.582 0 0 .65 13.266.65 14.99 0 10.705 8.535 19.661 15.46 19.661 4.73 0 8.713-4.175 8.713-14.823l-1.074-25.096c-1.164-14.026 10.463-18.486 24.508-19.657a68.508 68.508 0 0 1 5.579-.245"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-hand-active',
    name: 'Hand active',
    tags: ['grab'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 340.213 345.8"
        height="345.8"
        width="340.213"
      >
        <path
          d="M326.599 75.57c-7.566-4.73-16.415-9.767-25.932-9.767-1.776 0-3.747.173-5.83.648l1.138-6.375c1.272-7.204 2.46-31.17-35.584-37.935-4.13-.734-7.752-1.094-11.07-1.094-10.573 0-18.757 3.781-23.998 10.88l-.168-3.531-.008-.235-.022-.237c-.694-8.4-5.41-27.93-34.06-27.93-2.082 0-4.33.097-6.681.291C157.787 2.496 150 15.361 148.096 25.557 142.553 10.907 128.389.581 111.746.581c-.48 0-.967.007-1.45.023-10.338.376-19.94 4.765-27.005 12.365-7.074 7.598-10.757 17.503-10.375 27.886l1.724 38.077c.005 12.184.245 22.68.568 31.743-5.66-14.956-20.06-25.09-36.318-25.09-3.349 0-6.69.436-9.934 1.295-10.036 2.644-18.437 9.041-23.664 18.016-5.222 8.968-6.638 19.435-3.987 29.47l.418 1.586.793 1.44 54.301 98.752c19.238 34.703 40.805 53.23 51.597 61.007l.317 35.414.12 13.235h173.984l.2-13.145.613-38.607 49.1-154.859.112-.348.09-.36 1.262-4.878c6.63-25.595 11.873-45.822-7.613-58.032"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-hand-pointer-alt',
    name: 'Hand pointer alt',
    tags: ['click'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 418.933 527.227"
        height="527.227"
        width="418.933"
      >
        <path
          d="M170.348 0c-.705 0-1.416.01-2.121.036-15.734.57-30.286 7.224-41 18.74-10.587 11.377-16.164 26.156-15.745 41.675l1.732 161.83c-.004 10.826-.12 19.842-.317 27.358L96.366 236.65a58.903 58.903 0 0 0-37.49-13.498 58.805 58.805 0 0 0-44.99 20.878c-20.957 24.8-17.839 62.026 6.956 82.988l80.218 67.827c16.122 27.447 33.468 45.133 45.97 55.573l.275 43.63.204 33.178h213.807l.356-33.018.588-53.53 48.184-151.984.283-.886.228-.89 1.249-4.831c3.601-13.895 6.441-24.87 6.712-35.645.65-25.64-14.179-38.82-23.077-44.399-6.524-4.084-13.48-7.979-21.146-10.38-2.481-19.56-16.858-39.513-52.19-45.788-5.299-.945-10.072-1.407-14.58-1.407-4.296 0-8.4.442-12.28 1.288-8.136-12.558-22.779-22.349-45.986-22.349-2.63 0-5.426.125-8.317.363-4.195.349-8.133.906-11.833 1.685-.127-31.432-.252-60.868-.282-67.63l-.004-.535-.018-.54C228.039 24.925 202.187 0 170.348 0zm0 33.383c13.67 0 24.985 10.824 25.492 24.586 0 0 .647 153.148.647 154.87 0 7.589 4.29 11.482 9.256 11.482 6.818 0 14.913-7.34 14.913-22.526l-1.068-25.095c-1.167-14.03 10.459-18.49 24.505-19.656a67.604 67.604 0 0 1 5.564-.247c11.334 0 19.76 3.564 20.766 15.679l1.342 28.36c1.81 8.028 4.76 10.499 7.704 10.499 4.739 0 9.466-6.372 9.466-6.372l2.27-12.72c1.895-10.688 7.768-14.388 16.718-14.388 2.65 0 5.57.325 8.737.89 13.867 2.463 27.224 8.578 24.772 22.435l-1.764 9.89v-.014s-9.676 28.077-2.479 28.077c.951 0 2.196-.488 3.796-1.594.02-.012-.005-.018.026-.039l6.953-7.765c3.223-5.139 7.05-7.126 11.313-7.126 5.636 0 12.039 3.47 18.839 7.73 11.927 7.474 7.55 20.861.507 48.265l-49.69 156.73-.64 58.51H180.685l-.378-60.474s-28.378-15.473-53.185-60.214l-84.727-71.628c-10.759-9.099-12.103-25.192-3.014-35.944 5.046-5.965 12.245-9.045 19.494-9.045a25.354 25.354 0 0 1 16.444 6.032l48.467 38.073c3.656 2.87 6.77 4.397 9.41 4.397 10.343 0 13.403-23.55 13.403-82.942l-1.732-162.284c-.524-14.092 10.488-25.908 24.552-26.414.309-.01.618-.018.929-.018"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-hand-pointer',
    name: 'Hand pointer',
    tags: ['click'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 372.16 462.547"
        height="462.547"
        width="372.16"
      >
        <path
          d="M360.09 198.48c-7.16-4.48-15.515-9.257-24.158-9.257-2.993 0-6.648.573-10.339 2.566.13-.494.262-.978.395-1.456l.121-.44.083-.436 1.755-9.888c1.46-8.237 1.162-28.012-32.879-34.058-3.93-.698-7.36-1.039-10.484-1.039-14.553 0-23.993 8.04-26.587 22.653l-.028.167-.885-18.655-.008-.184-.016-.169c-.768-9.293-5.787-24.872-30.735-24.872-2.009 0-4.098.092-6.402.281-31.087 2.586-34.472 19.996-33.675 30.279l.104 2.452c-1.153 4.344-2.3 5.436-3.305 6.201-.175-43.125-.512-123.473-.535-128.064v-.164l-.008-.162A35.4 35.4 0 0 0 147.009.004c-.425 0-.845.008-1.274.021-9.498.34-18.269 4.352-24.733 11.298-6.416 6.9-9.783 15.865-9.497 25.269l1.737 162.243c0 39.853-1.633 63.998-4.852 71.838a28.713 28.713 0 0 1-1.762-1.277L58.31 231.44a35.533 35.533 0 0 0-22.778-8.279 35.467 35.467 0 0 0-27.139 12.587c-6.122 7.247-9.061 16.441-8.265 25.896.791 9.455 5.216 18.035 12.466 24.159l83.337 70.456c19.621 34.758 41.334 52.494 51.061 59.243l.336 37.113.09 9.932h167.389l.157-9.862.616-39.093 49.244-155.325.088-.263.067-.273 1.265-4.888c6.532-25.226 11.256-43.447-6.153-54.363"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-handtool-alt',
    name: 'Handtool alt',
    tags: ['hover'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 476.6 536.587"
        height="536.587"
        width="476.6"
      >
        <path
          d="M232.641.003c-1.613 0-3.254.068-4.869.202-32.399 2.687-56.543 31.198-53.852 63.546l.028.314C163.06 52.008 147.405 44.76 130.273 44.76c-5.853 0-11.676.877-17.296 2.598-15.034 4.62-27.37 14.812-34.735 28.711-7.373 13.901-8.883 29.845-4.252 44.885l40.728 132.667c2.936 9.585 5.007 17.585 6.457 24.21l-24.8-19.48a58.914 58.914 0 0 0-37.459-13.473h-.015a58.826 58.826 0 0 0-44.98 20.868C3.765 277.765-1.103 293.013.212 308.688c1.312 15.675 8.656 29.899 20.666 40.052l80.215 67.817c16.133 27.482 33.49 45.172 45.993 55.604l.25 31.303.262 33.123H361.25l.458-32.923.528-38.176c24.401-48.223 34.529-101.717 37.293-118.728l69.325-146.607c15.595-27.253 6.982-62.322-19.857-79.14a58.782 58.782 0 0 0-31.241-8.986c-8.26 0-16.236 1.689-23.52 4.849l2.317-13.023c5.653-31.996-15.741-62.614-47.687-68.29a59.313 59.313 0 0 0-10.325-.912c-18.975 0-36.09 9-46.919 23.28l-.325-3.934C288.781 23.724 263.016.003 232.641.003zm0 33.385c13.135 0 24.28 10.063 25.384 23.375l13.771 165.789c2.577 10.333 5.595 13.587 8.376 13.587 4.74 0 8.793-9.454 8.793-9.454l24.488-137.618c2.19-12.339 12.956-21.03 25.087-21.03 1.479 0 2.981.13 4.488.395 13.867 2.47 23.105 15.712 20.653 29.575l-23.98 134.78v-.011.013-.002c.016.53.624 20.036 7.156 20.036 2.243 0 5.179-2.295 9.027-8.427-.004-.027-.004-.027.025-.044l40.199-86.972c4.844-7.725 13.15-11.968 21.647-11.968 4.628 0 9.305 1.255 13.514 3.89 11.93 7.48 15.544 23.229 8.072 35.17L367.26 336.893s-8.904 66.218-38.299 120.16l-.637 46.15H180.719l-.382-48.115s-28.378-15.472-53.181-60.21L42.43 323.244c-10.759-9.092-12.105-25.185-3.015-35.938 5.046-5.968 12.249-9.039 19.496-9.039a25.346 25.346 0 0 1 16.441 6.021l48.468 38.075c5.089 3.99 11.41 6.89 17.208 6.89 14.7 0 26.063-18.629 5.603-85.437l-40.733-132.673c-4.146-13.483 3.427-27.737 16.878-31.868a25.359 25.359 0 0 1 7.497-1.132c10.911 0 21.007 7.055 24.382 18.025l40.36 131.492c.442.815.941 1.931 1.502 3.563 2.991 8.527 11.062 21.272 17.088 21.272 4.542 0 7.919-7.239 7.084-28.977l-13.502-162.53c-1.163-14.028 9.266-26.348 23.313-27.512.72-.06 1.432-.089 2.141-.089"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-handtool',
    name: 'Handtool',
    tags: ['hover'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 429.867 489.84"
        height="489.84"
        width="429.867"
      >
        <path
          d="M413.221 117.441a35.49 35.49 0 0 0-18.833-5.418c-12.327 0-23.592 6.224-30.132 16.662l-.34.538-.268.577-37.25 80.59c-.006-.098-.015-.195-.015-.29l23.789-133.715c3.41-19.292-9.492-37.761-28.759-41.19a35.714 35.714 0 0 0-6.245-.552c-17.236 0-31.935 12.325-34.95 29.298l-22.482 126.351-13.099-157.728c-1.513-18.267-17.05-32.567-35.37-32.567-.974 0-1.968.038-2.952.115-19.538 1.624-34.096 18.819-32.476 38.328l13.478 162.293c.21 5.675.102 9.854-.146 12.903-1.739-2.692-3.47-5.96-4.57-9.105-.518-1.488-1.057-2.822-1.636-4.019L140.861 69.853c-4.62-15.016-18.264-25.101-33.96-25.101-3.524 0-7.041.524-10.43 1.572-9.068 2.783-16.508 8.932-20.952 17.313-4.444 8.386-5.357 18-2.561 27.072l40.73 132.676c16.244 53.03 9.796 67.575 7.431 70.766-.916 1.248-1.858 1.708-3.458 1.708-3.064 0-7.293-1.822-11.034-4.755l-48.312-37.952a35.512 35.512 0 0 0-22.774-8.279 35.477 35.477 0 0 0-27.147 12.592c-6.12 7.243-9.059 16.443-8.267 25.894.798 9.452 5.22 18.032 12.466 24.162l83.341 70.458c19.621 34.742 41.33 52.482 51.062 59.236l.335 42.692.081 9.933h167.42l.133-9.876.591-42.547c38.659-46.62 38.928-108.106 38.459-121.876l70.778-149.67c9.952-16.544 4.836-38.147-11.572-48.43"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-hd',
    name: 'Hd',
    tags: ['resolution', 'high definition'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 589.48 327.653"
        height="327.653"
        width="589.48"
      >
        <path
          d="M494.983 215.6c-5.464 13.616-12.644 23.018-21.335 29.17-8.719 6.126-19.296 9.335-32.861 9.374H391.48V73.52h49.306c13.681-.008 24.557 1.985 32.63 5.467 8.112 3.522 13.495 8.249 17.319 14.709 8.472 14.347 13.387 36.73 13.355 67.004.008 21.713-3.148 39.99-9.108 54.9zm88.424-112.347c-4.175-19.088-12.067-36.936-23.506-53.272-14.482-20.562-33.977-35.106-57.5-42.789-14.034-4.61-30.826-6.884-50.598-7.181H309.008v327.642h143.678c48.74.004 87.369-21.55 110.795-62.373 17.515-30.239 26.022-66.753 26-108.959 0-16.95-2.038-34.638-6.074-53.068zm-400.011 14.018H83.942V.005H0v327.64h83.942V190.36h99.454v137.286h83.948V.006h-83.948V117.27"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-headphones',
    name: 'Headphones',
    tags: ['audio', 'ear buds', 'music', 'quiet'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 593.053 492.493"
        height="492.493"
        width="593.053"
      >
        <path
          d="M546.312 400.204v-103.68c-.015-69.05-27.923-131.352-73.161-176.617-45.272-45.244-107.572-73.159-176.63-73.159-69.049 0-131.348 27.915-176.624 73.159-45.233 45.265-73.145 107.566-73.159 176.617v103.68h.008H0v-103.68C.016 132.748 132.748.021 296.521.004c163.784.017 296.512 132.744 296.531 296.52v103.68h-46.74"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-help-alt',
    name: 'Help alt',
    tags: ['assist', 'manual'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 580.827 580.827"
        height="580.827"
        width="580.827"
      >
        <path
          d="M290.413 50.072c-132.521 0-240.337 107.813-240.337 240.335 0 132.525 107.816 240.34 240.337 240.34 132.522 0 240.335-107.815 240.335-240.34 0-132.522-107.813-240.335-240.335-240.335zm0-50.077c160.394 0 290.415 130.025 290.415 290.412 0 160.394-130.021 290.42-290.415 290.42C130.023 580.827 0 450.8 0 290.407 0 130.02 130.023-.005 290.413-.005"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-help',
    name: 'Help',
    tags: [],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 565.52 565.533"
        height="565.533"
        width="565.52"
      >
        <path
          d="M477.33 477.344c-38.846 38.79-80.742 54.754-117.92 54.785-16.889-.01-32.838-3.329-47.26-9.46.085-.084.167-.155.249-.234.06-.063.096-.132.154-.19 109.364-13.474 196.203-100.081 209.691-209.712.05-.054.117-.082.167-.136.08-.08.157-.164.24-.246 6.145 14.425 9.468 30.385 9.481 47.281-.037 37.185-16.016 79.068-54.803 117.912zm-195.387-97.71c-25.919-.231-49.755-10.277-68.131-28.797-18.13-18.462-27.855-42.181-27.928-68.05 0-.083.008-.235.008-.47v-.194c.236-52.886 43.939-96.334 96.803-96.232h.917c25.836.23 49.693 10.293 68.084 28.829 18.113 18.42 27.872 42.123 27.921 67.89v.782c-.197 52.877-43.944 96.344-96.814 96.241zM206.1 532.14c-37.188-.02-79.088-16.01-117.914-54.787-38.791-38.849-54.77-80.76-54.804-117.941.015-16.896 3.338-32.853 9.48-47.27.084.082.163.175.25.26.047.046.1.074.144.12 13.457 109.37 100.066 196.205 209.691 209.726.057.057.095.128.15.187.087.082.173.158.257.243-14.416 6.134-30.367 9.451-47.254 9.462zm-10.8-342.97l-.66.653c-50.7 50.713-50.944 133.481-.548 184.524l-56.99 56.284c-81.568-82.583-81.08-215.512.893-297.472zM88.177 88.177c38.836-38.781 80.718-54.756 117.896-54.784 16.895.012 32.851 3.335 47.282 9.481-.087.08-.175.159-.263.247-.039.037-.065.087-.105.128C143.604 56.712 56.745 143.36 43.257 252.998c-.044.046-.097.075-.143.12-.088.083-.167.174-.25.26-6.143-14.413-9.466-30.36-9.481-47.249.034-37.186 16.013-79.092 54.794-117.953zM427.27 433.568l-57.324-56.008.662-.65c50.729-50.717 50.962-133.486.561-184.529l56.993-56.28c81.582 82.578 81.059 215.502-.892 297.467zm-67.852-400.18c37.174.032 79.059 15.999 117.907 54.784 38.795 38.856 54.768 80.757 54.803 117.932-.014 16.893-3.336 32.85-9.482 47.27-.08-.082-.157-.169-.237-.253-.052-.048-.113-.085-.17-.134-13.469-109.4-100.11-196.251-209.733-209.739-.036-.039-.062-.087-.106-.128-.084-.088-.175-.167-.259-.247 14.427-6.146 30.388-9.469 47.277-9.485zm185.775 249.375c13.175-22.666 20.339-48.98 20.321-76.659.028-46.915-20.438-97.472-64.592-141.54C456.883 20.443 406.331-.031 359.417.003c-27.684-.016-54 7.145-76.669 20.325-22.675-13.18-48.997-20.341-76.675-20.33-46.914-.025-97.466 20.449-141.505 64.57C20.442 108.636-.034 159.205 0 206.129c-.02 27.666 7.14 53.972 20.318 76.63C7.134 305.42-.021 331.737 0 359.412c-.034 46.927 20.457 97.492 64.568 141.544 44.039 44.135 94.608 64.604 141.533 64.577h.092c27.646 0 53.927-7.153 76.567-20.314 22.664 13.161 48.968 20.314 76.65 20.297h.08c46.89.005 97.415-20.456 141.442-64.56 44.14-44.052 64.607-94.604 64.587-141.524.014-27.683-7.15-54.001-20.327-76.67"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-home',
    name: 'Home',
    tags: ['house', 'dwelling', 'safe'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 612.733 582.52"
        height="582.52"
        width="612.733"
      >
        <path
          d="M87.888 380.964V582.52h156.148V399.368h124.667V582.52h156.15V380.952L306.405 162.493zM306.405-.001L0 306.36l57.634 57.645 248.782-248.718 248.69 248.702 57.63-57.62L306.406 0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-inactive-line',
    name: 'Inactive line',
    tags: ['geometry', 'math'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 569.013 569.013"
        height="569.013"
        width="569.013"
      >
        <path
          d="M539.996 569.013L0 29.016 29.016-.003l540 540.003-29.02 29.013"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-inbox',
    name: 'Inbox',
    tags: ['mail', 'email', 'messages'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 588.627 525.96"
        height="525.96"
        width="588.627"
      >
        <path
          d="M337.905 104.552h-81.79v97.176H179.36l117.657 142.553 117.654-142.553h-76.766zm65.471 210.947v70.106c0 18.438-14.948 33.386-33.381 33.386h-151.35c-18.437 0-33.386-14.948-33.386-33.386V315.5H65.007L162.38 63.443h263.956l98.542 252.056zM469.646.003H118.89L0 307.767V525.96h588.632V304.37L469.647.002"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-indent',
    name: 'Indent',
    tags: ['text editor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 583.227 460.147"
        height="460.147"
        width="583.227"
      >
        <path
          d="M225.541 110.804V.003h357.687v110.801H225.541M225.541 285.473V174.677h357.687v110.796H225.541M225.541 460.147V349.348h357.687v110.799H225.541M144.388 230.08L0 314.144V146.005z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-infinity',
    name: 'Infinity',
    tags: ['forever'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 587.427 292.44"
        height="292.44"
        width="587.427"
      >
        <path
          d="M358.756 176.36c16.41 20.305 32.732 34.995 49.76 42.515 9.817 4.338 20.068 6.749 32.69 6.793 18.793.123 39.378-8.673 54.678-23.612 15.364-14.96 24.799-34.775 24.768-55.828-.01-21.825-8.963-41.51-23.608-56.107-14.673-14.545-34.527-23.357-55.837-23.342-16.512.093-29.078 4.089-41.727 11.514-12.541 7.451-24.877 18.914-37.173 33.544-8.712 10.25-17.222 21.956-25.903 34.419 7.484 10.745 14.847 20.93 22.352 30.104zm-212.539 49.308c17.715-.077 31.286-4.26 44.555-11.797 13.183-7.54 25.873-19 38.403-33.56 8.841-10.154 17.409-21.739 26.076-34.071-7.492-10.672-14.915-20.776-22.53-29.885-16.693-20.202-33.468-34.896-51.529-42.594-10.41-4.438-21.455-6.95-34.975-6.982-20.056-.06-40.276 8.733-55.26 23.477-15 14.784-24.197 34.527-24.182 55.972.152 44.175 34.693 79.324 79.442 79.44m0 66.772c-40.547.037-77.456-16.386-103.744-42.885C16.115 223.124-.027 186.332 0 146.228.008 105.34 17.588 68.681 44.183 42.616 70.782 16.52 106.98.066 146.217-.003c29.276-.084 55.75 7.892 77.82 20.68 22.16 12.758 40.096 29.776 55.699 47.867 5.573 6.512 10.892 13.195 16.015 19.937a496.182 496.182 0 0 1 11.196-14.454c19.717-24.236 43.022-47.339 74.392-61.428C399.172 4.6 419.459-.036 441.207.005c79.784.22 145.932 65.004 146.221 146.223-.037 41.26-18.325 77.855-45.03 103.734-26.778 25.892-62.598 42.355-101.191 42.478h-.527c-28.388 0-54.117-8.132-75.424-20.939-21.528-12.861-38.863-29.865-54.065-47.885-5.355-6.41-10.491-12.972-15.454-19.604a479.736 479.736 0 0 1-11.58 14.684c-20.216 24.348-44.39 47.433-76.609 61.34-18.316 7.905-39.05 12.441-61.33 12.404"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-info',
    name: 'Info',
    tags: ['help', 'assistance'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 270.76 535.8"
        height="535.8"
        width="270.76"
      >
        <path
          d="M147.241 65.433c0-35.989 31.078-65.43 67.076-65.43 32.742 0 56.448 22.072 56.448 55.621 0 37.644-31.07 65.459-67.885 65.459-33.533 0-55.639-22.102-55.639-55.65zm-44.166 161.148c5.723-14.713-1.643-22.072-8.19-22.072-30.25 0-69.54 71.166-84.231 71.166C4.906 275.675 0 269.932 0 265.028c0-14.724 35.988-49.073 46.643-59.71 32.704-31.082 75.254-54.806 122.704-54.806 35.157 0 72.8 21.26 43.352 100.628l-58.91 159.492c-4.886 12.273-13.886 32.741-13.886 45.823 0 5.72 3.25 11.46 9.796 11.46 24.529 0 69.541-69.546 80.997-69.546 4.081 0 9.801 4.9 9.801 12.263 0 23.724-95.694 125.168-178.325 125.168-29.45 0-49.898-13.895-49.898-44.985 0-39.255 27.807-106.342 33.56-120.259l57.24-143.975"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-iphone',
    name: 'Iphone',
    tags: ['mobile', 'phone', 'android'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 287.84 508.213"
        height="508.213"
        width="287.84"
      >
        <path
          d="M260.115 426.705H27.733V81.508h232.382zm-116.176 62.073c-13.031 0-23.624-10.554-23.624-23.591 0-13.02 10.593-23.595 23.624-23.595 13.024 0 23.582 10.574 23.582 23.595 0 13.037-10.558 23.591-23.582 23.591zm-24.201-457.25h48.366v16.064h-48.366zM250.813.001H37.003C16.564.001 0 16.581 0 37.02v434.175c0 20.44 16.563 37.018 37.004 37.018h213.81c20.471 0 37.022-16.578 37.022-37.018V37.02c0-20.439-16.55-37.019-37.023-37.019"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-key',
    name: 'Key',
    tags: ['safe', 'lock'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 282.08 569.693"
        height="569.693"
        width="282.08"
      >
        <path
          d="M141.039 147.299c-24.036 0-43.524-19.488-43.524-43.526 0-24.04 19.488-43.524 43.524-43.524 24.04 0 43.525 19.484 43.525 43.524 0 24.038-19.485 43.526-43.525 43.526zm0-147.294C63.15.005 0 63.155 0 141.048c0 55.184 31.714 102.936 77.892 126.107v47.63l2.647 3.331 47.48 47.48-50.127 50.128v2.615l46.174 46.173-43.527 43.523 61.658 61.658 61.991-61.99V267.156c46.18-23.171 77.892-70.923 77.892-126.107C282.08 63.155 218.93.005 141.039.005"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-keyboard',
    name: 'Keyboard',
    tags: ['computer'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.467 405.147"
        height="405.147"
        width="582.467"
      >
        <path
          d="M457.804 331.461h54.944v-54.934h-54.944zm.743-89.617h54.917V96.028h-92.056v54.904h37.139zm-302.375 89.617h268.73v-54.934h-268.73zm-87.833 0h54.915v-54.934H68.339zM291.904 186.34v54.917h54.944V186.34zm-87.39 0v54.917h54.9V186.34zm-32.433 0H68.463v54.917H172.08zm-49.827-91.27H67.34v54.909h54.913zm253.691 146.187h53.431V186.34h-53.43zm10.292-145.101h-54.945v54.904h54.945zm-86.896 0h-54.917v54.904h54.917zm-86.86 0h-54.94v54.904h54.94zm336.588 275.59H33.403V33.407h515.666zM0 .005v405.14h582.47V.007H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-laptop',
    name: 'Laptop',
    tags: ['computer'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 578.173 432.747"
        height="432.747"
        width="578.173"
      >
        <path
          d="M576.777 409.976H1.395L0 412.692c0 7.39 5.99 20.055 13.373 20.055h551.42c7.388 0 13.378-12.665 13.378-20.055zm-86.085-125.357H87.479V33.38h403.213zm33.387 22.606c0-.445-.088-.866-.134-1.3.046-.44.134-.859.134-1.296V13.371C524.079 5.985 518.09 0 510.7 0H67.466C60.08 0 54.093 5.985 54.093 13.37v291.26c0 .436.09.855.132 1.295-.042.434-.132.855-.132 1.3l-.113.216h470.21zm-295.92 69.787l15.004-28.527h93.326l13.527 28.527zm304.269-53.51H45.745L9.633 393.91h558.906l-36.111-70.41"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-layout',
    name: 'Layout',
    tags: ['page', 'editor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.227 582.227"
        height="582.227"
        width="582.227"
      >
        <path
          d="M541.188 41.041H41.036v500.15h500.152V41.04zM582.221.005v582.222H0V.005h582.221"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-light-down',
    name: 'Light down',
    tags: ['darker', 'dim'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 443.4 443.4"
        height="443.4"
        width="443.4"
      >
        <path
          d="M221.707 129.7c50.809 0 91.998 41.188 91.998 91.992 0 50.817-41.189 92.003-91.998 92.003-50.812 0-92.003-41.186-92.003-92.003 0-50.804 41.19-91.992 92.003-91.992M198.333 57.055V23.36c0-12.901 10.466-23.365 23.367-23.365 12.904 0 23.376 10.464 23.376 23.365v33.695c0 12.904-10.472 23.372-23.376 23.372-12.901 0-23.367-10.468-23.367-23.372M198.333 420.028v-33.692c0-12.908 10.462-23.367 23.367-23.367 12.907 0 23.376 10.46 23.376 23.367v33.692c0 12.901-10.47 23.372-23.376 23.372-12.905 0-23.367-10.47-23.367-23.372M321.596 121.8c-9.125-9.127-9.125-23.93 0-33.047l23.828-23.829c9.127-9.127 23.923-9.127 33.048 0 9.13 9.139 9.13 23.928 0 33.048L354.64 121.8a23.271 23.271 0 0 1-16.52 6.847 23.28 23.28 0 0 1-16.524-6.847M64.935 378.459c-9.128-9.128-9.128-23.916 0-33.045l23.825-23.828c9.13-9.122 23.927-9.122 33.048 0 9.131 9.13 9.131 23.928 0 33.047L97.984 378.46a23.302 23.302 0 0 1-16.528 6.845 23.283 23.283 0 0 1-16.52-6.845M386.34 245.063c-12.903 0-23.368-10.464-23.368-23.371.01-12.905 10.465-23.37 23.368-23.37h33.693c12.908.01 23.372 10.475 23.372 23.38s-10.464 23.36-23.372 23.36H386.34M23.373 245.063C10.463 245.063 0 234.599 0 221.692c0-12.905 10.464-23.37 23.373-23.37h33.69c12.907.01 23.372 10.475 23.372 23.38s-10.465 23.36-23.372 23.36h-33.69M345.412 378.456l-23.816-23.827c-9.127-9.119-9.123-23.929.01-33.043 9.118-9.13 23.918-9.125 33.047.004l23.815 23.826c9.13 9.119 9.121 23.92-.005 33.05a23.264 23.264 0 0 1-16.515 6.838 23.32 23.32 0 0 1-16.536-6.848M88.757 121.8L64.938 97.972c-9.13-9.125-9.13-23.917 0-33.048 9.128-9.127 23.92-9.127 33.048 0l23.828 23.83c9.118 9.125 9.118 23.92-.007 33.046a23.286 23.286 0 0 1-16.525 6.847c-5.98 0-11.96-2.28-16.525-6.847"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-light-up',
    name: 'Light up',
    tags: ['lighter', 'brighten'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576.947 576.947"
        height="576.947"
        width="576.947"
      >
        <path
          d="M288.476 196.472c50.808 0 91.996 41.192 91.996 91.995 0 50.813-41.188 92-91.996 92-50.812 0-92-41.187-92-92 0-50.803 41.188-91.995 92-91.995M265.11 123.827V23.36c0-12.906 10.46-23.368 23.362-23.368 12.908 0 23.373 10.462 23.373 23.368v100.466c0 12.901-10.465 23.369-23.373 23.369-12.901 0-23.363-10.468-23.363-23.37M265.107 553.566v-100.46c0-12.907 10.46-23.365 23.369-23.365 12.904 0 23.365 10.458 23.365 23.364v100.461c0 12.906-10.461 23.38-23.365 23.38-12.91 0-23.37-10.474-23.37-23.38M388.37 188.573c-9.126-9.128-9.126-23.928 0-33.054l71.038-71.042c9.128-9.124 23.921-9.124 33.047 0 9.126 9.128 9.126 23.931 0 33.058l-71.038 71.038a23.306 23.306 0 0 1-16.524 6.838 23.31 23.31 0 0 1-16.524-6.838M84.492 492.444c-9.126-9.125-9.126-23.919 0-33.041l71.039-71.042c9.124-9.122 23.92-9.122 33.05 0 9.126 9.127 9.126 23.927 0 33.047l-71.038 71.036a23.294 23.294 0 0 1-16.527 6.846 23.292 23.292 0 0 1-16.524-6.846M453.11 311.84c-12.906 0-23.37-10.473-23.37-23.373 0-12.906 10.464-23.368 23.37-23.368h100.466c12.903 0 23.368 10.462 23.368 23.368 0 12.9-10.465 23.373-23.368 23.373H453.109M23.369 311.84C10.46 311.84 0 301.367 0 288.467c0-12.906 10.461-23.368 23.369-23.368h100.466c12.905 0 23.368 10.462 23.368 23.368 0 12.9-10.463 23.373-23.368 23.373H23.369M459.408 492.444l-71.04-71.036c-9.125-9.12-9.125-23.92 0-33.047 9.124-9.122 23.925-9.122 33.05 0l71.042 71.042c9.121 9.122 9.121 23.916 0 33.041a23.32 23.32 0 0 1-16.53 6.846c-5.98 0-11.96-2.282-16.522-6.846M155.525 188.573l-71.042-71.038c-9.117-9.127-9.117-23.93 0-33.058 9.136-9.124 23.93-9.124 33.058 0l71.038 71.042c9.128 9.126 9.128 23.926 0 33.054a23.31 23.31 0 0 1-16.528 6.838c-5.983 0-11.964-2.279-16.526-6.838"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-lightbulb-active',
    name: 'Lightbulb active',
    tags: ['lamp', 'active'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 313.853 557.787"
        height="557.787"
        width="313.853"
      >
        <path
          d="M120.85 557.787h72.127v-22.591h-72.126zM93.144 511.73h127.568v-39.962H93.143zm180.154-343.149c-1.498 15.468-6.03 30.559-13.485 44.872-6.292 11.276-63.241 115.35-64.367 189.702l-.154 1.522h-18.383v-72.904h-39.972v72.904h-18.378l-.153-1.522c-.839-55.702-32.589-129.039-60.061-182.288l-.067-.614-3.898-7.081c-7.642-13.859-12.297-28.875-13.844-44.625l-.569-12.444c.218-30.959 12.345-59.983 34.254-81.852 22.094-22.107 51.466-34.284 82.708-34.284 11.352 0 22.475 1.577 32.98 4.658 18.699 5.532 35.908 15.782 49.768 29.639 21.853 21.859 33.985 50.867 34.21 81.77zm-5.362-122.577c-18.578-18.577-41.636-32.29-66.686-39.699-14.324-4.204-29.221-6.3-44.321-6.3-41.94 0-81.31 16.308-110.981 45.999C16.28 75.614 0 115.017 0 156.934l.659 14.43c1.969 21.563 8.264 42.133 18.72 61.1.109 1.052 59.08 106.83 59.08 172.916l2.022 19.57c3.179 13.053 9.842 19.69 19.796 19.69H213.58c9.956 0 16.61-6.637 19.799-19.69l2.016-19.57c0-66.085 58.968-171.864 59.578-172.916 9.96-18.967 16.256-39.537 18.196-61.1l.688-14.43c0-41.917-16.314-81.32-45.922-110.93"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-lightbulb',
    name: 'Lightbulb',
    tags: ['lamp'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 322.28 572.76"
        height="572.76"
        width="322.28"
      >
        <path
          d="M321.595 175.979c-2.024 22.162-8.48 43.269-18.698 62.749-.629 1.09-61.182 109.701-61.182 177.565l-2.07 20.09c-3.272 13.394-10.093 20.204-20.341 20.204H102.961c-10.202 0-17.044-6.81-20.33-20.204l-2.056-20.09c0-67.864-60.57-176.474-60.685-177.565-10.71-19.48-17.195-40.587-19.205-62.75L0 161.16c0-43.03 16.74-83.495 47.182-113.924C77.635 16.775 118.09 0 161.151 0c15.486 0 30.778 2.196 45.488 6.505 25.742 7.576 49.405 21.664 68.481 40.731 30.416 30.43 47.164 70.877 47.164 113.924l-.69 14.819M95.636 525.488v-41.036h131.02v41.036H95.636M124.11 572.76v-23.192h74.067v23.192H124.11"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-link',
    name: 'Link',
    tags: ['url'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 533.867 565.667"
        height="565.667"
        width="533.867"
      >
        <path
          d="M288.607 391.817c-36.422.042-72.928-14.228-100.431-41.757l-4.355-4.355 62.379-62.398 4.361 4.356c10.739 10.714 24.312 15.886 38.046 15.922 14.386-.057 28.116-5.238 38.83-15.922l102.268-102.268c10.699-10.734 15.879-24.408 15.927-38.527-.048-13.993-5.22-27.63-15.913-38.359l-4.358-4.354c-10.732-10.7-24.377-15.871-38.436-15.924-14.066.053-27.713 5.224-38.446 15.924l-42.05 42.057c-17.221 17.23-45.156 17.23-62.384 0-17.232-17.225-17.232-45.156-.006-62.384l42.056-42.059C313.82 14.007 350.576-.045 386.925 0c36.342-.045 73.094 14.007 100.824 41.77l4.355 4.35c27.71 27.683 41.81 64.388 41.759 100.748.05 36.333-13.966 73.13-41.767 100.912L389.824 350.047c-27.887 27.922-64.784 41.77-100.99 41.77h-.227"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-list',
    name: 'List',
    tags: [],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 357.667 460.133"
        height="460.133"
        width="357.667"
      >
        <path
          d="M0 110.79V0h357.673V110.79H0M0 285.47V174.663h357.673v110.805H0M0 460.133V349.33h357.673v110.804H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-load',
    name: 'Load',
    tags: [],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 445.813 410.533"
        height="410.533"
        width="445.813"
      >
        <path
          d="M0 410.533v-110.8h444.987v110.8H0M224.815 221.007L3.802-.004H445.82z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-loading',
    name: 'Loading',
    tags: ['waiting'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 304.8 447.547"
        height="447.547"
        width="304.8"
      >
        <path
          d="M168.17 212.816v-62.475h-33.38l-.009 95.864H247.44v-33.389zm68.382 100.85c-21.592 21.565-51.239 34.849-84.15 34.857-32.921-.008-62.572-13.292-84.159-34.856-21.562-21.599-34.847-51.243-34.856-84.16.009-32.915 13.294-62.567 34.856-84.151 21.587-21.564 51.238-34.845 84.158-34.856 32.912.01 62.559 13.292 84.151 34.856 21.564 21.584 34.85 51.236 34.856 84.15-.005 32.918-13.292 62.562-34.856 84.16zm12.23-202.187V.003H56.02v111.474C21.835 139.42.003 181.903 0 229.507c.003 47.605 21.835 90.09 56.02 118.034v100.006h192.763V347.539c34.177-27.949 56.005-70.427 56.013-118.032-.008-47.599-21.836-90.083-56.013-118.028"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-locate',
    name: 'Locate',
    tags: ['find', 'search', 'target', 'geolocation'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.52 582.52"
        height="582.52"
        width="582.52"
      >
        <path
          d="M321.312 492.063v-80.935h-60.097v80.935c-44.066-6.518-83.348-27.122-113.522-57.244-30.113-30.167-50.717-69.448-57.24-113.514h80.943v-60.093H90.454c6.522-44.065 27.126-83.345 57.24-113.516 30.173-30.119 69.455-50.724 113.52-57.248v80.941h60.098V90.453c44.067 6.52 83.341 27.124 113.515 57.236 30.113 30.178 50.724 69.458 57.241 113.523h-80.933v60.093h80.933c-6.517 44.066-27.128 83.347-57.241 113.514-30.174 30.122-69.448 50.725-113.515 57.244zM291.262-.003C130.382.021.026 130.384 0 291.255c.027 160.882 130.383 291.24 291.261 291.265 160.876-.026 291.231-130.383 291.264-291.265C582.492 130.384 452.137.02 291.261-.003"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-lock',
    name: 'Lock',
    tags: ['secure'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 445.693 582.04"
        height="582.04"
        width="445.693"
      >
        <path
          d="M132.894 180.305c0-28.222 10.683-53.19 27.291-70.958 16.735-17.755 38.528-27.976 62.671-28.01 24.125.034 45.916 10.246 62.65 28.01 16.606 17.768 27.289 42.736 27.289 70.958v98.136H132.894zm290.685 98.136h-29.446l-.002-98.136c0-48.901-18.562-93.748-49.223-126.524C314.361 21.003 270.845-.04 222.856 0c-48.004-.041-91.524 21.003-122.067 53.781-30.669 32.776-49.225 77.623-49.234 126.524v98.136H22.114C9.899 278.441 0 288.336 0 300.552v259.374c0 12.212 9.9 22.114 22.114 22.114h401.465c12.216 0 22.114-9.902 22.114-22.114V300.552c0-12.216-9.898-22.11-22.114-22.11"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-logout',
    name: 'Logout',
    tags: ['leave', 'exit'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 490.88 584.693"
        height="584.693"
        width="490.88"
      >
        <path
          d="M64.09.004v60.092h366.695v464.503H64.091v60.094H490.88V.004zm65.514 502.404l255.613-210.972L129.604 80.473v137.635H0v146.656h129.604v137.644"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-mailbox',
    name: 'Mailbox',
    tags: ['inbox', 'messages'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 588.627 525.96"
        height="525.96"
        width="588.627"
      >
        <path
          d="M403.376 315.5v70.104c0 18.439-14.948 33.383-33.381 33.383h-151.35c-18.437 0-33.386-14.944-33.386-33.383V315.5H65.007L162.38 63.443h263.956L524.88 315.5zM469.646 0H118.89L0 307.765V525.96h588.632V304.367L469.647 0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-map-alt',
    name: 'Map alt',
    tags: ['location'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 573.827 573.813"
        height="573.813"
        width="573.827"
      >
        <path
          d="M286.915 415.919c-71.139 0-129.007-57.879-129.007-129.014 0-16.688 3.22-32.626 9.013-47.276l54.647 81.242 31.38 31.388 81.25 54.642a128.287 128.287 0 0 1-47.283 9.018zm25.012-128.998c0 13.808-11.2 25.01-25.02 25.01-13.816 0-25.016-11.202-25.016-25.01 0-13.828 11.2-25.032 25.016-25.032 13.82 0 25.02 11.204 25.02 25.032zm-25.012-129.02c71.136 0 129.012 57.872 129.012 129.004 0 16.699-3.224 32.651-9.026 47.314l-54.646-81.231-31.391-31.421-81.244-54.643a128.24 128.24 0 0 1 47.295-9.023zm269.338 398.34L426.647 363.575a158.273 158.273 0 0 0 17.608-51.303l129.57-25.364-129.57-25.357c-10.827-67.7-64.279-121.146-131.974-131.974L286.915.007l-25.366 129.57a158.34 158.34 0 0 0-51.282 17.596L17.575 17.577 147.172 210.26a158.432 158.432 0 0 0-17.594 51.285L0 286.908l129.578 25.364c10.826 67.699 64.274 121.139 131.974 131.97l25.363 129.571 25.358-129.57a158.386 158.386 0 0 0 51.29-17.594l192.69 129.592"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-map',
    name: 'Map',
    tags: ['location'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 571.213 566.547"
        height="566.547"
        width="571.213"
      >
        <path
          d="M397.08 66.121v494.242l174.127-66.119V-.004zM0 566.547l173.7-65.964V6.34L0 72.299zm207.096-65.964l156.593 59.465V65.804L207.096 6.34v494.243"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-medal',
    name: 'Medal',
    tags: ['award', 'reward'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 458.933 584.187"
        height="584.187"
        width="458.933"
      >
        <path
          d="M225.636 300.7l-22.765 69.564h-73.04a4.04 4.04 0 0 0-3.833 2.781 4.02 4.02 0 0 0 1.46 4.494l59.102 43.056-22.77 69.941a4.037 4.037 0 0 0 1.457 4.504 4.044 4.044 0 0 0 4.729 0l59.485-43.181 59.354 43.18c.709.512 1.542.772 2.37.772a4.027 4.027 0 0 0 3.827-5.275L272.24 420.6l59.23-43.061a4.023 4.023 0 0 0 1.46-4.494 4.035 4.035 0 0 0-3.827-2.781h-73.166l-22.648-69.555a4.032 4.032 0 0 0-3.822-2.778 4.034 4.034 0 0 0-3.831 2.769zM0 .003v51.436h458.933V.003zm343.332 406.884c0 62.786-51.081 113.866-113.865 113.866-62.786 0-113.865-51.08-113.865-113.866 0-62.784 51.08-113.864 113.865-113.864 62.784 0 113.865 51.08 113.865 113.864zm-65.06-170.438c-15.512-4.433-31.87-6.86-48.805-6.86s-33.291 2.427-48.798 6.856V84.823H50.28v75.368l63.406 112.486C76.034 305.19 52.17 353.236 52.17 406.887c0 97.917 79.378 177.3 177.297 177.3 97.918 0 177.296-79.383 177.296-177.3 0-57.956-27.818-109.412-70.82-141.762L408.65 161.92V84.823H278.272v151.626"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-message-open',
    name: 'Message open',
    tags: ['read', 'email', 'letter'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 584.693 588.8"
        height="588.8"
        width="584.693"
      >
        <path
          d="M291.107 499.907L0 252.195V588.8h582.221V252.19L291.107 499.908M584.688 241.028L293.581-.002 2.471 241.029"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-message',
    name: 'Message',
    tags: ['unread', 'email', 'letter'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.213 365.48"
        height="365.48"
        width="582.213"
      >
        <path
          d="M291.044 286.523L0 37.58V365.48h582.22V40.075zM577.905-.005H7.415l283.741 242.694z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-mobile',
    name: 'Mobile',
    tags: ['phone'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 337.96 582.92"
        height="582.92"
        width="337.96"
      >
        <path
          d="M293.203 304.61H47.102V45.398h246.1zm0 145.694h-61.735v-61.74h61.735zm0 90.772h-61.735v-61.735h61.735zM142.6 343.183c0-14.587 11.826-26.412 26.41-26.412 14.582 0 26.404 11.825 26.404 26.412 0 14.585-11.822 26.408-26.404 26.408-14.584 0-26.41-11.823-26.41-26.408zm59.036 107.12h-61.736v-61.739h61.736zm0 90.773h-61.736v-61.735h61.736zm-92.8-90.772H47.102v-61.74h61.735zm0 90.772H47.102v-61.735h61.735zM309.585.006H28.362C12.698.005 0 12.702 0 28.367v526.184c0 15.664 12.698 28.368 28.362 28.368h281.223c15.663 0 28.37-12.704 28.37-28.368V28.368c0-15.665-12.707-28.363-28.37-28.363"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-mouse-cursor',
    name: 'Mouse cursor',
    tags: ['computer'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 268.667 514.973"
        height="514.973"
        width="268.667"
      >
        <path
          d="M148.136 309.527l120.525 13.86L8.708.004 0 415.207l11.664-11.286 76.42-73.96 58.679 163.974c4.642 12.957 16.83 21.046 29.861 21.038 3.552 0 7.168-.602 10.681-1.859 12.952-4.655 21.04-16.838 21.03-29.86 0-3.553-.602-7.17-1.855-10.687l-58.344-163.04"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-mouse',
    name: 'Mouse',
    tags: ['computer'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 294.133 584.04"
        height="584.04"
        width="294.133"
      >
        <path
          d="M44.932 326.727a208.23 208.23 0 0 1-22.009-16.703v138.407c0 74.895 60.71 135.609 135.604 135.609 74.89 0 135.601-60.714 135.601-135.61V316.42c-23.208 18.05-68.53 44.57-134.71 44.643-49.868 0-88.537-17.204-114.486-34.336zm136.933-115.422c0 12.894-10.448 23.343-23.338 23.343-12.891 0-23.339-10.45-23.339-23.343v-38.949c0-12.89 10.448-23.34 23.339-23.34 12.89 0 23.338 10.45 23.338 23.34zM177.41 83.037C168.084 35.697 126.38.007 76.298 0H0v33.386l76.298-.005c31.366.06 57.837 20.757 66.6 49.245-67.526 7.752-119.975 65.071-119.975 134.676v60.243l.269-.21c.005-.007.057.07.38.462.323.381.837.98 1.542 1.777a134.617 134.617 0 0 0 6.496 6.731c5.832 5.65 14.619 13.283 26.186 20.91 23.177 15.262 57.21 30.462 101.623 30.473 83.17.068 129.526-46.954 134.709-52.506v-67.88c0-68.48-50.772-125.072-116.719-134.264"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-movie-alt',
    name: 'Movie alt',
    tags: ['video', 'tape', 'entertainment'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 530.773 520.56"
        height="520.56"
        width="530.773"
      >
        <path
          d="M11.201 137.927l66.772 66.772-66.772 66.773zM191.467 77.524l38.208 65.916-67.631 12.405-38.208-65.91zm138.202-25.353l38.207 65.913-67.63 12.407-38.209-65.91zm138.203-25.359l28.767 49.63 3.197 17.427-61.384 11.266-38.21-65.914zm55.284 83.148L502.984.005h-.003L0 92.292l96.034 96.033zM421.695 340.54H133.08v-33.379h288.615zm-.002 76.698H133.075v-33.386h288.618zm-311.92-212.68L11.201 303.13V520.56h519.572V204.557h-421"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-movie',
    name: 'Movie',
    tags: ['video', 'tape', 'entertainment'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 456.413 512.613"
        height="512.613"
        width="456.413"
      >
        <path
          d="M433.223 81.932h-48.974V32.957h48.974zm0 95.293h-48.974V128.25h48.974zm0 99.428h-48.974V227.68h48.974zm0 103.572h-48.974v-48.978h48.974zm0 99.423h-48.974v-48.97h48.974zm-78.307-249.407h-253.42V56.08h253.42zm0 226.29h-253.42V282.368h253.42zM72.159 81.932H23.186V32.957h48.973zm0 95.293H23.186V128.25h48.973zm0 99.428H23.186V227.68h48.973zm0 103.572H23.186v-48.978h48.973zm0 99.423H23.186v-48.97h48.973zM0-.002v512.615h456.41V-.003H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-music',
    name: 'Music',
    tags: ['entertainment', 'listen'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 425.613 539.48"
        height="539.48"
        width="425.613"
      >
        <path
          d="M425.532.003L119.575 49.629l.046 367.97c-16.005-5.607-35.198-6.642-54.72-1.76-43.37 10.848-71.778 46.622-63.453 79.9 8.33 33.278 50.234 51.46 93.617 40.596 38.108-9.535 64.663-38.333 64.884-67.76l.042-.007v-294.09l225.158-35.3v227.438c-16.229-5.759-35.733-6.85-55.588-1.887-43.825 10.968-72.541 47.12-64.125 80.742 8.42 33.636 50.768 52.004 94.601 41.038 39.935-9.993 67.298-40.89 65.495-71.737V.002"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation-bottom',
    name: 'Navigation bottom',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 449.6 380.533"
        height="380.533"
        width="449.6"
      >
        <path
          d="M6.214 292.304v88.23h443.39v-88.23zM445.151-.004H0l222.57 282.116z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation-down',
    name: 'Navigation down',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 445.147 282.107"
        height="282.107"
        width="445.147"
      >
        <path d="M222.576 282.107L0-.005h445.148z" fill="#231f20" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation-first',
    name: 'Navigation first',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 380.547 445.147"
        height="445.147"
        width="380.547"
      >
        <path
          d="M0 444.26h88.238V.877H0zm98.435-221.69l282.11 222.577V-.005z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation-horizontal',
    name: 'Navigation horizontal',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 587.547 197.04"
        height="197.04"
        width="587.547"
      >
        <path
          d="M587.543 98.525L468.185.007v64.272H119.36V.007L0 98.52l119.36 98.52v-64.278h348.825v64.278l119.358-98.515"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation-last',
    name: 'Navigation last',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 380.533 449.6"
        height="449.6"
        width="380.533"
      >
        <path
          d="M292.303-.004v443.392h88.229V-.004zM0 449.6l282.108-222.57L0 4.456z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation-left',
    name: 'Navigation left',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 282.107 445.147"
        height="445.147"
        width="282.107"
      >
        <path d="M0 222.573L282.112-.004l-.003 445.15z" fill="#231f20" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation-right',
    name: 'Navigation right',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 282.12 445.147"
        height="445.147"
        width="282.12"
      >
        <path d="M282.119 222.573L0 445.147.003-.004z" fill="#231f20" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation-top',
    name: 'Navigation top',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 449.6 380.533"
        height="380.533"
        width="449.6"
      >
        <path
          d="M443.39-.003H0v88.231h443.39zM227.035 98.421L4.458 380.533h445.149z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation-up',
    name: 'Navigation up',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 445.16 282.12"
        height="282.12"
        width="445.16"
      >
        <path d="M222.581.007L445.16 282.12H0z" fill="#231f20" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation-vertical',
    name: 'Navigation vertical',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 197.027 587.547"
        height="587.547"
        width="197.027"
      >
        <path
          d="M132.75 119.356h64.28L98.519-.001 0 119.356h64.273v348.833H.005l98.513 119.358 98.513-119.358h-64.28V119.356"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-navigation',
    name: 'Navigation',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 587.547 587.547"
        height="587.547"
        width="587.547"
      >
        <path
          d="M587.544 293.775l-119.361-98.519v64.272h-140.17V119.356h64.275L293.776-.001l-98.519 119.357h64.271v140.172H119.357v-64.272L0 293.769l119.357 98.522v-64.279h140.171v140.177h-64.265l98.513 119.358 98.512-119.358h-64.275V328.012h140.17v64.279l119.361-98.516"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-next-media',
    name: 'Next media',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 565.733 331.947"
        height="331.947"
        width="565.733"
      >
        <path d="M285.045 165.976L0 331.946V.005z" fill="#231f20" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-next',
    name: 'Next',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 382.267 445.16"
        height="445.16"
        width="382.267"
      >
        <path d="M382.267 222.584L0 445.16V.007z" fill="#231f20" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-notepad',
    name: 'Notepad',
    tags: ['write', 'paper'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 397.427 562.667"
        height="562.667"
        width="397.427"
      >
        <path
          d="M199.147 98.423c11.338 0 20.53-9.196 20.53-20.534V20.528C219.677 9.191 210.485 0 199.147 0c-11.338 0-20.528 9.19-20.528 20.528v57.361c0 11.338 9.19 20.534 20.528 20.534zm-125.806 0c11.336 0 20.529-9.196 20.529-20.534V20.528C93.87 9.191 84.677 0 73.34 0 62.003 0 52.81 9.19 52.81 20.528v57.361c0 11.338 9.192 20.534 20.53 20.534zm251.615 0c11.336 0 20.53-9.196 20.53-20.534V20.528C345.485 9.191 336.291 0 324.955 0c-11.341 0-20.532 9.19-20.532 20.528v57.361c0 11.338 9.19 20.534 20.532 20.534zm10.015 222.738H70.115v41.034H334.97zm0-138.088H70.115v41.036H334.97zm0 69.048H70.115v41.032H334.97zm29.072 277.16H175.227c-49.602 0-25.702-117.574-25.702-117.574S34.86 439.576 33.385 386.995V147.048h330.658zM360.04 22.907V52.79c3.877 6.285 6.157 13.669 6.157 21.596 0 22.784-18.469 41.246-41.246 41.246-22.779 0-41.236-18.462-41.236-41.246 0-7.927 2.273-15.306 6.15-21.59v-29.89h-55.633V52.79c3.88 6.285 6.159 13.669 6.159 21.596 0 22.784-18.468 41.246-41.246 41.246-22.78 0-41.238-18.462-41.238-41.246 0-7.927 2.276-15.306 6.149-21.59v-29.89h-55.632V52.79c3.879 6.285 6.16 13.669 6.16 21.596 0 22.784-18.47 41.246-41.245 41.246-22.781 0-41.242-18.462-41.242-41.246 0-7.927 2.278-15.306 6.152-21.59v-29.89H0v408.212l9.778 9.777 121.768 121.77h265.882V22.907H360.04"
          fill="#231f20"
          fillRule="evenodd"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-ordered-list',
    name: 'Ordered list',
    tags: [],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 518.293 469.533"
        height="469.533"
        width="518.293"
      >
        <path
          d="M160.607 116.024V5.221h357.681v110.803H160.607M160.603 290.692V179.895h357.685v110.797H160.603M160.607 465.364V354.565h357.681v110.8H160.607M7.276 37.201V21.163c7.422-.335 12.617-.828 15.586-1.492 4.725-1.043 8.577-3.14 11.546-6.284 2.032-2.147 3.572-5.015 4.617-8.598.605-2.148.907-3.745.907-4.792h19.677v119.878h-24.14V37.2H7.275M6.366 273.132c3.361-7.993 11.298-16.45 23.811-25.384 10.855-7.77 17.884-13.336 21.081-16.699 4.906-5.236 7.359-10.968 7.359-17.196 0-5.073-1.407-9.286-4.216-12.654-2.812-3.356-6.835-5.038-12.071-5.038-7.167 0-12.044 2.674-14.634 8.018-1.489 3.085-2.37 7.993-2.646 14.717H2.148c.386-10.199 2.235-18.437 5.547-24.721 6.29-11.96 17.461-17.938 33.518-17.938 12.69 0 22.786 3.511 30.29 10.539 7.503 7.028 11.255 16.328 11.255 27.9 0 8.875-2.65 16.756-7.951 23.645-3.48 4.578-9.193 9.675-17.147 15.299l-9.443 6.693c-5.909 4.192-9.952 7.223-12.129 9.099a26.66 26.66 0 0 0-5.499 6.53h52.336v20.751H.825c.221-8.598 2.07-16.454 5.54-23.561M23.15 429.767c0 4.797.77 8.765 2.309 11.906 2.858 5.787 8.055 8.683 15.588 8.683 4.62 0 8.648-1.583 12.083-4.754 3.437-3.17 5.157-7.729 5.157-13.685 0-7.88-3.188-13.145-9.56-15.79-3.63-1.488-9.344-2.234-17.145-2.234V397.03c7.635-.112 12.962-.852 15.984-2.23 5.218-2.318 7.826-7.002 7.826-14.055 0-4.577-1.332-8.299-3.997-11.165-2.668-2.864-6.422-4.298-11.258-4.298-5.551 0-9.634 1.767-12.245 5.29-2.612 3.53-3.862 8.24-3.751 14.141H2.148c.22-5.955 1.24-11.604 3.057-16.95 1.927-4.685 4.954-9.013 9.086-12.98 3.08-2.81 6.743-4.96 10.98-6.451 4.241-1.487 9.445-2.23 15.612-2.23 11.452 0 20.69 2.963 27.709 8.887 7.02 5.927 10.528 13.877 10.528 23.852 0 7.057-2.093 13.012-6.282 17.858-2.646 3.035-5.403 5.1-8.268 6.204 2.15 0 5.237 1.845 9.259 5.537 6.006 5.566 9.013 13.171 9.013 22.82 0 10.141-3.511 19.056-10.53 26.744-7.023 7.688-17.415 11.53-31.18 11.53-16.96 0-28.745-5.536-35.35-16.617-3.47-5.893-5.397-13.61-5.782-23.15h23.15"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-os-x',
    name: 'OS X',
    tags: ['apple'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 461.147 543.947"
        height="543.947"
        width="461.147"
      >
        <path
          d="M0-.001h130.066l106.433 182.388L336.993-.001h124.158L307.425 279.936l153.726 264.01H336.993L236.5 371.562 130.066 543.947H0l177.361-264.011L0-.001"
          fill="#100f0d"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-out',
    name: 'Out',
    tags: ['leave', 'exit'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 583.907 448.107"
        height="448.107"
        width="583.907"
      >
        <path
          d="M408.896-.003l56.839 56.84-136.707 136.704 62.387 62.382 136.702-136.699 55.795 55.797V-.003zm123.856 396.946H51.16V51.16h255.472V-.003H0v448.11h583.912V292.24h-51.16v104.702"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-outbox',
    name: 'Outbox',
    tags: ['messages', 'email', 'letter', 'post office'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 588.627 525.96"
        height="525.96"
        width="588.627"
      >
        <path
          d="M256.121 344.273h81.792v-97.172h76.752L297.01 104.552l-117.65 142.55h76.762zM403.375 315.5v70.104c0 18.439-14.948 33.383-33.384 33.383H218.643c-18.438 0-33.386-14.944-33.386-33.383V315.5H65.006l97.373-252.057h263.954L524.875 315.5zM469.644 0H118.887L0 307.765V525.96h588.627V304.367L469.644 0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-outdent',
    name: 'Outdent',
    tags: ['text', 'editor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 587.293 460.147"
        height="460.147"
        width="587.293"
      >
        <path
          d="M229.601 110.804V-.001h357.687v110.805H229.601M229.601 285.47V174.673h357.687v110.799H229.601M229.601 460.147V349.343h357.687v110.804H229.601M0 230.07l144.387-84.065v168.138z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-page-add',
    name: 'Page add',
    tags: ['editor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 465.68 567.053"
        height="567.053"
        width="465.68"
      >
        <path
          d="M379.825 481.204v56.401h-37.641v-56.401h-56.397v-37.65h56.397v-56.397h37.641v56.396h56.41v37.65zm-18.817-123.495c-57.805 0-104.67 46.868-104.67 104.68 0 57.806 46.865 104.664 104.67 104.664 57.812 0 104.673-46.858 104.673-104.664 0-57.812-46.861-104.68-104.673-104.68zM33.386 522.23V33.392h188.817c49.6 0 25.697 117.579 25.697 117.579s114.67-27.876 116.144 24.702v158.714a127.38 127.38 0 0 1 33.383 4.958V131.553L275.664 9.785 265.88.003H0v555.61h274.412a128.76 128.76 0 0 1-25.523-33.383H33.386"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-page-remove',
    name: 'Page remove',
    tags: ['editor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 465.68 567.053"
        height="567.053"
        width="465.68"
      >
        <path
          d="M285.787 481.204v-37.65h150.448v37.65zm75.221-123.495c-57.805 0-104.67 46.868-104.67 104.68 0 57.806 46.865 104.664 104.67 104.664 57.81 0 104.675-46.858 104.675-104.664 0-57.812-46.866-104.68-104.675-104.68zM33.384 522.23V33.392h188.819c49.602 0 25.7 117.579 25.7 117.579s114.664-27.876 116.138 24.702v158.714a127.358 127.358 0 0 1 33.386 4.958V131.553L275.66 9.785 265.877.003H0v555.61h274.412a128.76 128.76 0 0 1-25.523-33.383H33.384"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-page-restricted',
    name: 'Page restricted',
    tags: ['editor'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 465.68 567.053"
        height="567.053"
        width="465.68"
      >
        <path
          d="M361.21 532.983c-39.88 0-72.209-32.328-72.209-72.208 0-39.884 32.33-72.211 72.208-72.211 39.876 0 72.204 32.327 72.204 72.21 0 39.88-32.328 72.209-72.204 72.209zm-.202-175.274c-57.805 0-104.664 46.868-104.664 104.68 0 57.806 46.859 104.664 104.664 104.664 57.812 0 104.675-46.858 104.675-104.664 0-57.812-46.863-104.68-104.675-104.68zm.201 52.791c-9.897 0-19.106 2.916-26.897 7.87l69.299 69.29c4.954-7.787 7.868-16.997 7.868-26.885 0-27.724-22.554-50.275-50.27-50.275zm-50.272 50.275c0 27.721 22.55 50.27 50.272 50.27 9.892 0 19.102-2.913 26.888-7.868l-69.292-69.294c-4.953 7.785-7.868 16.993-7.868 26.892zM33.385 522.23V33.392H222.2c49.6 0 25.7 117.579 25.7 117.579s114.667-27.876 116.141 24.702v158.714a127.391 127.391 0 0 1 33.386 4.958V131.553L275.657 9.785l-9.78-9.782H0v555.61h274.41a128.837 128.837 0 0 1-25.52-33.383H33.384"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-panel-show',
    name: 'Panel show',
    tags: ['expand', 'toggle'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.213 502.813"
        height="502.813"
        width="582.213"
      >
        <path
          d="M534.17 457.568H49.296V96.135h484.872zM0 .004v502.81h582.215V.003H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-pannel-close',
    name: 'Pannel close',
    tags: ['expand', 'toggle'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.213 502.813"
        height="502.813"
        width="582.213"
      >
        <path
          d="M534.17 457.568H49.297V96.135h484.871zM0 .004v502.81h582.219V.003H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-pause',
    name: 'Pause',
    tags: ['media', 'controls'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 314.453 439.44"
        height="439.44"
        width="314.453"
      >
        <path
          d="M203.65 439.44V.001h110.803V439.44H203.65M0 439.437V.007h110.802v439.43H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-people-alt',
    name: 'People alt',
    tags: ['person', 'man', 'woman', 'group'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 248.867 568.053"
        height="568.053"
        width="248.867"
      >
        <path
          d="M236.716 202.543c-17.443-17.451-38.167-27.898-113.107-27.898-74.951 0-95.173 11.339-111.728 27.898C-4.68 219.097.907 395.72.907 395.72l36.648-87.072 23.04 259.405 66.475-132.76 62.027 132.76 21.942-259.405 36.65 87.072s6.476-175.732-10.973-193.177zm-111.289-37.378c45.608 0 82.581-36.969 82.581-82.578 0-45.61-36.973-82.58-82.58-82.58-45.609 0-82.582 36.97-82.582 82.58 0 45.609 36.973 82.578 82.581 82.578"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-people',
    name: 'People',
    tags: ['person', 'man', 'woman', 'group'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 235.573 568.2"
        height="568.2"
        width="235.573"
      >
        <path
          d="M202.184 178.99H33.386C14.948 178.99 0 193.931 0 212.372v174.855h47.677V568.2h140.218V387.228h47.673V212.373c0-18.441-14.947-33.384-33.384-33.384zm-84.398-13.834c45.606 0 82.58-36.97 82.58-82.575 0-45.609-36.974-82.586-82.58-82.586-45.605 0-82.582 36.977-82.582 82.586 0 45.604 36.977 82.575 82.582 82.575"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-phone',
    name: 'Phone',
    tags: ['telephone', 'call'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 592.92 579.027"
        height="579.027"
        width="592.92"
      >
        <path
          d="M7.538 198.71C118.39 511.654 381.515 574.9 421.852 577.9c96.723 10.244 158.919-50.356 171.064-142.063 0 0-97.797-62.194-146.588-72.409l-77.127 77.127s-41.506 1.812-132.389-89.067c-90.875-90.883-89.064-132.39-89.064-132.39l66.393-66.397C203.045 85.417 164.101-20.97 87.936 3.61 12.871 27.237-14.861 133.073 7.538 198.711"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-picture',
    name: 'Picture',
    tags: ['camera', 'photograph'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 579.587 408.76"
        height="408.76"
        width="579.587"
      >
        <path
          d="M528.11 357.223H53.192l-.021-304.044h473.237v.022h1.7zM0 0V408.76h579.584V.001zm412.347 170.782c21.414 0 38.764-17.334 38.764-38.746 0-21.386-17.35-38.749-38.764-38.749-21.359 0-38.718 17.363-38.718 38.75 0 21.411 17.359 38.745 38.718 38.745zm-134.019 91.365L164.191 140.752 86.577 284.299v39.544H472.07c-49.096-42.338-152.635-132.91-152.635-132.91l-41.108 71.215"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-pictures-alt-2',
    name: 'Pictures alt 2',
    tags: ['camera', 'photograph'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 584.813 530.453"
        height="530.453"
        width="584.813"
      >
        <path
          d="M514.888 254.208H175.221v206.727h339.667zm34.793 241.521H140.428V219.413h409.253zM105.594 219.995l-14.84 6.29 14.84 35.012v89.155L45.142 207.833 421.9 48.077l57.716 136.178h-37.788l-38.384-90.559-213.56 90.559h-84.29zm414.109-35.74L438.5-.004 0 193.175l105.594 239.621v97.657h479.213V184.255h-65.104"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-pictures-alt',
    name: 'Pictures alt',
    tags: ['camera', 'photograph'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 513.227 557.813"
        height="557.813"
        width="513.227"
      >
        <path
          d="M0 0v428.465h108.253V315.567H41.665V40.919H320.8v46.626H362.4V0H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-pictures',
    name: 'Pictures',
    tags: ['camera', 'photograph'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 584.413 417.067"
        height="417.067"
        width="584.413"
      >
        <path
          d="M553.975 98.761c0 5.223-4.231 9.45-9.447 9.45h-21.925c-5.216 0-9.446-4.227-9.446-9.45V76.84c0-5.216 4.23-9.447 9.446-9.447h21.925c5.216 0 9.447 4.231 9.447 9.447zM374.999 377.937c-78.456 0-142.286-63.828-142.286-142.285 0-78.453 63.83-142.285 142.286-142.285s142.284 63.832 142.284 142.285c0 78.457-63.828 142.285-142.284 142.285zM183.62 111.36h-83.189c-9.839 0-17.815-7.978-17.815-17.816s7.976-17.816 17.815-17.816h83.19c9.84 0 17.818 7.978 17.818 17.816s-7.979 17.816-17.819 17.816zm22.535-76.284L175.66.005H86.161l-30.495 35.07H0v381.992h584.408V35.075zm168.843 264.482c-35.294 0-63.903-28.608-63.903-63.905 0-35.293 28.61-63.903 63.903-63.903 35.29 0 63.904 28.61 63.904 63.903 0 35.297-28.614 63.905-63.904 63.905zm0-172.802c-60.144 0-108.9 48.753-108.9 108.897 0 60.144 48.756 108.901 108.9 108.901 60.142 0 108.898-48.757 108.898-108.901S435.141 126.755 375 126.755"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-pie-chart',
    name: 'Pie chart',
    tags: ['display', 'information'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 577.6 578"
        height="578"
        width="577.6"
      >
        <path
          d="M507.833 253.913C507.833 113.681 394.151 0 253.905 0 113.677-.001 0 113.68 0 253.913 0 394.144 113.677 507.83 253.905 507.83V253.913h253.928"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-pin-location',
    name: 'Pin location',
    tags: ['geographic'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 309.173 519.6"
        height="519.6"
        width="309.173"
      >
        <path
          d="M154.588 201.567c-25.94 0-46.97-21.032-46.97-46.97 0-25.942 21.03-46.973 46.97-46.973 25.941 0 46.97 21.03 46.97 46.973 0 25.938-21.029 46.97-46.97 46.97zm0-201.563C69.209.004 0 69.214 0 154.597 0 239.971 154.588 519.6 154.588 519.6s154.59-279.63 154.59-365.003C309.179 69.215 239.96.004 154.589.004"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-play',
    name: 'Play',
    tags: ['controls', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="400"
        height="400"
        viewBox="0 0 400 400"
      >
        <polygon
          fill="#231F20"
          points="208 169.501 0 339 0 0"
          transform="translate(132 30)"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-plugin',
    name: 'Plugin',
    tags: ['add-on', 'functionality'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 579.467 366.613"
        height="366.613"
        width="579.467"
      >
        <path
          d="M533.74 131.587h-.095c-25.266 0-50.842 29.658-50.842 4.408v-136H354.5c-30.344 0 5.303 30.748 5.303 61.101v.11c0 30.36-24.614 54.97-54.958 54.97-30.354 0-54.964-24.61-54.964-54.97l-.104-.11c0-29.67 37.727-61.101 7.37-61.101H116.18V129.71c0 30.357-31.43-7.372-61.096-7.372l-.115.108C24.612 122.447 0 147.052 0 177.409c0 30.34 24.612 54.955 54.97 54.955h.115c30.35 0 61.096-35.645 61.096-5.305v139.554h147.25c25.249 0-4.407-25.573-4.407-50.837v-.099c0-25.252 20.47-45.724 45.723-45.724 25.262 0 45.729 20.472 45.729 45.724l.076.099c0 24.69-31.377 50.837-6.121 50.837h138.372v-149.62c0-25.25 26.149 6.127 50.842 6.127l.095-.079c25.25 0 45.725-20.468 45.725-45.732 0-25.252-20.476-45.722-45.725-45.722"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-podcast',
    name: 'Podcast',
    tags: ['media', 'audio'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 545.693 577.173"
        height="577.173"
        width="545.693"
      >
        <path
          d="M272.86.001C122.126.001.026 122.143 0 272.813c0 40.419 8.814 78.82 24.579 113.327 31.64 69.164 91.332 111.192 164.538 130.285l-4.966-10.27c-55.903-27.399-101.112-81.078-126.048-135.812-13.545-29.711-21.084-62.738-21.149-97.53.211-130.284 105.63-235.626 235.906-235.892 130.247.266 235.639 105.608 235.863 235.892-.172 97.107-58.792 192.202-142.57 232.842l-4.254 11.177c106.941-32.85 183.777-124.536 183.793-244.019C545.664 122.143 423.537.001 272.86.001zm.501 132.082c77.727.117 140.611 63.014 140.744 140.793-.08 42.53-16.908 80.505-39.313 112.596 33.721-17.752 76.25-54.99 76.28-112.596-.03-98.18-79.592-177.708-177.71-177.73h-.53c-98.116.022-177.684 79.55-177.708 177.73.024 57.607 42.544 94.844 76.279 112.596-22.403-32.09-39.243-70.067-39.314-112.596.135-77.779 63.019-140.676 140.743-140.793h.53"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-power',
    name: 'Power',
    tags: [],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 580.547 600.707"
        height="600.707"
        width="580.547"
      >
        <path
          d="M290.275 600.707c-74.139.05-148.69-28.426-205.249-85.02C28.425 459.12-.049 384.568 0 310.427c-.05-74.14 28.425-148.692 85.031-205.256 17.228-17.222 45.16-17.222 62.386.008 17.228 17.225 17.22 45.16-.005 62.385-39.537 39.567-59.13 91.004-59.18 142.863.05 51.856 19.643 103.304 59.185 142.877 39.55 39.525 90.998 59.119 142.858 59.168 51.858-.05 103.308-19.637 142.87-59.168 39.535-39.573 59.128-91.021 59.176-142.877-.048-51.851-19.641-103.296-59.176-142.871v.008c-17.226-17.233-17.226-45.164 0-62.393 17.228-17.222 45.158-17.222 62.392 0 56.595 56.568 85.071 131.116 85.011 205.256.06 74.141-28.421 148.693-85.019 205.26-56.52 56.554-130.984 85.022-205.065 85.02h-.19"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-previous-media',
    name: 'Previous media',
    tags: ['control'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 565.733 331.947"
        height="331.947"
        width="565.733"
      >
        <path d="M280.693 165.976L565.737.006v331.94z" fill="#231f20" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-previous',
    name: 'Previous',
    tags: ['control'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 382.267 445.16"
        height="445.16"
        width="382.267"
      >
        <path d="M0 222.58L382.265.003V445.16z" fill="#231f20" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-print',
    name: 'Print',
    tags: [],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.56 569.573"
        height="569.573"
        width="582.56"
      >
        <path
          d="M454.899 93.943H127.657V-.004h327.242v93.947M520.94 197.343c-12.527 0-22.683-10.16-22.683-22.69 0-12.528 10.156-22.685 22.683-22.685 12.532 0 22.688 10.157 22.688 22.685 0 12.53-10.156 22.69-22.688 22.69zm33.253-69.546H28.364C12.702 127.797 0 140.5 0 156.163V364.83h85.448V238.156h411.665v126.675h85.444V156.163c0-15.664-12.702-28.366-28.364-28.366"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-printer-alt',
    name: 'Printer alt',
    tags: [],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.56 539.96"
        height="539.96"
        width="582.56"
      >
        <path
          d="M199.257 359.848h191.904v-33.381H199.257zm191.907-98.876h-191.91v33.395h191.91zm129.781-93.243c-12.533 0-22.688-10.154-22.688-22.685 0-12.528 10.155-22.684 22.688-22.684 12.526 0 22.684 10.156 22.684 22.684 0 12.53-10.158 22.685-22.684 22.685zm-23.83 154.659h-33.026v-66.021h-33.381v250.207H293.765c-49.602 0-25.7-117.574-25.7-117.574s-114.67 27.867-116.145-24.71V256.366h-33.386v64.657h-33.08V208.547h411.66zM151.925 33.392h278.783v64.795H151.925zm402.268 64.795H464.09V.005H118.534v98.182h-90.17C12.704 98.187 0 110.888 0 126.547V367.38h118.534v41.035L250.08 539.96H464.09V368.745h118.468V126.547c0-15.659-12.702-28.36-28.364-28.36"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-pushpin',
    name: 'Pushpin',
    tags: ['board', 'save', 'favorite'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 476.76 476.533"
        height="476.533"
        width="476.76"
      >
        <path
          d="M422.727 54.041C376.699 8.016 322.693-12.603 302.099 7.987c-6.296 6.3-8.724 15.736-7.762 27.101-.424 9.313-1.582 17.865-3.381 25.712l-79.41 79.408c-24.355 6.93-47.802 7.373-60.39 6.935-26.61-8.327-49.084-7.018-62.092 5.99-28.85 28.85-.32 104.142 63.712 168.178 64.035 64.034 139.324 92.556 168.172 63.708 10.987-10.986 13.63-28.712 9.185-49.986l.254.254s-4.552-36.603 6.746-73.995l74.804-74.808c9.058-2.27 19.087-3.675 30.206-4.02 11.158.857 20.428-1.584 26.637-7.796 20.592-20.59-.023-74.595-46.053-120.627zm-317.018 263.11L0 476.533l158.987-106.492a388.96 388.96 0 0 1-28.84-26.1 394.304 394.304 0 0 1-24.438-26.79"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-radio-alt',
    name: 'Radio alt',
    tags: ['sound', 'audio'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 605.507 481.48"
        height="481.48"
        width="605.507"
      >
        <path
          d="M300.484 249.436h-.092a110.87 110.87 0 0 1-31.137-4.447V481.48h62.273V244.987a110.767 110.767 0 0 1-31.044 4.449M247.844 87.49c-14.523 14.533-21.748 33.38-21.76 52.36.027 19.175 7.199 38.145 21.773 52.729 14.548 14.538 33.462 21.744 52.542 21.762 19.072-.018 37.981-7.224 52.534-21.762 14.555-14.56 21.756-33.475 21.768-52.547-.012-19.079-7.213-37.985-21.768-52.543-14.56-14.549-33.462-21.75-52.534-21.77-19.08.02-37.994 7.221-52.555 21.77M134.455 219.516c-22.358-22.336-33.627-51.847-33.598-81.112-.03-29.272 11.24-58.781 33.598-81.112 9.781-9.781 25.634-9.781 35.414 0 9.772 9.781 9.772 25.637-.006 35.417-12.663 12.678-18.902 29.066-18.924 45.695.022 16.63 6.256 33.016 18.924 45.707h.006c9.772 9.778 9.772 25.63-.006 35.405a24.965 24.965 0 0 1-17.71 7.333 24.94 24.94 0 0 1-17.698-7.333M435.65 219.524c-9.78-9.783-9.787-25.63-.007-35.41 12.67-12.705 18.908-29.093 18.932-45.713-.024-16.626-6.262-33.014-18.926-45.697v.005c-9.78-9.78-9.78-25.633 0-35.412 9.776-9.781 25.628-9.781 35.408 0 22.354 22.326 33.626 51.84 33.599 81.104a114.54 114.54 0 0 1-33.59 81.11c-4.889 4.894-11.3 7.338-17.713 7.338a24.996 24.996 0 0 1-17.704-7.325M54.29 269.476C18.14 233.341-.023 185.756 0 138.404-.022 91.041 18.14 43.452 54.3 7.337c9.782-9.778 25.63-9.778 35.41 0 9.775 9.782 9.77 25.632-.006 35.415-26.46 26.457-39.59 60.933-39.623 95.652.033 34.704 13.162 69.175 39.623 95.672h.006c9.775 9.77 9.775 25.628-.006 35.41a24.978 24.978 0 0 1-17.706 7.329 24.967 24.967 0 0 1-17.709-7.339M515.808 269.487c-9.783-9.783-9.783-25.634-.01-35.414 26.471-26.484 39.607-60.965 39.627-95.661-.02-34.712-13.156-69.192-39.617-95.676v.016c-9.783-9.783-9.783-25.633 0-35.415 9.776-9.778 25.628-9.778 35.41 0 36.143 36.126 54.322 83.722 54.29 131.075.032 47.352-18.147 94.935-54.28 131.075a24.976 24.976 0 0 1-17.71 7.336 24.97 24.97 0 0 1-17.71-7.336"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-radio',
    name: 'Radio',
    tags: ['sound', 'audio'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 605.507 589.533"
        height="589.533"
        width="605.507"
      >
        <path
          d="M302.479 212.83c41.102 0 74.416-33.32 74.416-74.415 0-41.103-33.314-74.422-74.416-74.422-41.096 0-74.416 33.319-74.416 74.422 0 41.096 33.32 74.416 74.416 74.416zM551.216 7.34c-9.776-9.779-25.637-9.779-35.41 0-9.78 9.781-9.78 25.63 0 35.408 26.46 26.48 39.597 60.956 39.625 95.664-.028 34.701-13.164 69.174-39.632 95.661-9.776 9.777-9.772 25.64.008 35.416a24.949 24.949 0 0 0 17.697 7.33c6.408 0 12.821-2.443 17.712-7.338 36.141-36.132 54.321-83.719 54.288-131.07.033-47.353-18.14-94.942-54.288-131.071zM89.703 234.076c-26.466-26.487-39.597-60.967-39.623-95.67.026-34.703 13.165-69.185 39.623-95.657 9.777-9.78 9.777-25.629 0-35.41-9.779-9.779-25.63-9.779-35.411 0C18.145 43.463-.028 91.053 0 138.405c-.027 47.352 18.145 94.943 54.292 131.079a24.982 24.982 0 0 0 17.707 7.33 24.968 24.968 0 0 0 17.704-7.33c9.777-9.78 9.777-25.63.008-35.408zM435.648 57.303c-9.781 9.776-9.781 25.634 0 35.406 12.667 12.687 18.899 29.072 18.927 45.702-.028 16.618-6.26 33.013-18.927 45.697-9.781 9.783-9.781 25.641 0 35.415 4.89 4.889 11.3 7.33 17.705 7.33 6.41 0 12.819-2.441 17.706-7.33a114.493 114.493 0 0 0 33.597-81.112c.028-29.274-11.25-58.783-33.597-81.112-9.782-9.778-25.636-9.778-35.411.004zm-283.49 169.55a24.969 24.969 0 0 0 17.703-7.326c9.78-9.783 9.78-25.64.007-35.414h-.007c-12.668-12.685-18.898-29.078-18.925-45.708.027-16.62 6.257-33.013 18.925-45.692 9.78-9.776 9.78-25.634.007-35.406-9.783-9.782-25.632-9.786-35.413-.004-22.351 22.321-33.63 51.83-33.603 81.102-.027 29.278 11.252 58.782 33.603 81.122 4.888 4.885 11.293 7.326 17.702 7.326zM367.26 437.765l-31.177-18.957 19.527-11.276zm31.094 80.698l-90.474-35.815-12.389.033-88.912 35.844 12.364-32.088 84.183-48.604 83.793 50.95zm-148.259-112.87l20.507 12.47-32.552 18.792zm19.975-51.845h64.818l8.572 22.247-39.898 23.037-41.27-25.097zm32.408-84.105l19.545 50.721h-39.085zm.454-20.198h-.078c-17.832.016-35.786-4.228-52.068-12.776L114.822 589.533h64.397l10.94-28.393 111.628-44.996 112.897 44.695 11.06 28.694h64.395L354.195 236.724c-15.992 8.432-33.628 12.721-51.262 12.721"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-rate',
    name: 'Rate',
    tags: ['star'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 602 574.587"
        height="574.587"
        width="602"
      >
        <path
          d="M601.43 218.11c-1.56-4.798-6.065-8.077-11.111-8.077H377.867L312.108 8.068A11.72 11.72 0 0 0 301.003.001a11.692 11.692 0 0 0-11.11 8.05l-66.128 201.982H11.68c-5.047 0-9.552 3.272-11.11 8.067a11.728 11.728 0 0 0 4.227 13.068L176.42 356.18l-66.126 203.097c-1.567 4.796.153 10.094 4.235 13.07a11.713 11.713 0 0 0 13.735 0l172.723-125.395 172.368 125.395a11.656 11.656 0 0 0 13.74 0 11.665 11.665 0 0 0 4.246-13.07l-66.138-203.092 171.982-125.008c4.086-2.966 5.803-8.265 4.246-13.068"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-readonly',
    name: 'Readonly',
    tags: ['edit'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 578.587 579.213"
        height="579.213"
        width="578.587"
      >
        <path
          d="M419.912 123.753l-21.713-21.706-110.122 110.122 21.714 21.706zM134.24 478.308l-61.822 28.14 27.86-62.097 31.188-31.186 4.487 29.738 29.467 4.22zm52.345-78.73l-21.236-21.251 68.216-68.223-21.717-21.707L63.646 436.6l.25.247L0 579.213l141.75-64.512.242.243.647-.645 147.553-147.563-35.385-35.383zM366.42 290.511l110.124-110.128-35.387-35.379-110.123 110.119zM578.585 78.34L500.237.001l-66.636 66.635 78.351 78.35zM4.785 34.119l540 539.998 29.018-29.02-540-539.994L4.785 34.119"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-record',
    name: 'Record',
    tags: ['video', 'tape'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 443.613 443.6"
        height="443.6"
        width="443.613"
      >
        <path
          d="M443.607 221.796c0 122.497-99.306 221.804-221.804 221.804C99.31 443.6 0 344.293 0 221.796S99.31-.005 221.803-.005c122.498 0 221.804 99.304 221.804 221.801"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-refresh',
    name: 'Refresh',
    tags: ['reload'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 570.88 582.827"
        height="582.827"
        width="570.88"
      >
        <path
          d="M570.88 291.384C570.852 131.343 441.757 1.18 281.528.011c-.876-.011-1.603-.012-2.096-.012C196.956-.016 122.137 34.467 69.173 89.7L0 19.641V223.23h201.008l-69.805-70.701c37.186-39.644 89.693-64.285 148.229-64.299.54 0 .835 0 .961.007h.372c111.754.679 201.91 91.57 201.88 203.148.006.133-.005.676.006 1.603-.834 111.617-91.675 201.63-203.148 201.602-.362.008-.948 0-1.748 0l.274 88.238c.262-.008.756-.008 1.474 0 160.104-.033 290.317-129.232 291.377-289.556v-.48l-.005-.579c0-.15.005-.424.005-.828zM281.324.005c.068 0 .135.004.204.006.063.002.11.002.177.002l-.381-.008"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-remove',
    name: 'Remove',
    tags: ['delete'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 442.773 110.8"
        height="110.8"
        width="442.773"
      >
        <path d="M0 110.8V0h442.779v110.8H0" fill="#231f20" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-repeat-one',
    name: 'Repeat one',
    tags: ['control', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 525.76 501.347"
        height="501.347"
        width="525.76"
      >
        <path
          d="M437.773 466.828h-27.932V371.17h-32.62v-18.555c8.587-.391 14.599-.962 18.032-1.722 5.474-1.216 9.926-3.633 13.359-7.273 2.356-2.488 4.139-5.803 5.344-9.952.701-2.483 1.052-4.333 1.052-5.543h22.765zm-16.689-174.83c-57.81 0-104.672 46.869-104.672 104.677 0 57.8 46.863 104.672 104.672 104.672 57.81 0 104.67-46.871 104.67-104.672 0-57.808-46.86-104.678-104.67-104.678zm-68.62-3.345H147.032v-64.268L27.674 322.901l119.358 98.514v-64.27l152.284-.004c9.283-28.516 28.313-52.654 53.148-68.488zm57.636-31.976l-14.62 14.528a128.309 128.309 0 0 1 25.604-2.574c20.67 0 40.195 4.957 57.496 13.689v-85.7H410.1zm-341.62-91.95l32.175-31.974h231.442v64.283l119.362-98.51L332.097.003v64.277H72.408L0 136.245v88.546h68.48v-60.064"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-repeat',
    name: 'Repeat',
    tags: ['control', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 478.573 421.413"
        height="421.413"
        width="478.573"
      >
        <path
          d="M410.093 196.62v60.057l-32.172 31.975H147.033v-64.27L27.672 322.894l119.361 98.518v-64.276h259.13l72.414-71.972V196.62zm-341.61-31.89l32.171-31.971H332.1v64.272l119.36-98.515L332.099.003v64.276l-193.926-.008H72.415L0 136.243v88.545h68.482v-60.059"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-reply-arrow',
    name: 'Reply arrow',
    tags: ['email', 'respond'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 409.333 493.547"
        height="493.547"
        width="409.333"
      >
        <path
          d="M197.947 97.633L198.57.004 0 164.184l196.47 166.29.591-93.258c196.196 26.599 111.454 144.53-.35 256.33 387.305-252.686 156.918-369.09 1.236-395.913"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-resize',
    name: 'Resize',
    tags: [],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 583.707 443.387"
        height="443.387"
        width="583.707"
      >
        <path
          d="M583.71 229.48L459.954 105.723v79.645H342.584V.003h-110.8v185.365H123.759v-79.645L0 229.485l123.759 123.759v-79.655l108.025.008v169.79h110.8v-169.79h117.37v79.647L583.71 229.48"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-rss',
    name: 'Rss',
    tags: ['feed', 'list'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 585.147 585.147"
        height="585.147"
        width="585.147"
      >
        <path
          d="M80.25 424.65c44.32 0 80.249 35.93 80.249 80.246 0 44.315-35.93 80.25-80.249 80.25-44.322 0-80.25-35.935-80.25-80.25 0-44.316 35.928-80.247 80.25-80.247"
          fill="#231f20"
        />
        <path d="M468.115 585.147c0-258.534-209.583-468.112-468.115-468.112V.004c323.163 0 585.14 261.976 585.14 585.143H468.115" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-scan',
    name: 'Scan',
    tags: ['radar', 'search'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 563.947 563.947"
        height="563.947"
        width="563.947"
      >
        <path
          d="M461.892 227.96c-8.636-28.85-24.337-56.04-47.11-78.807-3.263-3.264-8.55-3.25-11.803 0-3.256 3.27-3.256 8.556.008 11.81 20.429 20.421 34.569 44.716 42.508 70.518-10.703 5.448-18.048 16.536-18.048 29.37 0 15.557 10.781 28.554 25.268 32.022-2.547 40.11-19.074 79.451-49.736 110.115-33.442 33.428-77.194 50.116-121.018 50.125-43.824-.009-87.57-16.697-121.008-50.125a174.207 174.207 0 0 1-5.961-6.268 22.67 22.67 0 0 0 3.04-11.341c0-12.596-10.208-22.808-22.805-22.808-1.392 0-2.75.146-4.076.385-10.42-19.353-16.821-40.265-19.22-61.556 14.223-3.661 24.745-16.524 24.745-31.888 0-13.73-8.399-25.492-20.334-30.448a169.952 169.952 0 0 1 29.117-60.268l29.412 29.416a129.778 129.778 0 0 0-22.966 73.755c-.008 33.254 12.714 66.585 38.099 91.966a129.638 129.638 0 0 0 39.083 26.852c-.015.407-.062.81-.062 1.227 0 18.205 14.755 32.956 32.962 32.956 14.909 0 27.493-9.893 31.565-23.477 29.315-2.611 57.95-15.13 80.373-37.558 25.379-25.381 38.108-58.712 38.098-91.966.01-33.255-12.719-66.599-38.098-91.958a8.352 8.352 0 0 0-11.805 0 8.346 8.346 0 0 0 .01 11.81c22.146 22.141 33.187 51.11 33.198 80.148-.01 29.037-11.052 58.002-33.208 80.16-19.063 19.057-43.165 29.876-68.021 32.533-3.344-14.661-16.436-25.613-32.112-25.613-11.847 0-22.204 6.27-28.015 15.653-11.636-5.433-22.541-12.953-32.161-22.573-22.158-22.164-33.2-51.123-33.207-80.16.007-21.538 6.1-43.03 18.281-61.742l60.628 60.635c0 .11-.016.219-.016.327 0 18.21 14.759 32.962 32.962 32.962 18.208 0 32.964-14.752 32.964-32.962 0-17.391-13.482-31.608-30.562-32.842L162.537 128.017c-9.37-9.372-24.561-9.372-33.932 0-9.362 9.375-9.362 24.56 0 33.927l4.959 4.961c-16.442 21.17-27.756 45.02-33.898 69.914-16.293 1.994-28.916 15.857-28.916 32.693 0 15.227 10.335 28.003 24.362 31.788a186.67 186.67 0 0 0 21.849 70.472c-2.837 3.796-4.537 8.497-4.537 13.607 0 12.588 10.21 22.802 22.803 22.802 2.342 0 4.6-.357 6.728-1.01a196.722 196.722 0 0 0 7.192 7.625c36.649 36.653 84.773 55.012 132.814 55.012 48.042 0 96.163-18.359 132.822-55.012 33.974-33.979 52.21-77.804 54.693-122.28 13.793-3.939 23.896-16.605 23.896-31.665 0-17.707-13.968-32.111-31.48-32.891zm-14.47 219.463c-45.76 45.737-105.495 68.516-165.455 68.543-59.968-.027-119.704-22.798-165.454-68.543-45.348-45.362-68.516-104.339-68.535-163.396.037-60.864 22.403-121.362 68.535-167.51 45.75-45.737 105.486-68.505 165.454-68.54 59.96.035 119.701 22.803 165.454 68.54 45.735 45.739 68.506 105.483 68.532 165.45-.026 59.964-22.797 119.705-68.532 165.456zm33.923-364.831C426.353 27.572 354.044-.029 281.967-.007 209.88-.029 137.57 27.572 82.58 82.592 26.92 138.233-.035 211.477 0 284.027c-.017 71.605 28.218 142.976 82.58 197.328 55.001 55.011 127.301 82.617 199.387 82.592h.106c72.04 0 144.307-27.606 199.272-82.592 55.02-55 82.623-127.302 82.598-199.388.025-72.083-27.578-144.392-82.598-199.375"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-screensharing',
    name: 'Screensharing',
    tags: ['video', 'conference'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.573 506.787"
        height="506.787"
        width="582.573"
      >
        <path
          d="M532.503 456.706H180.525V214.015h351.978zM50.083 292.771V50.077h351.988v113.855H130.44v128.839zm402.06-128.839V-.005H0v342.861h130.44v163.93h452.133V163.933h-130.43"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-script-alt',
    name: 'Script alt',
    tags: ['medicine', 'rx'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 411.627 575.587"
        height="575.587"
        width="411.627"
      >
        <path
          d="M221.53 396.417l26.317 26.314 99.272-99.271-26.308-26.313zm59.565-138.989l-99.271 99.28 26.307 26.317 99.281-99.278zm-39.706-39.71l-99.276 99.278 26.315 26.31 99.275-99.263zm121.503 135.475L235.615 480.465c-3.252-13.04-9.898-25.447-20.062-35.602L197.79 427.11 48.738 278.06c-7.717-7.74-11.507-17.701-11.522-27.826.015-10.138 3.805-20.103 11.522-27.83 7.738-7.726 17.693-11.512 27.837-11.542 10.126.03 20.091 3.816 27.828 11.532 7.718 7.729 11.506 17.694 11.534 27.84-.028 10.125-3.816 20.1-11.534 27.826l26.315 26.315 119.509-119.51 94.912 94.895 17.753 17.766c7.723 7.726 11.51 17.697 11.527 27.828-.016 10.13-3.804 20.097-11.527 27.838zm-173.661 173.65c-7.73 7.732-17.71 11.504-27.892 11.536-10.091-.032-20.046-3.815-27.764-11.537-7.727-7.724-11.517-17.7-11.533-27.827.016-10.144 3.806-20.098 11.525-27.826l27.836-27.838 10.072 10.074 17.765 17.754c7.72 7.738 11.505 17.702 11.524 27.836-.019 10.127-3.804 20.093-11.533 27.827zm33.193-478.135c7.71-7.688 17.673-11.477 27.81-11.496 10.134.019 20.091 3.796 27.827 11.528 7.72 7.735 11.507 17.701 11.534 27.837-.027 10.127-3.814 20.088-11.534 27.826l-11.001 11.002-116.204 116.206a76.278 76.278 0 0 0-20.149-35.527 76.269 76.269 0 0 0-35.043-20.017zm166.783 222.504l-17.763-17.761-94.901-94.904 27.83-27.835A76.364 76.364 0 0 0 326.8 76.577a76.41 76.41 0 0 0-22.427-54.152C289.47 7.501 269.756-.017 250.233 0a76.43 76.43 0 0 0-54.149 22.434L29.304 189.972a78.002 78.002 0 0 0-6.886 6.12C7.511 210.991-.019 230.704 0 250.235a76.444 76.444 0 0 0 22.425 54.141l112.663 112.659-27.835 27.828c-14.924 14.9-22.445 34.612-22.425 54.152a76.424 76.424 0 0 0 22.435 54.148 76.403 76.403 0 0 0 54.076 22.424h.073c19.507 0 39.213-7.505 54.13-22.43l.006.006L389.207 379.5a76.391 76.391 0 0 0 22.421-54.146 76.357 76.357 0 0 0-22.421-54.143"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-script',
    name: 'Script',
    tags: ['medicine', 'rx'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 354.96 518.333"
        height="518.333"
        width="354.96"
      >
        <path
          d="M208.155 381.872l-23.61-23.613 99.28-99.27 23.608 23.607zm-54.867-54.876l-23.618-23.61 99.28-99.27 23.609 23.612zm187.465-64.572L322.99 244.66 222.02 143.681l-125.996 126-14.17-14.166c9.384-9.396 14.037-21.603 14.046-33.907-.01-12.304-4.662-24.524-14.046-33.904-9.39-9.39-21.607-14.036-33.904-14.05-12.31.014-24.52 4.66-33.908 14.05C4.657 197.092.01 209.304 0 221.608c.01 12.304 4.657 24.51 14.051 33.907l149.046 149.048 17.756 17.756a67.836 67.836 0 0 1 19.911 48.065c0 .232-.03.456-.033.684l140.022-140.021c9.484-9.508 14.199-21.862 14.207-34.324-.008-12.439-4.712-24.8-14.207-34.299zm-224.811-40.997L244.515 92.849l11.002-10.992c9.378-9.394 14.034-21.604 14.044-33.91-.01-12.302-4.666-24.508-14.044-33.899C246.124 4.66 233.913.007 221.612-.002c-12.305.009-24.525 4.665-33.897 14.037L48.759 153.624c17.095.193 34.215 6.86 47.257 19.905 13.207 13.202 19.883 30.59 19.926 47.898zm32.983 197.29l-16.146-16.14-33.915 33.903c-9.383 9.383-14.03 21.592-14.04 33.917.01 12.296 4.67 24.513 14.047 33.906 9.372 9.356 21.572 14.023 33.848 14.03 12.33-.007 24.569-4.642 33.96-14.03 9.377-9.393 14.036-21.61 14.046-33.92-.01-12.3-4.656-24.512-14.038-33.903l-17.762-17.763"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-search',
    name: 'Search',
    tags: ['find', 'look', 'magnify'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 594.573 594.107"
        height="594.107"
        width="594.573"
      >
        <path
          d="M234.513 411.179c-96.785-.622-175.027-79.878-174.416-176.67.62-96.172 79.352-174.416 175.5-174.421l1.174.003c46.889.294 90.857 18.832 123.8 52.198 32.94 33.367 50.918 77.57 50.616 124.468-.296 46.687-18.703 90.524-51.823 123.42-33.112 32.894-77.04 51.003-123.69 51.003zm351.942 89.513l-3.588-3.585.008-.003-143.352-143.363c19.917-34.312 31.488-74.086 31.76-116.601C472.117 106.987 367.296.816 237.152-.003c-.525-.002-1.035-.002-1.557-.002C106.18 0 .838 104.516.005 234.125-.82 364.271 104.003 470.44 234.133 471.271c.519.002 1.022.005 1.54.005 43.258 0 83.795-11.72 118.664-32.1l143.226 143.241.013-.012 3.581 3.58c10.834 10.832 28.391 10.823 39.219 0l46.079-46.072c10.822-10.822 10.829-28.39 0-39.22"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-settings',
    name: 'Settings',
    tags: ['profile'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 572.987 572.987"
        height="572.987"
        width="572.987"
      >
        <path
          d="M286.499 377.804c-50.427 0-91.304-40.877-91.304-91.305 0-50.426 40.877-91.308 91.304-91.308 50.424 0 91.3 40.882 91.3 91.308 0 50.428-40.876 91.305-91.3 91.305zm286.486-60.085V252.52l-9.208-3.008-69.8-22.788-18.626-44.97 35.801-75.752-46.115-46.107-8.634 4.384-65.467 33.25L345.975 78.9 317.71.007h-65.199l-3.004 9.216-22.788 69.802-44.95 18.623-75.778-35.799-46.097 46.107 4.382 8.632 33.244 65.488-18.612 44.941L0 255.27v65.211l9.218 3.004 69.802 22.792 18.622 44.957-35.793 75.76 46.09 46.117 8.646-4.393 65.47-33.24 44.958 18.623 28.251 78.887h65.204l3.012-9.21 22.792-69.8 44.961-18.622 75.758 35.806 46.112-46.12-4.382-8.64-33.249-65.458 18.625-44.967 78.888-28.257"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-share',
    name: 'Share',
    tags: ['link'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 387.467 578.493"
        height="578.493"
        width="387.467"
      >
        <path
          d="M293.355 390.277c-14.803 0-28.803 3.43-41.267 9.523l-72.164-72.172a93.712 93.712 0 0 0 8.288-38.604 93.747 93.747 0 0 0-8.29-38.613l71.866-71.866c12.532 6.184 26.64 9.679 41.567 9.679 51.977 0 94.108-42.137 94.108-94.112 0-51.973-42.131-94.105-94.108-94.105-51.974 0-94.103 42.132-94.103 94.105a93.82 93.82 0 0 0 6.975 35.576l-73.518 73.515a93.763 93.763 0 0 0-38.602-8.286C42.13 194.917 0 237.048 0 289.024c0 51.975 42.131 94.105 94.107 94.105a93.663 93.663 0 0 0 38.602-8.285l73.65 73.647a93.774 93.774 0 0 0-7.107 35.897c0 51.975 42.13 94.105 94.103 94.105 51.977 0 94.108-42.13 94.108-94.105s-42.131-94.11-94.108-94.11"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-shield',
    name: 'Shield',
    tags: ['secure'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 409.613 558.76"
        height="558.76"
        width="409.613"
      >
        <path
          d="M0 69.785C177.092 69.785 204.804.003 204.804.003s27.04 69.782 204.81 69.782v286.171c0 113.102-204.81 202.804-204.81 202.804S0 469.058 0 355.956V69.786"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-shift',
    name: 'Shift',
    tags: ['keyboard', 'modifier'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 488.6 419.133"
        height="419.133"
        width="488.6"
      >
        <path
          d="M244.297 49.019L76.655 229.229h67.132v156.516H344.8V229.23H411.94L244.297 49.02zm0-49.02L488.596 262.61h-110.41v156.522H110.404V262.611H0L244.297-.001"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-shopping-basket-alt',
    name: 'Shopping basket alt',
    tags: [],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 396.653 566.013"
        height="566.013"
        width="396.653"
      >
        <path
          d="M369.944 195.52H26.711L0 566.013h396.652zm-247.602-38.305l-.007-.008s-.008-.088-.04-.583c-.081-1.45-.288-5.417-.288-11.057-.088-15.88 1.884-45.272 11.113-67.83 4.543-11.33 10.665-20.641 18.087-26.745 7.512-6.05 16.162-9.84 30.164-9.965h33.381c14.133.137 22.832 4.044 30.475 10.376 11.358 9.417 19.62 27.188 24.017 46.368 4.505 19.046 5.41 38.697 5.39 49.974 0 3.167-.06 5.675-.122 7.355-.039.836-.061 1.475-.08 1.865-.023.402-.03.467-.023.467l40.95 2.723c.02-.38.317-4.982.317-12.41-.092-17.78-1.47-51.398-13.87-83.394-6.274-15.966-15.517-31.844-29.982-44.199C257.463 7.753 237.616-.14 214.752-.004h-33.381c-22.464-.13-42.015 7.392-56.322 19.379-21.57 18.068-31.736 43.365-37.452 66.598-5.627 23.384-6.605 45.571-6.626 59.594 0 8.826.42 14.38.451 14.808l40.92-3.16"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-shopping-basket',
    name: 'Shopping basket',
    tags: ['ecommerce', 'buy'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 547.24 555.707"
        height="555.707"
        width="547.24"
      >
        <path
          d="M449.344 298.607l97.895-97.888V66.804H126.945L102.468.007h-70.75C14.205.007 0 14.204 0 31.725c0 17.512 14.204 31.712 31.719 31.712h26.435l85.398 233.059-45.474 140.961h412.046c17.51 0 31.708-14.2 31.708-31.712 0-17.524-14.197-31.721-31.708-31.721h-324.93l24.329-75.417zM141.523 469.885c-23.7 0-42.908 19.207-42.908 42.907 0 23.703 19.208 42.915 42.908 42.915 23.701 0 42.914-19.212 42.914-42.915 0-23.7-19.213-42.907-42.914-42.907zm337.521 0c-23.696 0-42.91 19.207-42.91 42.907 0 23.703 19.214 42.915 42.91 42.915 23.7 0 42.913-19.212 42.913-42.915 0-23.7-19.213-42.907-42.913-42.907"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-shuffle',
    name: 'Shuffle',
    tags: ['control', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 584.48 420.613"
        height="420.613"
        width="584.48"
      >
        <path
          d="M165.2 287.856H.004v68.48h193.568l57.98-57.98-48.419-48.43zm299.201-.003h-52.789L179.587 55.832H0v68.483h151.217L383.244 356.34h81.157v64.272l119.36-98.516-119.36-98.514zm-46.54-155.109l47.25.01v64.271l119.362-98.514L465.111-.003v64.274h-75.499l-62.307 61.926 48.279 48.578 42.277-42.031"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-slideshow',
    name: 'Slideshow',
    tags: ['presentation'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.227 588.28"
        height="588.28"
        width="582.227"
      >
        <path
          d="M462.296 319.441h-110.99v33.395h110.99zm0-61.269h-110.99v33.381h110.99zm0-61.273h-110.99v33.385h110.99zm-265.41 178.169c47.923 0 86.78-38.855 86.78-86.783h-86.78zm-24.38-23.665v-86.779h86.78c0-47.924-38.85-86.776-86.78-86.776-47.921 0-86.771 38.852-86.771 86.776 0 47.925 38.85 86.779 86.772 86.779zm340.745 75.182H62.909V134.761H513.25zM302.575 48.636V.001h-33.387v48.635H0v86.125h29.525V459.97H235.24L110.09 562.452l21.146 25.828 156.692-128.31h1.11l156.695 128.31 21.152-25.837-125.158-102.474h204.909V134.761h35.588V48.636h-279.65"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-sound-low',
    name: 'Sound low',
    tags: ['audio', 'turn down', 'decrease'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 356.013 375.573"
        height="375.573"
        width="356.013"
      >
        <path
          d="M298.816 49.708c-8.896-8.893-23.313-8.893-32.208 0-8.893 8.896-8.893 23.315.013 32.21h-.013c29.257 29.271 43.824 67.415 43.85 105.745-.026 38.446-14.555 76.657-43.85 105.987-8.893 8.898-8.893 23.32.013 32.211 4.44 4.443 10.268 6.664 16.092 6.668 5.834 0 11.666-2.23 16.114-6.677 38.112-38.11 57.208-88.273 57.182-138.19.026-49.873-19.144-99.923-57.193-137.954zM0 112.387V263.18h67.782l151.42 112.393V-.003L67.786 112.387H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-sound-medium',
    name: 'Sound medium',
    tags: ['audio', 'turn up', 'increase'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 457.8 433.747"
        height="433.747"
        width="457.8"
      >
        <path
          d="M370.744 6.675c-8.904-8.894-23.324-8.894-32.216 0-8.89 8.894-8.89 23.316.008 32.205h-.008c49.116 49.135 73.7 113.277 73.719 177.627-.027 64.645-24.459 129.063-73.719 178.361-8.89 8.888-8.89 23.316.008 32.215a22.711 22.711 0 0 0 16.099 6.664 22.74 22.74 0 0 0 16.109-6.672c58.1-58.118 87.081-134.487 87.059-210.568.02-75.919-29.179-151.97-87.059-209.832zm-71.92 72.124c-8.907-8.894-23.32-8.894-32.212 0-8.899 8.897-8.899 23.312.005 32.204h-.005c29.253 29.274 43.82 67.413 43.847 105.754-.027 38.447-14.556 76.654-43.847 105.984-8.899 8.898-8.899 23.323.005 32.21a22.728 22.728 0 0 0 16.104 6.67 22.71 22.71 0 0 0 16.114-6.677c38.101-38.117 57.193-88.276 57.177-138.187.016-49.878-19.148-99.926-57.188-137.958zM0 141.476v150.793h67.785l151.418 112.394V29.087L67.79 141.476H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-sound-off',
    name: 'Sound off',
    tags: ['audio', 'mute'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 219.2 375.573"
        height="375.573"
        width="219.2"
      >
        <path
          d="M219.203-.003l-151.42 112.39H0V263.18h67.784l151.419 112.393V-.003"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-sound',
    name: 'Sound',
    tags: ['audio'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 563.827 580.68"
        height="580.68"
        width="563.827"
      >
        <path
          d="M446.343 6.67c-8.906-8.895-23.324-8.895-32.215 0-8.892 8.895-8.892 23.31 0 32.206 69.4 69.428 104.125 160.172 104.148 251.121-.023 91.223-34.605 182.227-104.148 251.802-8.899 8.895-8.892 23.316 0 32.207a22.698 22.698 0 0 0 16.105 6.674 22.72 22.72 0 0 0 16.11-6.674c78.376-78.375 117.514-181.323 117.485-284.009.03-102.497-39.307-205.149-117.485-283.326zm-75.6 73.47c-8.896-8.892-23.316-8.892-32.214 0-8.89 8.899-8.89 23.315.007 32.21l-.007-.009c49.114 49.136 73.7 113.284 73.722 177.631-.03 64.648-24.464 129.075-73.722 178.359-8.896 8.893-8.89 23.318.007 32.209a22.707 22.707 0 0 0 16.1 6.672 22.729 22.729 0 0 0 16.113-6.672c58.096-58.104 87.076-134.481 87.048-210.568.023-75.915-29.172-151.963-87.054-209.832zm-71.92 72.13c-8.894-8.895-23.318-8.895-32.211 0-8.895 8.894-8.895 23.306.007 32.2h-.007c29.255 29.274 43.817 67.409 43.848 105.751-.03 38.444-14.559 76.67-43.848 105.98-8.895 8.903-8.895 23.323.007 32.218a22.713 22.713 0 0 0 16.102 6.662c5.828 0 11.662-2.22 16.108-6.67 38.106-38.111 57.204-88.276 57.18-138.19.024-49.878-19.145-99.924-57.186-137.952zM0 214.942v150.794h67.786l151.418 112.387V102.552L67.786 214.942H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-stop-alt',
    name: 'Stop alt',
    tags: ['control', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 558 558"
        height="558"
        width="558"
      >
        <path
          d="M163.43 558L0 394.564V163.439L163.43.003h231.13l163.437 163.436v231.125L394.56 558H163.43"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-stop',
    name: 'Stop',
    tags: ['control', 'media'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 445.693 448.2"
        height="448.2"
        width="445.693"
      >
        <path d="M445.695 448.2H0V.004h445.695V448.2" fill="#231f20" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-sync',
    name: 'Sync',
    tags: ['refresh', 'reload'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.333 582.347"
        height="582.347"
        width="582.333"
      >
        <path
          d="M435.408 433.864c-36.808 37.224-87.745 60.245-144.244 60.235-56.187-.011-106.637-22.642-143.497-59.432-36.802-36.86-59.42-87.31-59.442-143.486H0C.022 452 130.335 582.31 291.164 582.347c80.719-.011 153.91-32.975 206.639-86.084l65.329 65.333V364.201h-197.39zM221.349 219.545l-72.758-72.754C185.26 110.56 235.5 88.24 291.16 88.24c56.174.017 106.63 22.644 143.495 59.436 36.792 36.864 59.415 87.323 59.437 143.505h88.236C582.297 130.35 451.981.032 291.161 0 211.3 0 138.792 32.27 86.195 84.393L19.048 17.247l.004 202.298H221.35"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-tab',
    name: 'Tab',
    tags: ['keyboard', 'modifier'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.213 248.36"
        height="248.36"
        width="582.213"
      >
        <path
          d="M512.808 161.157V33.39c0-18.437-14.947-33.385-33.384-33.385H102.798c-18.438 0-33.384 14.948-33.384 33.385v127.768H0v87.203h582.219v-87.203h-69.411"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-tag',
    name: 'Tag',
    tags: ['badge'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 454.013 457.227"
        height="457.227"
        width="454.013"
      >
        <path
          d="M405.09 103.641c-15.117 15.119-39.626 15.119-54.743 0-15.12-15.113-15.12-39.624 0-54.74 15.114-15.125 39.626-15.125 54.742-.005 15.116 15.121 15.118 39.632 0 54.745zM415.623.004L271.103.008 0 269.698l187.524 187.529 266.49-266.494V38.397L415.623.004"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-tags',
    name: 'Tags',
    tags: ['badge'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 492.4 568.027"
        height="568.027"
        width="492.4"
      >
        <path
          d="M288.444 89.65l8.732-8.69h156.839V38.399L415.624.004 271.1.012 0 269.702l53.583 53.586L288.444 89.651"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-target',
    name: 'Target',
    tags: ['bulls-eye'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 492.813 492.813"
        height="492.813"
        width="492.813"
      >
        <path
          d="M335.795 246.415c0 49.369-40.024 89.394-89.39 89.394-49.369 0-89.392-40.025-89.392-89.394 0-49.368 40.023-89.384 89.392-89.384 49.366 0 89.39 40.016 89.39 89.384"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-terminal',
    name: 'Terminal',
    tags: ['program', 'computer'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.213 502.813"
        height="502.813"
        width="582.213"
      >
        <path
          d="M550.085 469.43H33.382V84.271h516.703zM0 .003v502.81h582.219V.003zm329.845 253.812h-91.437v-22.09h91.437zm-120.75-36.465l-96.933 40.798v-26.926l73.589-26.192-73.589-26.439V152.4l96.933 41.13zM516.7 117.656H66.77v318.39H516.7v-318.39"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-thumb-down',
    name: 'Thumb down',
    tags: ['vote down'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 393.413 552.893"
        height="552.893"
        width="393.413"
      >
        <path
          d="M393.416 215.972c0-24.553-4.577-44.488-29.15-44.488h-.182c18.365-3.132 22.05-20.881 22.05-42.405 0-23.7-4.418-42.927-28.14-42.927h-20.38c16.077-4.55 19.417-21.805 19.417-42.47 0-24.12-4.498-43.678-28.611-43.678H122.688C54.934.004 0 54.929 0 122.694V253.63c0 48.053 26.58 86.168 68.365 102.446 32.525 21.383 98.027 72.304 111.984 143.074v53.392s91.502 9.937 91.502-76.08c0-101.307-63.778-117.768-13.003-120.236h75.733c26.754 0 31.722-21.69 31.722-48.45 0-23.234-3.767-42.612-22.267-47.32h20.23c24.573 0 29.15-19.912 29.15-44.485"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-thumb-up',
    name: 'Thumb up',
    tags: ['vote up'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 389.867 582.987"
        height="582.987"
        width="389.867"
      >
        <path
          d="M202.505 264.127c0 21.392 3.976 38.717 25.372 38.717h118.118c21.39 0 25.364-17.325 25.364-38.717 0-21.395-3.974-38.734-25.364-38.734H227.877c-21.396 0-25.372 17.339-25.372 38.734M181.061 355.92c0 21.381 3.984 38.733 25.356 38.733H364.49c21.396 0 25.38-17.352 25.38-38.733 0-21.39-3.984-38.728-25.38-38.728H206.417c-21.372 0-25.356 17.337-25.356 38.728M202.213 449.121c0 21.378 3.984 38.715 25.352 38.715h124.692c21.391 0 25.38-17.337 25.38-38.715 0-21.405-3.989-38.733-25.38-38.733H227.565c-21.368 0-25.352 17.328-25.352 38.733M222.793 544.268c0 21.38 3.984 38.719 25.36 38.719h71.03c21.378 0 25.369-17.339 25.369-38.72 0-21.403-3.99-38.732-25.37-38.732h-71.029c-21.376 0-25.36 17.329-25.36 38.733"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-thumbnail-list',
    name: 'Thumbnail list',
    tags: ['view', 'layout', 'images'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 445.573 441.08"
        height="441.08"
        width="445.573"
      >
        <path
          d="M230.14 68.487V.004h215.432v68.483H230.14M230.14 172.921V104.44h215.432v68.482H230.14M230.14 336.653v-68.489h215.432v68.49H230.14M230.14 441.08v-68.484h215.432v68.484H230.14M171.824 173.515H0V1.688h171.824v171.827M171.824 440.594H0V268.767h171.824v171.827"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-thumbnails-small',
    name: 'Thumbnails small',
    tags: ['view', 'layout', 'images'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 528 526.28"
        height="526.28"
        width="528"
      >
        <path
          d="M378.37 526.28h149.625V376.648H378.37zm-189.185 0h149.63V376.648h-149.63zM0 526.28h149.63V376.648H0zm378.37-188.325h149.625V188.32H378.37zm-189.185 0h149.63V188.32h-149.63zM0 337.955h149.63V188.32H0zM378.37-.004v149.63h149.625V-.003zm-189.185 149.63h149.63V-.003h-149.63zM0 149.627h149.63V-.003H0v149.63"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-thumbnails',
    name: 'Thumbnails',
    tags: ['view', 'layout', 'images'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 443.92 438.907"
        height="438.907"
        width="443.92"
      >
        <path
          d="M171.824 171.828H0V.001h171.824v171.827M443.915 171.828H272.087V.001h171.828v171.827M171.824 438.907H0V267.08h171.824v171.827M443.915 438.907H272.087V267.08h171.828v171.827"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-time',
    name: 'Time',
    tags: ['watch', 'clock'],
    svg: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 0C23.5484 0 26.9355 0.967742 30 2.74194C33.0645 4.51613 35.4839 6.93548 37.2581 10C39.0323 13.0645 40 16.4516 40 20C40 23.629 39.0323 26.9355 37.2581 30C35.4839 33.0645 33.0645 35.5645 30 37.3387C26.9355 39.1129 23.5484 40 20 40C16.371 40 13.0645 39.1129 10 37.3387C6.93548 35.5645 4.43548 33.0645 2.66129 30C0.887097 26.9355 0 23.629 0 20C0 16.4516 0.887097 13.0645 2.66129 10C4.43548 6.93548 6.93548 4.51613 10 2.74194C13.0645 0.967742 16.371 0 20 0ZM20 36.129C22.9032 36.129 25.5645 35.4032 28.0645 33.9516C30.4839 32.5 32.5 30.5645 33.9516 28.0645C35.4032 25.6452 36.129 22.9032 36.129 20C36.129 17.0968 35.4032 14.4355 33.9516 11.9355C32.5 9.51613 30.4839 7.5 28.0645 6.04839C25.5645 4.59677 22.9032 3.87097 20 3.87097C17.0968 3.87097 14.3548 4.59677 11.9355 6.04839C9.43548 7.5 7.5 9.51613 6.04839 11.9355C4.59677 14.4355 3.87097 17.0968 3.87097 20C3.87097 22.9032 4.59677 25.6452 6.04839 28.0645C7.5 30.5645 9.43548 32.5 11.9355 33.9516C14.3548 35.4032 17.0968 36.129 20 36.129ZM25 27.7419C25.1613 27.9032 25.4032 27.9839 25.7258 27.9032C25.9677 27.9032 26.2097 27.7419 26.371 27.5L27.8226 25.4032C27.9839 25.2419 27.9839 25 27.9839 24.6774C27.9839 24.4355 27.8226 24.1935 27.6613 24.0323L22.2581 20.1613V8.70968C22.2581 8.46774 22.0968 8.22581 21.9355 8.06452C21.7742 7.90323 21.5323 7.74194 21.2903 7.74194H18.7097C18.3871 7.74194 18.1452 7.90323 17.9839 8.06452C17.8226 8.22581 17.7419 8.46774 17.7419 8.70968V21.9355C17.7419 22.2581 17.8226 22.5806 18.1452 22.7419L25 27.7419Z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-tools',
    name: 'Tools',
    tags: ['wrench', 'handyman'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 550.427 532.813"
        height="532.813"
        width="550.427"
      >
        <path
          d="M271.779 302.244l30.322 30.321 34.396-34.396c-1.865-16.781 3.598-34.216 16.462-47.076 12.857-12.858 30.293-18.32 47.069-16.46L550.421 84.24 466.181.003l-150.39 150.393c1.864 16.776-3.602 34.21-16.462 47.076-12.86 12.861-30.296 18.32-47.076 16.455l-34.392 34.398 30.31 30.312L99.563 427.245l-5.437-5.437-28.527 22.977-47.983 75.776 12.249 12.252 75.783-47.98 22.97-28.528-5.455-5.45zM485.88 497.588l-27.836 7.459-22.584-22.587 7.459-27.83 27.839-7.464 22.582 22.587zM350.376 281.712a44.53 44.53 0 0 0-.816 14.772l.708 6.379-4.541 4.54-34.39 34.4-9.445 9.437-30.315-30.316-19.341 19.341 175.501 175.51c10.822 10.817 24.999 16.224 39.18 16.224 14.175 0 28.354-5.407 39.167-16.224 21.643-21.64 21.643-56.716 0-78.35zm-196.45-39.792c.13.13.24.276.373.408l55.442 55.441 19.339-19.338-20.875-20.87-9.437-9.446 48.379-48.378 6.381.71c1.627.186 3.29.277 4.944.277 3.341 0 6.613-.41 9.795-1.121l-35.619-35.623c-.719-.721-1.496-1.355-2.245-2.032 10.977-39.461.984-83.535-30.048-114.563C169.553 16.58 125.9 6.513 86.66 17.103l66.486 66.482-17.455 65.131-65.134 17.46L4.07 99.689c-10.592 39.246-.514 82.902 30.287 113.702 32.345 32.348 78.871 41.837 119.568 28.529"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-trafic',
    name: 'Trafic',
    tags: ['network', 'internet'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 423.787 421.4"
        height="421.4"
        width="423.787"
      >
        <path
          d="M119.36 224.375L0 322.884 119.36 421.4v-64.276h245.015v-68.485H119.36zm185.067-27.356l119.362-98.511L304.427-.005V64.26H58.86v68.484h245.567v64.274"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-trash-alt',
    name: 'Trash alt',
    tags: ['garbage', 'delete', 'remove'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 509.12 586.4"
        height="586.4"
        width="509.12"
      >
        <path
          d="M330.056 72.69H179.06V60.2c.013-10.572 8.588-19.14 19.164-19.167h112.67c10.57.027 19.138 8.595 19.162 19.167zm150.703 0h-109.67V60.2C371.075 26.943 344.144.01 310.893.007H198.224c-33.26.002-60.192 26.936-60.208 60.193v12.49H28.365C12.703 72.69 0 85.39 0 101.054v68.451h509.121v-68.45c0-15.663-12.701-28.363-28.362-28.363zM79.133 586.4h350.856l33.647-383.51H45.486L79.134 586.4"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-trash',
    name: 'Trash',
    tags: ['garbage', 'delete', 'remove'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 442.347 586.4"
        height="586.4"
        width="442.347"
      >
        <path
          d="M296.659 72.683H145.664l-.005-12.48c.032-10.586 8.593-19.146 19.177-19.163H277.5c10.572.017 19.145 8.577 19.159 19.163zm117.317 0h-76.279v-12.48C337.693 26.945 310.752.009 277.5 0H164.836c-33.255.01-60.193 26.945-60.205 60.203v12.48H28.365C12.705 72.683 0 85.384 0 101.049v75.13h442.341v-75.13c0-15.665-12.701-28.366-28.365-28.366zM113.852 288.017c0-11.334 9.192-20.521 20.517-20.521 11.331 0 20.522 9.187 20.522 20.521v216.171c0 11.33-9.191 20.517-20.522 20.517-11.325 0-20.517-9.186-20.517-20.517zm86.797 0c0-11.326 9.19-20.521 20.52-20.521 11.328 0 20.523 9.195 20.523 20.521v216.168c0 11.329-9.195 20.52-20.523 20.52-11.33 0-20.52-9.191-20.52-20.52zm86.802-.004c0-11.33 9.188-20.514 20.525-20.514 11.327 0 20.513 9.184 20.513 20.514v216.172c0 11.329-9.186 20.524-20.513 20.524-11.337 0-20.525-9.195-20.525-20.524zM45.742 586.4h350.86V213.312H45.741V586.4"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-umbrella',
    name: 'Umbrella',
    tags: ['rain'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.227 568.52"
        height="568.52"
        width="582.227"
      >
        <path
          d="M308.259 38.69V-.008h-34.294V38.69C121.174 47.575 0 174.27 0 329.293h6.179c9.884-27.62 36.207-47.412 67.22-47.412 31.01 0 57.335 19.792 67.222 47.412h10.699c9.888-27.62 36.208-47.412 67.223-47.412 22.672 0 42.805 10.608 55.874 27.088v197.603c.008 34.226 27.738 61.94 61.955 61.948 34.21-.008 61.939-27.722 61.947-61.948 0-9.223-7.476-16.69-16.698-16.69-9.217 0-16.69 7.467-16.69 16.69-.032 15.768-12.798 28.538-28.559 28.559-15.77-.021-28.536-12.791-28.57-28.559V308.975c13.069-16.486 33.206-27.094 55.88-27.094 31.014 0 57.337 19.792 67.225 47.412h10.697c9.89-27.62 36.21-47.412 67.223-47.412 31.01 0 57.336 19.792 67.221 47.412h6.175c0-155.024-121.171-281.721-273.964-290.604"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-universal',
    name: 'Universal',
    tags: ['yin yang'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 592.04 592.04"
        height="592.04"
        width="592.04"
      >
        <path
          d="M296.019 33.39c145.049 0 262.642 117.582 262.642 262.633 0 17.97-1.821 35.513-5.254 52.465-16.967 53.421-66.934 92.133-125.954 92.133-72.997 0-132.182-59.169-132.182-132.164 0-72.992-59.172-132.165-132.168-132.165-63.554 0-116.598 44.868-129.257 104.656 7.818-138.03 122.19-247.557 262.173-247.557zm0-33.39C132.794 0 0 132.795 0 296.023 0 459.245 132.794 592.04 296.019 592.04c163.228 0 296.025-132.795 296.025-296.017C592.044 132.795 459.247 0 296.019 0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-unlocked',
    name: 'Unlocked',
    tags: ['insecure'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 585.76 572.027"
        height="572.027"
        width="585.76"
      >
        <path
          d="M563.643 268.428H311.827l-.006-104.555c0-44.369-16.84-85.098-44.716-114.898C239.344 19.165 199.667-.033 155.917-.001 112.164-.033 72.49 19.165 44.73 48.975 16.842 78.775.008 119.504 0 163.873v138.48h81.344v-17.968l-47.541-47.541h47.541v-72.97c0-23.686 8.956-44.542 22.78-59.337 13.95-14.786 31.903-23.16 51.793-23.192 19.888.032 37.832 8.406 51.782 23.192 13.833 14.795 22.789 35.651 22.782 59.336v104.555h-34.918c-12.211 0-22.108 9.901-22.108 22.113v259.375c0 12.21 9.897 22.11 22.108 22.11h368.08c12.218 0 22.116-9.9 22.116-22.11V290.54c0-12.212-9.898-22.113-22.116-22.113"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-usb',
    name: 'Usb',
    tags: ['computer', 'data', 'connection'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 327.267 584.787"
        height="584.787"
        width="327.267"
      >
        <path
          d="M327.261 95.707h-69.268v69.662h16.03c-.782 25.98-3.51 44.092-8.935 57.407-6.63 16.188-16.863 27.768-38.508 42.579-15.559 10.544-29.477 21.346-41.123 34.134V73.723h24.574L167.1 0l-42.925 73.722h24.562v301.024c-11.542-12.554-25.297-23.194-40.642-33.583-21.64-14.81-31.877-26.392-38.509-42.579-6.043-14.822-8.724-35.608-9.108-66.549 13.981-6.835 23.634-21.157 23.634-37.767 0-23.226-18.826-42.054-42.056-42.054C18.833 152.215 0 171.043 0 194.269c0 16.659 9.714 31.018 23.764 37.824.418 32.871 2.93 57.979 11.746 80.168 9.657 24.386 27.293 42.747 51.997 59.31 22.362 15.137 37.127 28.208 46.677 44.818 6.233 10.83 10.728 23.914 13.117 41.433-27.383 7.527-47.53 32.526-47.53 62.295 0 35.723 28.958 64.67 64.676 64.67 35.702 0 64.661-28.947 64.661-64.67 0-28.348-18.27-52.372-43.65-61.102v-48.592c.398-32.962 5.831-53.84 15.035-69.848 9.559-16.595 24.311-29.668 46.683-44.814 24.69-16.558 42.332-34.916 51.993-59.304 7.984-20.106 10.794-42.596 11.57-71.088h16.522V95.707"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-user',
    name: 'User',
    tags: ['person', 'man', 'woman'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 580.8 538.093"
        height="538.093"
        width="580.8"
      >
        <path
          d="M392.913 51.767c4.902 19.732 5.392 21.374 4.936 41.633-.184 7.807-4.666 43.915-3.448 54.99 1.002 9.135 3.28 9.86 6.883 17.387 6.273 13.099 4.173 31.168 1.767 44.376-1.318 7.228-4.102 17.515-8.331 23.415-4.663 6.501-13.997 6.55-18.123 14.136-5.945 10.927-2.588 26.256-6.336 38.053-4.257 13.378-15.1 14.318-15.917 31.823 5.315.75 10.616 1.512 15.917 2.27 5.322 11.314 15.063 34.07 25.012 40.918 8.334 2.273 16.674 4.548 25.003 6.817 29.21 11.976 61.668 26.31 90.939 38.65 26.654 11.245 58.569 15.253 68.202 43.196 0 18.972 1.79 63.797 1.3 88.662H.085c-.49-24.865 1.298-69.69 1.298-88.662 9.634-27.943 41.547-31.951 68.202-43.196 29.27-12.34 61.729-26.674 90.935-38.65 8.333-2.269 16.675-4.544 25.005-6.817 9.947-6.848 19.692-29.604 25.012-40.917l11.836-2.878c-2.688-14.941-11.938-16.104-15.792-26.68-1.512-15.908-3.025-31.826-4.545-47.74.073.75-10.884-1.997-12.317-2.894-15.44-9.676-15.755-48.964-17.242-65.304-.676-7.47 9.712-13.591 6.826-27.287-16.922-80.184 7.314-117.71 45.638-130.153 26.6-10.778 76.264-30.764 122.588-2.271L359.025 25.3l18.603 3.205c9.332 5.388 15.285 23.262 15.285 23.262"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-users-alt',
    name: 'Users alt',
    tags: ['person', 'man', 'woman', 'people'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.093 390.493"
        height="390.493"
        width="582.093"
      >
        <path
          d="M581.603 304.887c-3.372-9.78-14.547-11.183-23.882-15.123-10.246-4.321-21.612-9.333-31.842-13.536-2.912-.788-5.83-1.59-8.751-2.384-3.483-2.399-6.892-10.364-8.756-14.323-1.859-.269-3.716-.533-5.573-.802.286-6.124 4.078-6.458 5.573-11.138 1.31-4.133.135-9.498 2.22-13.317 1.444-2.661 4.707-2.68 6.343-4.96 1.481-2.064 2.46-5.663 2.918-8.196.842-4.628 1.575-10.953-.624-15.537-1.258-2.635-2.056-2.891-2.405-6.086-.432-3.876 1.144-16.522 1.207-19.253.161-7.096-.011-13.513-1.73-20.428 0 0-2.085-6.252-5.352-8.135l-6.509-1.121-4.03-3.732c-16.223-9.983-33.609-2.987-42.918.79-13.42 4.36-21.908 23.338-15.98 51.413 1.008 4.8-2.627 6.94-2.387 9.558.515 5.72.627 19.475 6.032 22.863.504.317 4.339 1.276 4.314 1.013.529 5.568 1.065 11.147 1.594 16.715 1.346 3.705 4.586 4.108 5.524 9.337l-4.142 1.016c-1.578 3.355-4.268 9.547-7.171 12.832 5.28 2.242 10.627 4.535 15.885 6.797 6.128 2.626 12.207 5.245 18.04 7.703 2.682 1.13 5.54 2.124 8.567 3.171 11.49 3.979 25.792 8.93 31.101 24.324l.534 1.553v1.64c0 3.623.14 9.431.286 15.582.026.922.047 1.868.071 2.808h62.296c.175-8.704-.453-24.396-.453-31.044zm-106.146-9.02c-14.682-6.187-30.968-13.38-45.62-19.39-4.18-1.133-8.366-2.277-12.546-3.42-4.992-3.434-9.878-14.85-12.547-20.526-2.661-.382-5.321-.763-7.985-1.143.409-8.788 5.845-9.255 7.985-15.964 1.88-5.924.196-13.605 3.177-19.09 2.072-3.807 6.751-3.83 9.088-7.091 2.124-2.962 3.527-8.131 4.188-11.751 1.206-6.621 2.254-15.695-.89-22.264-1.808-3.777-2.95-4.141-3.452-8.72-.614-5.557 1.637-23.675 1.728-27.593.229-10.167-.012-19.362-2.474-29.26 0 0-2.988-8.972-7.672-11.671l-9.332-1.6-5.772-5.348c-23.237-14.305-48.16-4.277-61.496 1.13-19.23 6.246-31.393 33.449-22.902 73.674 1.45 6.87-3.766 9.941-3.418 13.687.743 8.205.895 27.913 8.647 32.768.715.453 6.213 1.83 6.18 1.45.757 7.979 1.52 15.972 2.277 23.954 1.935 5.304 6.576 5.89 7.92 13.384l-5.932 1.448c-1.904 4.042-4.937 10.966-8.328 15.872 7.38 3.132 14.851 6.33 22.195 9.493 8.57 3.685 17.072 7.341 25.224 10.773 3.877 1.644 7.953 3.052 12.264 4.548 16.105 5.58 34.364 11.899 41.184 31.676l.533 1.55v1.645c0 5.141.202 13.355.41 22.043.093 3.872.189 7.886.276 11.893h91.964c.246-12.47-.65-34.967-.65-44.484-4.836-14.013-20.848-16.028-34.224-21.672zm-115.624 1.818c-20.605-8.682-43.45-18.773-64.009-27.208a13953.89 13953.89 0 0 1-17.603-4.8c-7.002-4.814-13.86-20.834-17.605-28.801l-11.203-1.592c.578-12.323 8.21-12.985 11.203-22.399 2.641-8.306.277-19.098 4.464-26.785 2.905-5.336 9.47-5.373 12.753-9.948 2.978-4.156 4.936-11.399 5.866-16.483 1.69-9.293 3.168-22.014-1.247-31.238-2.536-5.294-4.139-5.804-4.843-12.235-.854-7.793 2.298-33.21 2.428-38.708.322-14.26-.021-27.159-3.474-41.052 0 0-4.194-12.581-10.76-16.376l-13.09-2.248-8.096-7.501c-32.605-20.066-67.564-5.991-86.282 1.596-26.98 8.758-44.04 46.92-32.13 103.357 2.034 9.635-5.28 13.95-4.8 19.21 1.048 11.503 1.263 39.153 12.138 45.962 1.008.637 8.717 2.565 8.672 2.037l3.193 33.606c2.716 7.448 9.225 8.262 11.117 18.777l-8.329 2.02c-3.747 7.967-10.603 23.987-17.61 28.801-5.863 1.604-11.733 3.205-17.597 4.8-20.557 8.435-43.406 18.526-64.007 27.208C30.223 305.607 7.76 308.423.974 328.088c0 13.36-1.254 44.903-.916 62.405h408.694c.341-17.502-.915-49.045-.915-62.405-6.781-19.665-29.246-22.481-48.004-30.403"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-users',
    name: 'Users',
    tags: ['person', 'man', 'woman', 'people'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 586.493 399.72"
        height="399.72"
        width="586.493"
      >
        <path
          d="M585.785 325.27c-4.946-14.343-21.337-16.405-35.026-22.177-15.032-6.338-31.7-13.701-46.7-19.85a24159.56 24159.56 0 0 0-12.84-3.503c-5.112-3.516-10.11-15.203-12.848-21.013-2.72-.39-5.446-.779-8.172-1.167.421-8.992 5.985-9.476 8.172-16.344 1.926-6.064.202-13.933 3.257-19.539 2.116-3.896 6.91-3.924 9.305-7.26 2.174-3.03 3.606-8.32 4.282-12.028 1.234-6.781 2.31-16.062-.912-22.79-1.848-3.866-3.019-4.236-3.532-8.923-.628-5.688 1.673-24.232 1.77-28.245.235-10.406-.018-19.818-2.534-29.951 0 0-3.062-9.183-7.85-11.95l-9.554-1.64-5.906-5.474c-23.79-14.636-49.298-4.368-62.952 1.16-7.6 2.467-14.098 8.167-18.741 16.557-.15 2.782-.203 5.058-.08 6.224.065.61.132.968.165 1.144.16.304.347.603.536.927.696 1.19 1.652 2.817 2.723 5.065 6.697 13.99 4.717 30.763 2.643 42.172-1.027 5.627-3.542 16.183-8.862 23.608a26.367 26.367 0 0 1-4.472 4.803c.844 8.892 2.659 19.124 7.998 22.468.736.46 6.36 1.872 6.329 1.488.776 8.17 1.555 16.344 2.332 24.513 1.977 5.435 6.732 6.028 8.11 13.696l-6.08 1.486c-.477 1.013-1.025 2.213-1.631 3.51 12.47 5.14 25.756 10.838 38.629 16.378 8.716 3.748 17.356 7.462 25.64 10.953 3.765 1.595 7.833 3.001 12.137 4.49 17.043 5.898 38.251 13.245 46.294 36.567l.914 2.647v2.795c0 5.18.202 13.528.415 22.37.093 4.024.196 8.197.285 12.367h67.422c.254-12.765-.666-35.79-.666-45.533zM191.82 139.394c-.659-7.236 2.343-12.716 4.135-15.997.344-.636.798-1.463 1.021-1.963a209.73 209.73 0 0 1-3.32-20.953l-9.279-1.59-5.902-5.474c-23.791-14.636-49.298-4.368-62.952 1.16-19.687 6.396-32.133 34.237-23.44 75.413 1.477 7.032-3.856 10.178-3.504 14.016.762 8.39.918 28.568 8.853 33.539.734.46 6.36 1.872 6.328 1.488l2.33 24.513c1.98 5.435 6.735 6.028 8.108 13.696l-6.079 1.486c-2.73 5.81-7.732 17.497-12.84 21.013-4.28 1.165-8.566 2.335-12.842 3.503-14.999 6.149-31.668 13.512-46.705 19.85C22.047 308.865 5.66 310.927.71 325.271c0 9.742-.92 32.768-.664 45.533H67.78c.087-4.17.183-8.343.284-12.368.21-8.841.411-17.19.411-22.37v-2.794l.914-2.647c8.047-23.322 29.253-30.669 46.293-36.566 4.304-1.49 8.371-2.896 12.14-4.491 8.27-3.483 16.897-7.195 25.594-10.934 12.803-5.505 26.003-11.17 38.411-16.285a643.13 643.13 0 0 0-1.68-3.622c-2.724-.39-5.444-.779-8.175-1.167.422-8.992 5.99-9.476 8.175-16.344 1.927-6.064.2-13.933 3.256-19.539 2.117-3.896 6.91-3.924 9.304-7.26 2.17-3.03 3.605-8.32 4.28-12.028a82.05 82.05 0 0 0 .93-6.502c-12.998-11.98-14.622-35.258-15.703-51.16-.138-2.006-.26-3.812-.395-5.334"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-utilities',
    name: 'Utilities',
    tags: ['toolbox'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 582.587 495.187"
        height="495.187"
        width="582.587"
      >
        <path
          d="M324.513 309.117v-98.84h-66.438v98.84zM174.01 60.204c.019-10.575 8.587-19.147 19.163-19.165h196.235c10.581.018 19.144 8.59 19.17 19.165v36.492H174.01zm50.866 116.775h133.208v53.253h224.474V125.055c0-15.658-12.7-28.359-28.364-28.359H449.608V60.204c-.013-33.259-26.943-60.19-60.201-60.205H193.172c-33.25.016-60.185 26.946-60.202 60.205v36.492H28.364C12.702 96.696 0 109.397 0 125.055v105.177h224.875zm133.208 87.464v78.142H224.875v-78.142H.369v230.744h582.22V264.443H358.083"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-vcard',
    name: 'Vcard',
    tags: ['address', 'profile'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 584.307 363.36"
        height="363.36"
        width="584.307"
      >
        <path
          d="M527.49 191.428H278.766v-33.392h248.722zm-315.37 11.224c-3.604-4.42-10.26-5.623-16.021-8.059-7.698-3.246-16.232-7.004-23.91-10.154-2.19-.599-4.38-1.192-6.572-1.79-2.617-1.801-5.17-7.785-6.572-10.761-1.393-.197-2.781-.4-4.181-.59.215-4.6 3.061-4.857 4.181-8.373.99-3.101.104-7.125 1.668-9.994 1.086-1.995 3.534-2.008 4.756-3.719 1.114-1.55 1.852-4.257 2.192-6.152.64-3.473 1.188-8.227-.461-11.664-.952-1.979-1.544-2.172-1.81-4.57-.32-2.909.858-12.4.907-14.451.118-5.322-.005-10.15-1.293-15.332 0 0-1.565-4.692-4.02-6.115l-4.892-.841-3.019-2.794c-12.18-7.496-25.227-2.244-32.22.592-10.078 3.267-16.445 17.516-11.996 38.59.757 3.601-1.974 5.213-1.791 7.176.388 4.29.471 14.616 4.528 17.164.38.233 3.257.96 3.24.761l1.191 12.545c1.02 2.784 3.448 3.083 4.15 7.011l-3.11.756c-1.395 2.976-3.957 8.96-6.57 10.761-2.195.598-4.386 1.191-6.575 1.79-7.676 3.15-16.21 6.908-23.896 10.154-5.208 2.191-11.152 3.354-14.918 6.799V64.562H212.12zm66.648-108.048h248.719v33.384H278.768zM0 .003V363.36h125.196v-43.404H88.472v-33.384h93.477v33.384h-36.721v43.404h292.119v-43.404h-36.724v-33.384h93.48v33.384h-36.724v43.404H584.3V.003H0"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-video',
    name: 'Video',
    tags: ['camera', 'movie'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 572.333 350.147"
        height="350.147"
        width="572.333"
      >
        <path
          d="M345.688 20.905H27.263C12.207 20.905 0 33.113 0 48.168V301.98c0 15.057 12.207 27.263 27.263 27.263h318.425c15.057 0 27.265-12.206 27.265-27.263V48.168c0-15.055-12.208-27.263-27.265-27.263zm60.648 86.282v135.769l165.992 107.19V.002L406.336 107.187"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-voice',
    name: 'Voice',
    tags: ['microphone'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 348.96 557"
        height="557"
        width="348.96"
      >
        <path
          d="M302.215 209.812v62.624c-.016 35.35-14.264 67.132-37.41 90.324-23.192 23.152-54.977 37.401-90.325 37.415-35.348-.014-67.138-14.263-90.326-37.415-23.156-23.192-37.399-54.975-37.41-90.324v-62.624H.004L0 272.436c.018 88.441 65.798 161.436 151.11 172.87v64.951H74.543V557h199.865v-46.743h-76.558v-64.952c85.301-11.433 151.09-84.428 151.106-172.869v-62.624zM174.48 366.077c51.847 0 93.881-42.029 93.881-93.88V93.887c0-51.848-42.034-93.88-93.881-93.88-51.85 0-93.878 42.032-93.878 93.88v178.31c0 51.851 42.028 93.88 93.878 93.88"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-wand',
    name: 'Wand',
    tags: ['magic'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 579.76 571.973"
        height="571.973"
        width="579.76"
      >
        <path
          d="M558.059 198.896h-67.912c-11.987 0-21.7 9.719-21.7 21.7-.006 11.98 9.713 21.7 21.7 21.7h67.912c11.984 0 21.697-9.72 21.697-21.7 0-11.985-9.713-21.7-21.697-21.7zm-273.6 55.58l90.141-90.144 33.05 33.05-90.142 90.145zm86.926-132.23L0 493.627l78.347 78.347 371.389-371.377zm93.359 174.749c-8.476-8.478-22.217-8.478-30.693 0-8.472 8.473-8.472 22.214 0 30.689l48.02 48.019c8.474 8.474 22.217 8.474 30.689 0 8.479-8.476 8.479-22.211 0-30.687zM252.077 145.709c8.472 8.471 22.218 8.471 30.691 0 8.47-8.474 8.47-22.214 0-30.689l-48.023-48.024c-8.473-8.47-22.216-8.47-30.688 0-8.478 8.475-8.478 22.215 0 30.69zm214.755-3.402l48.02-48.023c8.475-8.476 8.47-22.216 0-30.687-8.477-8.474-22.216-8.474-30.692 0l-48.017 48.019c-8.475 8.475-8.478 22.216 0 30.69 8.472 8.475 22.214 8.473 30.689 0zm-107.67-30.992c11.99 0 21.703-9.715 21.703-21.702V21.705C380.868 9.72 371.152.004 359.163.004c-11.978 0-21.695 9.716-21.698 21.701v67.908c0 11.987 9.72 21.706 21.698 21.702"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-wifi',
    name: 'Wifi',
    tags: ['signal'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 591.64 419.893"
        height="419.893"
        width="591.64"
      >
        <path
          d="M295.823 119.147c-79.006 0-153.287 30.765-209.151 86.628-.83.83-1.597 1.705-2.425 2.545l42.634 42.63c42.792-44.08 102.65-71.515 168.934-71.515 66.293 0 126.145 27.434 168.948 71.516l42.622-42.626c-.822-.845-1.593-1.72-2.425-2.55-55.864-55.863-130.136-86.628-209.137-86.628zm293.393 2.38c-162.041-162.043-424.757-162.032-586.8 0-.833.833-1.593 1.712-2.416 2.542l40.883 40.884C105.69 98.865 195.94 57.815 295.823 57.815c99.874 0 190.122 41.05 254.937 107.138l40.88-40.884c-.828-.83-1.588-1.709-2.424-2.542zm-293.401 236.99c-16.816 0-31.763 7.548-42.107 19.262l42.115 42.114 42.112-42.114c-10.351-11.714-25.296-19.262-42.12-19.262zm-125.45-64.074l39.838 39.83c21.456-22.79 51.836-37.093 85.612-37.093 33.781 0 64.158 14.303 85.628 37.094l39.83-39.831c-31.704-33.015-76.174-53.674-125.458-53.674-49.276 0-93.736 20.659-125.45 53.674"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-windows',
    name: 'Windows',
    tags: ['computer', 'operating system'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 527.68 464.16"
        height="464.16"
        width="527.68"
      >
        <path
          d="M527.568 64.81c-.13-.086-.237-.195-.345-.302-68.894 27.97-136.771 30.897-200.726-11.604-2.928 10.09-5.618 17.719-7.324 23.637-5.652 19.555-11.3 39.11-16.952 58.663-8.664 30.033-17.338 60.067-26.013 90.088 62.517 40.417 133.473 42.576 201.243 12.123l50.224-172.508-.107-.096m-157.21 228.833c-45.795 0-76.962-16.139-103.669-33.901-.129.15-.334.281-.485.39l-49.479 171.254c62.723 41.569 133.732 41.18 201.944 12.38l47.979-167.386-.43.11c-36.171 12.098-67.88 17.153-95.86 17.153m-199.33-120.347c30.745 3.78 55.16 16.788 75.07 29.298C262.574 145.727 278.888 88.815 295.502 32 271.777 16.908 247.536 3.825 219.123.995c-37.391-4.463-76.346 6.752-110.55 20.742-16.67 56.998-32.993 114.104-49.48 171.156 35.306-13.849 73.723-24.285 111.935-19.596m65.11 66.063c-25.225-15.461-49.36-28.5-79.64-30.877-37.003-2.918-73.907 8.21-107.797 22.04L0 400.92c65.284-24.932 125.492-27.808 185.903 10.503L236.16 239.37s-.012-.011-.021-.011"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-wrench',
    name: 'Wrench',
    tags: ['tool'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 558.587 558.587"
        height="558.587"
        width="558.587"
      >
        <path
          d="M488.033 153.137l-65.13-17.452-17.458-65.134 66.486-66.486c-39.239-10.593-82.895-.518-113.696 30.283-30.987 30.983-40.996 74.972-30.092 114.392L148.748 328.137c-39.421-10.901-83.407-.89-114.396 30.092-30.8 30.802-40.874 74.458-30.28 113.7l66.488-66.482 65.133 17.45 17.452 65.135-66.485 66.485c39.24 10.588 82.896.515 113.696-30.287 32.343-32.338 41.83-78.853 28.54-119.543l175.801-175.799c40.694 13.296 87.203 3.804 119.539-28.539 30.803-30.8 40.876-74.457 30.284-113.697l-66.487 66.485"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-wrong',
    name: 'Wrong',
    tags: ['incorrect'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 446.96 446.96"
        height="446.96"
        width="446.96"
      >
        <path
          d="M446.961 377.997L292.444 223.481 446.956 68.967 377.992 0 223.477 154.516 68.967.006 0 68.967 154.513 223.48 0 377.997l68.968 68.963 154.515-154.516 154.512 154.51 68.966-68.957"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-x-axis-rotation',
    name: 'X axis rotation',
    tags: ['geometry'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 460.813 565.053"
        height="565.053"
        width="460.813"
      >
        <path
          d="M460.813 269.97L362.5 150.443l-98.719 119.192 62.955.104c.119 4.239.201 8.488.201 12.785.082 63.691-13.805 121.09-34.114 159.702-10.059 19.33-21.638 33.776-32.434 42.448-10.965 8.747-20.106 11.826-28.953 11.888-6.187-.03-12.213-1.52-19.17-5.266-10.347-5.545-22.382-16.842-33.446-33.984-8.299-12.764-16.012-28.616-22.477-46.813l-49.112 59.295c8.852 17.656 19.143 33.566 30.941 47.358 12.008 13.95 25.69 25.769 41.372 34.315 15.624 8.532 33.437 13.613 51.892 13.585h.224c26.885 0 51.799-10.805 71.813-27.144 30.287-24.766 52.24-61.422 67.832-105.174 15.44-43.808 24.079-95.148 24.107-150.21-.003-4.254-.137-8.452-.236-12.666zm-317.589 91.313c-.047-.254-.085-.516-.136-.767l53.943-65.13-60.883-.105c-.12-4.224-.207-8.466-.204-12.756-.096-63.694 13.797-121.09 34.107-159.713 10.057-19.325 21.636-33.781 32.43-42.45 10.966-8.75 20.104-11.829 28.955-11.89 10.648.045 22.397 4.725 36.199 18.479 13.524 13.574 27.196 35.758 37.61 64.046.586 1.586 1.155 3.211 1.724 4.828l49.186-59.382C345.176 74.28 332.03 54.765 316.33 38.8 293.977 15.981 264.532-.052 231.436-.003c-26.97-.062-51.97 10.754-72.044 27.138-30.283 24.758-52.245 61.428-67.828 105.166-15.44 43.82-24.081 95.17-24.107 150.224 0 4.24.074 8.448.176 12.64L0 295.053l98.307 119.528 44.149-53.298h.768"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-y-axis-rotation',
    name: 'Y axis rotation',
    tags: ['geometry'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 565.053 460.813"
        height="460.813"
        width="565.053"
      >
        <path
          d="M269.972.004L150.445 98.311l119.195 98.721.105-62.95a431.87 431.87 0 0 1 12.787-.203c63.692-.083 121.087 13.802 159.699 34.11 19.333 10.059 33.781 21.64 42.453 32.435 8.739 10.968 11.823 20.107 11.887 28.953-.034 6.188-1.523 12.214-5.268 19.171-5.547 10.352-16.846 22.38-33.984 33.447-12.766 8.301-28.618 16.006-46.815 22.477l59.295 49.11c17.656-8.85 33.562-19.14 47.358-30.938 13.954-12.007 25.763-25.687 34.315-41.373 8.53-15.624 13.61-33.436 13.587-51.894v-.224c0-26.882-10.806-51.797-27.148-71.812-24.764-30.288-61.42-52.241-105.17-67.829-43.809-15.443-95.149-24.084-150.209-24.107-4.257 0-8.456.132-12.67.235zm91.31 317.585c-.247.048-.51.086-.762.135l-65.128-53.941-.104 60.884c-4.224.121-8.47.206-12.756.204-63.7.098-121.093-13.796-159.713-34.104-19.328-10.06-33.782-21.638-42.455-32.432-8.745-10.967-11.828-20.106-11.886-28.958.045-10.645 4.728-22.397 18.478-36.19 13.574-13.53 35.758-27.202 64.048-37.618 1.585-.588 3.208-1.156 4.828-1.724L96.447 104.66c-22.16 10.977-41.676 24.12-57.639 39.82C15.983 166.837-.044 196.28 0 229.377c-.06 26.974 10.754 51.974 27.136 72.046 24.76 30.28 61.432 52.242 105.17 67.829 43.82 15.44 95.166 24.08 150.226 24.104 4.24 0 8.445-.07 12.639-.174l-.118 67.631 119.53-98.309-53.3-44.145v-.77"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-z-axis-rotation',
    name: 'Z axis rotation',
    tags: ['geometry'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 495.827 495.827"
        height="495.827"
        width="495.827"
      >
        <path
          d="M372.407 377.127c-34.338 33.182-79.196 50.174-124.6 50.21-40.516-.024-80.978-13.534-114.586-41.445C90.48 350.34 68.532 299.41 68.486 247.8c.007-8.547.648-17.083 1.863-25.56L.34 235.379c-.205 4.14-.34 8.28-.34 12.421-.042 71.004 30.531 141.795 89.44 190.757 46.203 38.423 102.587 57.294 158.367 57.27h.181c64.797 0 129.355-25.588 177.337-74.862l46.004 38.115.286-154.765-152.01 29.072zm34.001-319.834l.003-.005C360.19 18.832 303.808-.037 248.036-.004 183.661-.04 119.527 25.166 71.608 73.772L23.463 33.608l-.812 154.759 152.109-28.548-50.374-42.02c34.22-32.59 78.671-49.278 123.65-49.314 40.507.036 80.964 13.522 114.587 41.46 42.746 35.548 64.672 86.467 64.728 138.088a182.023 182.023 0 0 1-1.404 22.338l69.694-13.326c.11-3.006.187-6.01.187-9.012.05-71.004-30.51-141.776-89.42-190.74"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-zoom-in',
    name: 'Zoom in',
    tags: ['enlarge'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 594.573 594.107"
        height="594.107"
        width="594.573"
      >
        <path
          d="M275.175 111.893h-72.292v82.024H120.86v72.296h82.023v82.026h72.292v-82.026H357.2v-72.296h-82.026zm84.185 248.29c-33.11 32.889-77.041 51.001-123.693 51.001l-1.147-.005c-96.788-.619-175.034-79.872-174.423-176.666.301-46.686 18.708-90.517 51.833-123.418 33.111-32.89 77.031-51.003 123.669-51.003h1.177c46.885.297 90.85 18.83 123.795 52.196 32.94 33.37 50.92 77.57 50.617 124.47-.297 46.686-18.703 90.52-51.828 123.425zm227.092 140.512l-3.587-3.588.007-.008L439.519 353.74c19.918-34.313 31.489-74.089 31.762-116.605C472.117 106.988 367.292.815 237.151-.001c-.526-.003-1.031-.003-1.556-.003C106.179.004.839 104.515.005 234.128c-.823 130.144 104 236.308 234.131 237.143.513.006 1.016.006 1.53.006 43.26 0 83.795-11.722 118.671-32.104L497.564 582.42l.013-.012 3.586 3.578c10.828 10.834 28.385 10.824 39.216 0l46.073-46.072c10.824-10.824 10.828-28.392 0-39.218"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-zoom-out',
    name: 'Zoom out',
    tags: [],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 594.573 594.107"
        height="594.107"
        width="594.573"
      >
        <path
          d="M120.86 270.39h236.339v-72.298h-236.34zm238.501 89.79c-33.112 32.89-77.037 51.003-123.693 51.003h-1.148c-96.788-.62-175.036-79.876-174.423-176.672.62-96.17 79.348-174.412 175.504-174.423h1.171c46.892.297 90.859 18.836 123.799 52.201 32.941 33.37 50.917 77.57 50.617 124.468-.297 46.694-18.701 90.527-51.827 123.423zm227.092 140.515l-3.589-3.583.008-.008-143.35-143.361c19.914-34.308 31.486-74.087 31.757-116.599C472.12 106.987 367.293.817 237.15.003c-.524-.006-1.032-.006-1.556-.006C106.18.003.839 104.52.005 234.128c-.823 130.145 104 236.316 234.131 237.145h1.532c43.263 0 83.796-11.716 118.668-32.093l143.228 143.237.013-.012 3.583 3.582c10.83 10.83 28.39 10.822 39.219 0l46.074-46.07c10.823-10.824 10.83-28.389 0-39.222"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-chat-bubble',
    name: 'Chat Bubble',
    tags: ['chat', 'message', 'talk', 'text', 'bubble'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
      >
        <path d="M8,14.7888559 L14.0002596,14.7888559 C15.6562794,14.7888559 17.0001113,13.4929839 17.0001113,11.8951437 L17.0001113,9 L17.8172444,9 C19.0226744,9 20,9.94358781 20,11.1072996 L20,15.0493831 C20,16.2131485 19.0234904,17.1566827 17.8179863,17.1566827 L17.8179863,18.4728279 C17.8179863,18.8984927 17.3217571,19.1480155 16.9602764,18.9040934 L14.3734237,17.1567006 L10.1805672,17.1567006 C8.97658375,17.1567006 8,16.2138106 8,15.052085 L8,14.7888559 Z M4.07437444,13.1736912 C2.92840862,13.1729984 2,12.2396898 2,11.0873715 L2,5.08631976 C2,3.93474646 2.92971326,3 4.07560856,3 L13.9243914,3 C15.0710448,3 16,3.93400148 16,5.08631976 L16,11.0873715 C16,12.2389448 15.0716619,13.1736912 13.9263308,13.1736912 L7.84389679,13.1736912 L4.8536312,14.9280659 C4.50791976,15.131075 4.07403947,14.8802572 4.07403947,14.4776854 L4.07437444,13.1736912 Z M9.00044196,10 C9.55200979,10 10,9.55289371 10,9.00044196 C10,8.44799021 9.55200979,8 9.00044196,8 C8.44799021,8 8,8.44799021 8,9.00044196 C8,9.55289371 8.44799021,10 9.00044196,10 L9.00044196,10 Z M11.999558,10 C12.5520098,10 13,9.55289371 13,9.00044196 C13,8.44799021 12.5520098,8 11.999558,8 C11.4479902,8 11,8.44799021 11,9.00044196 C11,9.55289371 11.4479902,10 11.999558,10 L11.999558,10 Z M6,10 C6.55269602,10 7,9.55289371 7,9.00044196 C7,8.44799021 6.55269602,8 6,8 C5.44730398,8 5,8.44799021 5,9.00044196 C5,9.55289371 5.44730398,10 6,10 L6,10 Z" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-road',
    name: 'Road',
    tags: ['road', 'miles', 'drive'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="15"
        viewBox="0 0 18 15"
      >
        <path d="M2.85380492,1.7416009 C2.98593085,1.3459965 3.111106,1.0330734 3.2293126,0.80204044 C3.3483025,0.57100747 3.4765654,0.39947341 3.6148687,0.28743824 C3.7531759,0.1754011 3.9084862,0.10277209 4.0800203,0.06953934 C4.2515524,0.03631451 4.4624906,0.01313407 4.7128291,0 L7.0077302,0 L4.7128291,14.4001978 L1.68625767,14.4001978 C0.86878074,14.4001978 0.35109283,14.1135429 0.13319393,13.5394418 C-0.08470497,12.9661319 -0.03524651,12.1517407 0.28154558,11.096189 C0.3874014,10.7531209 0.51257855,10.3212 0.65705327,9.8004264 C0.80231525,9.2796527 0.95684228,8.7194769 1.12220492,8.1191077 C1.28678228,7.5187385 1.45213898,6.8990637 1.61671041,6.2600835 C1.78128778,5.6203121 1.94276756,5.0106857 2.10116756,4.4304132 C2.2595636,3.8501407 2.40095657,3.3262813 2.5261258,2.858044 C2.65129503,2.3898066 2.76024448,2.0173846 2.85218294,1.740778 L2.85380492,1.7416009 Z M9.6386181,2.4339086 L8.1945038,2.4339086 L8.3134937,0.02091956 L9.5003069,0.02091956 L9.6386181,2.4339086 Z M9.9152247,8.447491 L7.9170269,8.447491 L8.1349258,3.6406998 L9.6972467,3.6406998 L9.9152247,8.447491 Z M9.9546309,9.6536295 L10.1725298,14.4604207 L7.6404638,14.4604207 L7.8583627,9.6536295 L9.9554616,9.6536295 L9.9546309,9.6536295 Z M17.6890924,11.3349481 C17.7810388,11.6246888 17.8536698,11.9484514 17.9069913,12.3038624 C17.9595335,12.6600646 17.9595335,12.9930844 17.9069913,13.3029218 C17.8544511,13.6127591 17.7323695,13.8731459 17.5407407,14.0840822 C17.3498933,14.2950185 17.062455,14.4008822 16.6799847,14.4008822 L13.0801825,14.4008822 L10.7660946,0.0006844 L12.6251188,0.0006844 C13.2841957,0.0006844 13.8382001,0.1459444 14.2863407,0.43569099 C14.7344814,0.72543758 15.0775495,1.2469965 15.3147539,1.9980119 C15.3935662,2.2352163 15.4924673,2.6045525 15.6114572,3.1060207 L16.0464638,4.807436 C16.2048599,5.4402448 16.3663495,6.100113 16.530921,6.785458 C16.6954983,7.4708031 16.8508067,8.1175371 16.9960726,8.7240778 L17.4117737,10.3458976 C17.5307636,10.8203064 17.62271,11.1502404 17.6883803,11.3349086 L17.6890924,11.3349481 Z" />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-truck',
    name: 'Semi Truck',
    tags: ['semi', 'truck', 'haul', 'tow'],
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <path
          d="M37.0018196,16 C35.3432508,16 34,17.348301 34,19.0027287 C34,20.6589755 35.3432508,22 37.0018196,22 C38.6585688,22 40,20.6589755 40,19.0027287 C40,17.3501202 38.6585688,16 37.0018196,16 Z M42.5522702,12.5468477 C41.5276623,11.974532 34.2603274,10.6181938 34.2603274,10.6181938 L33.4353854,7.44953061 L33.9803459,6.93826049 C33.9803459,6.93826049 33.254353,5.21564816 32.3398265,5.02484362 C31.4290745,4.84361605 29.9733142,1.95346285 24.4583002,0.974826796 L18.9527941,0 C18.9527941,0 18.4022435,2.93400352 18.3537007,6.70526126 C18.3070422,10.4767631 18.3537007,13.8744699 18.3537007,13.8744699 L9.75932052,13.9870236 L9.63427487,13.4814673 L3.27544644,13.8286661 L3.27544644,14.0709394 L0.477781693,14.1110005 L0.0223961896,14.6527935 L0,14.654701 L0.00373244291,14.6680549 L0,14.6718705 L0.00373244291,14.6756856 L0.712955144,18.817271 L1.15527814,18.817271 C1.36617676,16.9000449 2.95069513,15.4120434 4.87114831,15.4120434 C6.93345555,15.4120434 8.60756321,17.1251327 8.60756321,19.2331144 C8.60756321,19.3265925 8.60383028,19.4200657 8.60009783,19.5135438 L9.39517834,19.5135438 C9.39517834,19.4200657 9.38584673,19.3265925 9.38584673,19.2331144 C9.38584673,17.1232281 11.0562277,15.4120434 13.1203983,15.4120434 C15.1789788,15.4120434 16.8549498,17.1251327 16.8549498,19.2331144 C16.8549498,19.3265925 16.8512169,19.4200657 16.8456177,19.5135438 L17.8515921,19.5135438 C18.079285,19.8073251 18.4488222,20 18.8687467,20 L23.6575766,20 C24.0775058,20 24.4432925,19.8073251 24.6747311,19.5135438 L26.3731103,19.5135438 L26.3731103,19.7672644 L31.5221893,19.7672644 L31.5221893,19.5135438 L33.1085758,19.5135438 C33.1011105,19.4200657 33.0955114,19.3265925 33.0955114,19.2331144 C33.0955114,17.1232281 34.7658922,15.4120434 36.8319263,15.4120434 C38.8923701,15.4120434 40.5664777,17.1251327 40.5664777,19.2331144 C40.5664777,19.3265925 40.5590124,19.4200657 40.5496808,19.5135438 L42.7277073,19.5135438 L42.6194605,18.3918166 L42.9143441,17.9072651 C42.9162108,17.9091726 43.261483,12.9513297 42.5522746,12.5464745 L42.5522702,12.5468477 Z M13.9990893,16 C12.33901,16 11,17.348301 11,19.0027287 C11,20.6589755 12.33901,22 13.9990893,22 C15.6555259,22 17,20.6589755 17,19.0027287 C17,17.3501202 15.6555259,16 13.9990893,16 Z M4.99635845,16 C3.34042459,16 2,17.348301 2,19.0027287 C2,20.6589755 3.33860373,22 4.99635845,22 C6.65229233,22 8,20.6589755 8,19.0027287 C8,17.3501202 6.65229233,16 4.99635845,16 L4.99635845,16 Z"
          transform="translate(-12 6)"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-cash-bills',
    name: 'Bills',
    tags: ['cash', 'bills', 'money'],
    svg: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 13.0131C21.0625 13.0131 22.0625 13.3264 23 13.953C23.875 14.5796 24.625 15.4569 25.1875 16.5222C25.6875 17.6501 26 18.7781 26 20.0313C26 21.2846 25.6875 22.4752 25.1875 23.5405C24.625 24.6684 23.875 25.483 23 26.1097C22.0625 26.7363 21.0625 27.0496 20 27.0496C18.875 27.0496 17.875 26.7363 17 26.1097C16.0625 25.483 15.3125 24.6684 14.8125 23.5405C14.25 22.4752 14 21.2846 14 20.0313C14 18.7781 14.25 17.6501 14.8125 16.5222C15.3125 15.4569 16.0625 14.5796 17 13.953C17.875 13.3264 18.875 13.0131 20 13.0131ZM23 23.2898V22.7885C23 22.2872 22.75 22.0366 22.25 22.0366H21.3125V16.7728C21.3125 16.2715 21.0625 16.0209 20.5625 16.0209H19.8125C19.4375 16.0209 19.1875 16.1462 18.9375 16.3969L17.5625 17.6501C17.1875 18.0261 17.125 18.3394 17.5 18.6527L17.875 19.0287C18 19.2167 18.1875 19.342 18.375 19.342C18.5 19.342 18.6875 19.2794 18.875 19.0914L19.0625 18.9034L19 19.53V22.0366H18.0625C17.5625 22.0366 17.375 22.2872 17.375 22.7885V23.2898C17.375 23.7911 17.5625 24.0418 18.0625 24.0418H22.25C22.75 24.0418 23 23.7911 23 23.2898ZM38.5 8C38.875 8 39.25 8.18799 39.5625 8.43864C39.8125 8.75196 40 9.12794 40 9.50392V30.4961C40 30.9347 39.8125 31.3107 39.5625 31.5614C39.25 31.8747 38.875 32 38.5 32H1.5C1.0625 32 0.6875 31.8747 0.4375 31.5614C0.125 31.3107 0 30.9347 0 30.4961V9.50392C0 9.12794 0.125 8.75196 0.4375 8.43864C0.6875 8.18799 1.0625 8 1.5 8H38.5ZM32 29.0548C32 27.6762 32.4375 26.5483 33.4375 25.5457C34.4375 24.5431 35.625 24.0418 37 24.0418V16.0209C35.625 16.0209 34.4375 15.5822 33.4375 14.5796C32.4375 13.577 32 12.3864 32 11.0078H8C8 12.3864 7.5 13.577 6.5 14.5796C5.5 15.5822 4.375 16.0209 3 16.0209V24.0418C4.375 24.0418 5.5 24.5431 6.5 25.5457C7.5 26.5483 8 27.6762 8 29.0548H32Z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-user-round',
    name: 'User round',
    tags: ['person', 'man', 'woman'],
    svg: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 0C17.7344 0 15.625 0.625 13.75 1.71875C11.7969 2.8125 10.2344 4.375 9.14062 6.25C8.04687 8.20312 7.5 10.3125 7.5 12.5C7.5 14.7656 8.04687 16.875 9.14062 18.75C10.2344 20.7031 11.7969 22.2656 13.75 23.3594C15.625 24.4531 17.7344 25 20 25C22.1875 25 24.2969 24.4531 26.25 23.3594C28.125 22.2656 29.6875 20.7031 30.7812 18.75C31.875 16.875 32.5 14.7656 32.5 12.5C32.5 10.3125 31.875 8.20312 30.7812 6.25C29.6875 4.375 28.125 2.8125 26.25 1.71875C24.2969 0.625 22.1875 0 20 0ZM34.2969 26.0937C35.9375 26.5625 37.2656 27.4219 38.3594 28.75C39.4531 30.1562 40 31.6406 40 33.3594V36.25C40 37.3437 39.6094 38.2031 38.9062 38.9062C38.125 39.6875 37.2656 40 36.25 40H3.75C2.65625 40 1.79687 39.6875 1.09375 38.9062C0.3125 38.2031 0 37.3437 0 36.25V33.3594C0 31.6406 0.46875 30.1562 1.5625 28.75C2.65625 27.4219 3.98437 26.5625 5.70312 26.0937L11.25 24.6875C13.6719 26.4844 16.4062 27.4219 19.5312 27.5C22.8906 27.6562 25.9375 26.7187 28.75 24.6875L34.2969 26.0937Z"
          fill="#231f20"
        />
      </svg>
    ),
  },
  {
    icon: 'bbk-esi-briefcase',
    name: 'Briefcase',
    tags: ['luggage', 'briefcase', 'business'],
    svg: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#231f20"
          d="M25 21.4286V22.9464C25 23.25 24.8437 23.4777 24.6875 23.6295C24.5312 23.7813 24.2969 23.8571 24.0625 23.8571H15.9375C15.625 23.8571 15.3906 23.7813 15.2344 23.6295C15.0781 23.4777 15 23.25 15 22.9464V21.4286H0V32.3571C0 33.4196 0.3125 34.2545 1.09375 34.9375C1.79687 35.6964 2.65625 36 3.75 36H36.25C37.2656 36 38.125 35.6964 38.9062 34.9375C39.6094 34.2545 40 33.4196 40 32.3571V21.4286H25ZM40 12.9286C40 11.942 39.6094 11.1071 38.9062 10.3482C38.125 9.66518 37.2656 9.28571 36.25 9.28571H30V5.64286C30 4.65625 29.6094 3.82143 28.9062 3.0625C28.125 2.37946 27.2656 2 26.25 2H13.75C12.6562 2 11.7969 2.37946 11.0937 3.0625C10.3125 3.82143 10 4.65625 10 5.64286V9.28571H3.75C2.65625 9.28571 1.79687 9.66518 1.09375 10.3482C0.3125 11.1071 0 11.942 0 12.9286V19H40V12.9286ZM25 6.85714V9.28571H15V6.85714H25Z"
        />
      </svg>
    ),
  },
  // {
  //   icon: 'bbk-esi-',
  //   name: '',
  //   tags: [''],
  //   svg: '',
  // },
] as const;

// KV map of the icons
export const ExitSurveyIcons = keyBy(ExitSurveyIconsCol, (x) => x.icon);
